var map = {
	"./ID00002_stpaulconvent2025.jpg": 47743,
	"./ID00003_2_4x3_6ca3036c-41b7-40c3-8940-d11b99c003ce.jpg": 3754,
	"./ID00004_KINGSWOODPIANO_1_4x3_c4eaf7d6-e994-4601-8d09-ac147d9bf851.jpg": 33823,
	"./ID00004_KINGSWOODPIANO_2_4x3_882148dc-813c-4572-8aa6-70e343b79652.jpg": 65666,
	"./ID00004_KINGSWOODPIANO_3_4x3_025354bc-b75d-43f3-9526-47c3ed9eec83.jpg": 65688,
	"./ID00004_KINGSWOODPIANO_4_4x3_4a00e2d9-5370-411f-aff4-201aeafcd3cd.jpg": 50818,
	"./ID00005_1_4x3_4d764483-a9c7-4afe-a5ff-71d828cb58de.jpg": 66484,
	"./ID00006_LEAFYWONDERLANDPLAYGROUP_1_4x3_a20f0465-ccd2-4650-b64e-f766a2e42a6b.jpg": 33255,
	"./ID00006_LEAFYWONDERLANDPLAYGROUP_2_4x3_06418d99-6663-4014-a505-2f184204013b.jpg": 65035,
	"./ID00007_1_4x3_802b8b3b-0288-456f-8dc0-4be245f17bb4.jpg": 70628,
	"./ID00007_2_4x3_2b5fd4b8-943a-4aab-9402-7d40eae8f45c.jpg": 55939,
	"./ID00008_LeaderEducation_1_4x3_1a2f3dcd-16f5-4613-9942-60a46633f05b.jpg": 89900,
	"./ID00008_LeaderEducation_2_4x3_c419a0d8-1e3c-4be8-986a-383b97650f94.jpg": 47774,
	"./ID00009_NGAISMUSIC_1_4x3_f9901f81-dd01-47b4-a51f-bba8b78e07b4.jpg": 17084,
	"./ID00009_NGAISMUSIC_2_4x3_1cf7338d-1a05-4484-b2cc-6b4ed0621260.jpg": 38510,
	"./ID00009_NGAISMUSIC_3_4x3_6a987fad-0c6f-4733-83a4-3834a97d7e15.jpg": 4826,
	"./ID00009_NGAISMUSIC_4_4x3_199fd85e-b63d-4c3f-99d9-71cd5785d386.jpg": 92088,
	"./ID00010_SIUGallery_1_4x3_06eabf90-d7d2-4136-ad19-bd1ddc37e0f9.jpg": 71460,
	"./ID00010_SIUGallery_2_4x3_59242b36-aa30-4861-9543-4a5beecba8a1.jpg": 25342,
	"./ID00010_SIUGallery_3_4x3_56049261-2c3d-471d-9b30-894d3b0f1ad2.jpg": 50092,
	"./ID00010_SIUGallery_4_4x3_813f8c63-b5f6-4618-bd1c-329b4ab98bfd.jpg": 64520,
	"./ID00011_1_4x3_2383de4e-f0d4-4ade-9d9a-6f4c135c73c2.jpg": 50511,
	"./ID00011_2_4x3_1c70cffc-d7b6-417b-a415-616d73330dd6.jpg": 48575,
	"./ID00012_2_4x3_79359595-d005-415b-ac90-e81ae53b0de2.jpg": 71709,
	"./ID00012_4_4x3_e85e4411-3353-4bc3-b5ce-5318c0f06457.jpg": 79522,
	"./ID00012_5_4x3_9d599225-fcaf-46d7-9952-40c99035817e.jpg": 82150,
	"./ID00012_6_4x3_e9c7d203-92fc-44eb-a758-36b61fa99396.jpg": 8990,
	"./ID00013_ArtistsWonderland__1_4x3_ba6003c6-fe4f-4218-b3fc-db7ecce43119.jpg": 73092,
	"./ID00013_ArtistsWonderland__2_4x3_c64caf50-f8b8-4217-9956-576b93e03277.jpg": 14372,
	"./ID00013_ArtistsWonderland__3_4x3_3c5a3f92-4231-4949-9010-02885ec15e7f.jpg": 45597,
	"./ID00013_ArtistsWonderland__4_4x3_40791991-9434-49ea-8ad2-30fb7eeb3d38.jpg": 41701,
	"./ID00014_GUTSEducation__1_4x3_9514956e-b145-413f-8bd5-5fb3cf32848a.jpg": 81736,
	"./ID00014_GUTSEducation__2_4x3_b1c37e33-51e5-4803-936c-871132265935.jpg": 88306,
	"./ID00015_VistaLanguagesEducation__1_4x3_c3bad05d-f52e-4c2b-8a46-8d8f9c5bf710.jpg": 37633,
	"./ID00015_VistaLanguagesEducation__2_4x3_dee788a3-27f0-4cd6-9aa0-74556bc733f9.jpg": 79335,
	"./ID00015_VistaLanguagesEducation__3_4x3_62111bde-919b-4100-98c1-a8b8f22e3318.jpg": 54538,
	"./ID00015_VistaLanguagesEducation__4_4x3_a18b4b52-aa1e-4e04-87e6-19af1f94c2d5.jpg": 56492,
	"./ID00016_FaithHopeLoveEducation_1_4x3_b2b414eb-41a1-4705-a3b4-56b4627bbf5c.jpg": 4085,
	"./ID00016_FaithHopeLoveEducation_2_4x3_953a3804-32ba-4fb0-a3c2-6cbcc9d115fd.jpg": 27934,
	"./ID00016_FaithHopeLoveEducation_3_4x3_af5233b7-f953-44ff-9814-d3b9e57ed362.jpg": 46717,
	"./ID00016_FaithHopeLoveEducation_4_4x3_6a5cb1eb-8e68-4ef2-8e0f-4ed1dd4265ee.jpg": 70944,
	"./ID00017_MiuYiEducation_1_4x3_e946de27-7eb7-4b7c-882b-53e463de2a2e.jpg": 56222,
	"./ID00017_MiuYiEducation_2_4x3_8e97ce94-850d-46dc-8b82-eabd16460c24.jpg": 76873,
	"./ID00017_MiuYiEducation_3_4x3_dc4a383d-9461-45fa-b3a1-7f5d569fe172.jpg": 70000,
	"./ID00018_1_4x3_6334ddb0-e6a3-4788-91b4-9a2cf6f056f6.jpg": 14595,
	"./ID00018_2_4x3_a5d106b0-15dd-4922-acd2-0e32644607fd.jpg": 71429,
	"./ID00018_3_4x3_fc99375e-97ad-440c-ab08-6fc19944145d.jpg": 24703,
	"./ID00018_4_4x3_56087af6-be74-4cdc-9b39-6059dd7eca91.jpg": 35880,
	"./ID00019_BRIGHT_MINDS_1_4x3_fefc5bb5-eaa8-4740-bdf8-c8419b6c448a.jpg": 98976,
	"./ID00019_BRIGHT_MINDS_2_4x3_22a394f7-959a-463f-b8d6-98e08c994ac8.jpg": 77798,
	"./ID00019_BRIGHT_MINDS_3_4x3_36e70548-6808-4447-a91c-51ea2c4b9747.jpg": 25722,
	"./ID00020_UPGRADEEDUCATION_1_4x3_b5464d9e-5e10-4fd7-92cb-6462b098c2e6.jpg": 16023,
	"./ID00020_UPGRADEEDUCATION_2_4x3_00cbd06e-e636-44c6-8a64-3fbc94c1ad24.jpg": 58460,
	"./ID00020_UPGRADEEDUCATION_3_4x3_d871dbbd-65ac-43ef-bee4-74ebd596d302.jpg": 91841,
	"./ID00020_UPGRADEEDUCATION_4_4x3_6eda56ac-fbce-4ba3-9ab3-fbc9ab3aa8ec.jpg": 39160,
	"./ID00021_1_4x3_44792790-0d6d-4daf-bf6f-74eec4aade06.jpg": 51639,
	"./ID00021_2_4x3_b72d160b-29d6-44fe-a61d-ca53190bd986.jpg": 53629,
	"./ID00021_3_4x3_e9245076-7a87-4877-ad93-2aa78e9879d3.jpg": 25663,
	"./ID00021_4_4x3_b995ef72-e7d4-4a42-944d-2ec3fcb5b855.jpg": 29964,
	"./ID00022_A__1_4x3_8a6233a0-2526-4930-94b1-d3fccaab4656.jpg": 37716,
	"./ID00022_A__2_4x3_16148528-1137-4bf3-972a-3789437a4eed.jpg": 81973,
	"./ID00022_A__3_4x3_174ec681-2d06-49ff-9109-7f19dcee3a96.jpg": 95549,
	"./ID00023_1_4x3_a1dc9ed8-d44f-406b-8721-a0d2499be308.jpg": 22487,
	"./ID00023_2_4x3_a12fa019-3beb-42e6-b773-940eb529d9bd.jpg": 76944,
	"./ID00023_3_4x3_66965050-8a45-4965-a529-24b2be7a8fd1.jpg": 17319,
	"./ID00023_4_4x3_69271840-315d-46ab-9764-bda051396422.jpg": 98360,
	"./ID00024_1_4x3_b9633a65-236f-4663-85d6-a98cd4598f26.jpg": 19371,
	"./ID00024_2_4x3_ca19afe6-5d6e-4ac2-a291-10af44be53c1.jpg": 16739,
	"./ID00025_SKYMATH_1_4x3_4df00080-81a0-4fdd-a5d0-384ccdec08d0.jpg": 68254,
	"./ID00025_SKYMATH_2_4x3_c6734875-a554-4cae-b7c4-e2bf31e93c8d.jpg": 47058,
	"./ID00026_WiserEducation_1_4x3_e4132892-10bf-4e2b-aa95-48ef6bc255cb.jpg": 9142,
	"./ID00026_WiserEducation_2_4x3_a9c0a014-48ec-4ec1-8508-ea1aed206bcf.jpg": 83563,
	"./ID00026_WiserEducation_3_4x3_e69ab231-f8cb-474e-a000-a7f0ff0798a7.jpg": 85066,
	"./ID00026_WiserEducation_4_4x3_4126b44b-44e5-4552-b560-7bdcc49ad607.jpg": 88016,
	"./ID00027_1_4x3_86df8284-c86a-4909-af02-57186acde59b.jpg": 4300,
	"./ID00027_2_4x3_c2b5c265-fcd5-42c5-8509-b512f4bb3870.jpg": 79448,
	"./ID00028_1_4x3_2a5e185b-5de4-4b9a-a20e-9e6b70ccfc93.jpg": 94597,
	"./ID00028_2_4x3_c6191d03-f6bd-42f6-898b-c775b338a4c4.jpg": 6343,
	"./ID00028_3_4x3_08c8456a-8e33-4ff8-919d-1c83cb972855.jpg": 17177,
	"./ID00028_4_4x3_0cb285cd-6bec-4e98-91d6-7c45f41d2166.jpg": 77845,
	"./ID00028_5_4x3_1f771f26-ac69-4a32-9a99-30c084a1bf4a.jpg": 65852,
	"./ID00029_Dr.Tree__1_4x3_0f4733ea-60bb-412f-aa14-2c3a48c39224.jpg": 42798,
	"./ID00029_Dr.Tree__2_4x3_9f107622-c55d-4388-a156-08e9d1c4fd8d.jpg": 68608,
	"./ID00029_Dr.Tree__3_4x3_debca498-0e59-4846-9818-617f6e33741b.jpg": 88659,
	"./ID00029_Dr.Tree__4_4x3_5ad32429-97d1-46fb-a524-00e1f09bfa74.jpg": 90750,
	"./ID00030_1_4x3_9418b89e-7292-4ed7-a5a4-4c97baffeff4.jpg": 91311,
	"./ID00030_2_4x3_d8aa8265-020f-4694-a682-74c6ce71a054.jpg": 10391,
	"./ID00030_3_4x3_e0610f02-5f58-45da-8530-09183c70dc8c.jpg": 89662,
	"./ID00030_4_4x3_3fc50287-bae3-4a72-bb34-8532a83b6b0a.jpg": 97937,
	"./ID00031_1_4x3_482b5945-1d5e-4806-8933-ad5f1e4657b3.jpg": 12836,
	"./ID00031_2_4x3_ef158c04-c3c0-4458-95c1-0de797f4f597.jpg": 10944,
	"./ID00031_3_4x3_cd66be92-7988-4cf7-9ee8-ed8763905eb4.jpg": 62630,
	"./ID00031_4_4x3_fd9b16d8-fba8-42ae-83f9-f9b2aae8169b.jpg": 15338,
	"./ID00032_CatchyaStudio__CatchyaStudio__1_4x3_9873a0ea-34a3-43bf-a0bd-1d27e24be067.jpg": 43399,
	"./ID00033_SIR__1_4x3_68bd404d-09d7-4f2a-be00-d6430453e143.jpg": 65118,
	"./ID00033_SIR__2_4x3_4dda0fe4-f391-4ca3-bceb-689f87b518b9.jpg": 34248,
	"./ID00033_SIR__3_4x3_0ec3762d-1f8b-42ba-ae00-13c507395e3e.jpg": 85311,
	"./ID00033_SIR__4_4x3_3f265f54-4e45-4573-8ce8-83119f657a82.jpg": 244,
	"./ID00034_LEARN_SIR__1_4x3_7d0d03c6-2f2c-4864-a131-3c0f8b55e8f9.jpg": 24350,
	"./ID00035_MissPansClassroom_1_4x3_0552971b-6427-4290-bd29-60437e9c2b40.jpg": 25631,
	"./ID00035_MissPansClassroom_2_4x3_cd342143-7bfb-4ee3-8e89-a41114a0f257.jpg": 97740,
	"./ID00035_MissPansClassroom_3_4x3_486c6be7-1542-4894-8dc2-17e2e174ee84.jpg": 6109,
	"./ID00035_MissPansClassroom_4_4x3_b568fec8-3403-4b9b-83c2-68b22367acd1.jpg": 6390,
	"./ID00036_Sunkids__Sunkids_1_4x3_3d8b0d23-4b82-4443-974e-8b6e21133cfa.jpg": 1639,
	"./ID00037_AriseStudio_1_4x3_3c091ba2-8b17-485c-86b7-d6df8a055165.jpg": 6912,
	"./ID00037_AriseStudio_2_4x3_ed36fecb-bd1b-4070-911a-85f617756dc9.jpg": 75247,
	"./ID00037_AriseStudio_3_4x3_ccd36c05-0448-453b-994c-a5d46d901e6e.jpg": 40725,
	"./ID00037_AriseStudio_4_4x3_1039e028-a9ff-4c17-8c0f-b81f7885fe5b.jpg": 31915,
	"./ID00038_WingsEducationCentre_1_4x3_5f07d9a3-a421-4735-8dc9-fc8ec6243114.jpg": 20451,
	"./ID00038_WingsEducationCentre_2_4x3_4e4e4cd2-64a0-4d76-b4b4-2e925456467d.jpg": 64578,
	"./ID00039_LittleSmartiesTutorialCentre_1_4x3_5f87802d-153a-492a-b5b4-de084d75e75b.jpg": 76159,
	"./ID00039_LittleSmartiesTutorialCentre_2_4x3_731eb4e0-fe85-4066-a295-6040bda86cea.jpg": 1415,
	"./ID00040_LuminaryWisdomEducation_1_4x3_b6853b71-afc5-4f84-b806-7fab9bbdeb0b.jpg": 28294,
	"./ID00040_LuminaryWisdomEducation_2_4x3_cc5447f0-0691-4722-9962-981356988641.jpg": 39965,
	"./ID00040_LuminaryWisdomEducation_3_4x3_493ead57-cb81-40b0-9705-b219e1df5a5f.jpg": 27253,
	"./ID00040_LuminaryWisdomEducation_4_4x3_320a5bac-5abe-42d6-97c6-505b85a77a28.jpg": 1924,
	"./ID00041_1_4x3_a973c025-23ad-4007-ad36-5277b63eb8e2.jpg": 91012,
	"./ID00041_2_4x3_9ace1b8f-78e8-4f7f-9097-ee693ea18b15.jpg": 6086,
	"./ID00042_1_4x3_ba7db9cc-a91d-4079-a985-ac009e9db978.jpg": 21256,
	"./ID00043_MusicBox_1_4x3_d06c4962-7871-4378-a427-515aa2bcbe05.jpg": 50799,
	"./ID00043_MusicBox_2_4x3_be2b4ba7-3e3c-4535-8075-0019031ad5bc.jpg": 54014,
	"./ID00043_MusicBox_3_4x3_01d64012-cab5-4657-89a4-9fb6e67ec8af.jpg": 38607,
	"./ID00043_MusicBox_4_4x3_fd66134b-8b85-44bc-9bc0-59d180cabc91.jpg": 7817,
	"./ID00044_AESTHETICSTUDIO__1_4x3_c54a1a92-fa1b-44a3-a0c1-20d7af0e39bc.jpg": 41689,
	"./ID00044_AESTHETICSTUDIO__2_4x3_210d1002-cb11-46d5-b9e1-52f9674e7031.jpg": 1799,
	"./ID00044_AESTHETICSTUDIO__3_4x3_efd76565-9a13-43d3-b76f-9c53f78a4e82.jpg": 90754,
	"./ID00044_AESTHETICSTUDIO__4_4x3_24e53931-18c1-4666-8f55-f3de734630bc.jpg": 23552,
	"./ID00045_LittleHopeEducation_1_4x3_222e9ed7-028a-46bd-b35e-fbcbfc31e7b2.jpg": 31872,
	"./ID00045_LittleHopeEducation_2_4x3_f7e20bd2-e2c6-4251-8634-20a71b8cb9ea.jpg": 26143,
	"./ID00046_TheTreeofLifeMusicRoom_1_4x3_c2b30df0-3cbf-432e-869a-3ba05753d9a5.jpg": 51330,
	"./ID00046_TheTreeofLifeMusicRoom_2_4x3_493604c0-89e8-4fb3-9f99-b234b07e4beb.jpg": 74969,
	"./ID00046_TheTreeofLifeMusicRoom_3_4x3_c3344cd7-bf89-44ce-b7d2-626006af28ee.jpg": 54153,
	"./ID00046_TheTreeofLifeMusicRoom_4_4x3_04401ba6-c5b6-4080-a4f2-609d65a9e7dc.jpg": 5374,
	"./ID00047_MUSICLAB_1_4x3_f3ba4570-92f3-4b5f-8bd2-95b5966d16ec.jpg": 56674,
	"./ID00047_MUSICLAB_2_4x3_1549bc0d-ba0f-49a4-a0a2-9557c4a61f5e.jpg": 37233,
	"./ID00047_MUSICLAB_3_4x3_50c5c5dc-4efb-4d33-b269-0f2166b4ec24.jpg": 13823,
	"./ID00047_MUSICLAB_4_4x3_b8a86dbc-39ee-4c13-82fe-34ab3f535961.jpg": 3101,
	"./ID00048_LittleSeedArtsStudio_1_4x3_57b42106-1c33-4ac7-b3c4-448375b4e3d4.jpg": 23891,
	"./ID00049_SoundsFumClass_1_4x3_618aa982-4369-4260-9b21-f61cf8cd48ed.jpg": 12608,
	"./ID00049_SoundsFumClass_2_4x3_3cfac822-3f28-4373-a7eb-1ee788535c5a.jpg": 4392,
	"./ID00049_SoundsFumClass_3_4x3_853e572c-c97f-4192-966d-877ff47a5b2f.jpg": 97793,
	"./ID00049_SoundsFumClass_6_4x3_2a5062e6-52bb-4b21-a0cf-d62933213b3e.jpg": 53593,
	"./ID00050_1_4x3_cc24dd63-49c2-4ae9-a2f9-465ff9bb639d.jpg": 36853,
	"./ID00050_2_4x3_1fdfd9f4-4a29-4118-8d8e-2605bfa14bbe.jpg": 63773,
	"./ID00050_3_4x3_b84d0308-cf44-4f1a-8931-7b75d29455ec.jpg": 77872,
	"./ID00050_4_4x3_6f8ce2ac-61a8-46ee-8284-3f6d946bcb13.jpg": 655,
	"./ID00051_SMARTIESLEARNINGCENTRE_1_4x3_630f4820-33ad-4629-8b56-35da0e056766.jpg": 7772,
	"./ID00051_SMARTIESLEARNINGCENTRE_2_4x3_e70de721-c087-4506-824f-6c39303aa967.jpg": 94678,
	"./ID00051_SMARTIESLEARNINGCENTRE_3_4x3_1aedc92b-d440-479a-8aa2-7dd4fb40c282.jpg": 22944,
	"./ID00051_SMARTIESLEARNINGCENTRE_4_4x3_b672c964-03c5-46d3-944a-12be06e87627.jpg": 21875,
	"./ID00052_1_4x3_4fb62235-e8c5-4358-9eb9-b030c52aa454.jpg": 8611,
	"./ID00052_2_4x3_19f26710-35f3-4a61-89b7-c7af110c772d.jpg": 26989,
	"./ID00052_3_4x3_828f4981-e33a-430d-b628-66bdeffee9e8.jpg": 87221,
	"./ID00052_4_4x3_61efb674-9ab2-447f-a45c-a06ffaae75ac.jpg": 17909,
	"./ID00053_Pianoplace__1_4x3_ef6bd990-48a0-4a35-a075-b6ec6f04c110.jpg": 97231,
	"./ID00053_Pianoplace__2_4x3_f5a28f36-097e-446d-9333-28dbf19b8a14.jpg": 63031,
	"./ID00053_Pianoplace__3_4x3_98515a06-28ce-4973-a3c0-3ca5449dc1fa.jpg": 66351,
	"./ID00053_Pianoplace__4_4x3_30cd045c-5835-4917-a2b9-d16e0e4021b6.jpg": 55591,
	"./ID00054_559005967_1267864558718515_8541073618949188084_n_559005967_1267864558718515_8541073618949188084_n_559005967_1267864558718515_8541073618949188084_n_4x3_c1847810-711_400c0169.jpg": 21436,
	"./ID00055_likwokpo_likwokpo_likwokpo_4x3_67c3bf2d-5a9d-49cf-847d-adc4316af0cb.jpg": 10156,
	"./ID00056_schoolopenday_eventpostertemplateA4portirat_8.jpg": 23962,
	"./ID00057_schoolopenday_eventpostertemplateA4portirat_7.jpg": 81644,
	"./ID00058_HORSE_RIDING_EVENT_NOV_2025_1_4x3_bb52a930-aad3-42c8-84ae-e440b6632878.jpg": 28085,
	"./ID00059_2025-09-26230900_2025-09-26230900_2025-09-26230900_4x3_adf492cc-e65f-45f2-907b-0a132d6d4e46.jpg": 96636,
	"./ID00060_2025-09-26214739.png": 65828,
	"./ID00061_school_openday_event_poster_template_A4_portirat_6.jpg": 38923,
	"./ID00062_GAPSK_GAPSK_GAPSK_4x3_b8b3a3c4-1937-4634-bd20-84c1e39ad1bd.jpg": 31769,
	"./ID00063_2025_11__2025_11__2025_11__4x3_4d8bd10e-e1ae-4ccb-9877-50fc5bd25505.jpg": 31048,
	"./ID00064_2025__2025__2025_4x3_e0494211-2c41-4fc7-aac9-747f3d3d0daf.jpg": 41399,
	"./ID00065_2025-09-25123801.png": 56205,
	"./ID00065_4x3.jpg": 98740,
	"./ID00066_2025__2025__2025_4x3_341529dd-7724-4c71-8b31-1d5685e2ed5c.jpg": 72278,
	"./ID00067_AmazingStar__2_4x3_6d781d67-805c-4208-ba59-5101dd3870a1.jpg": 13948,
	"./ID00068_GreatnessLearningCentre_1_4x3_ae09be9f-cde1-428c-bd82-05d05fe56b61.jpg": 55162,
	"./ID00069_NFEDUCATIONCENTRE_1_4x3_1ff6c56a-ded0-498d-8967-209bd5de4606.jpg": 90064,
	"./ID00069_NFEDUCATIONCENTRE_2_4x3_ddcff337-c5a8-4faf-959e-0425ff58bd3c.jpg": 55236,
	"./ID00069_NFEDUCATIONCENTRE_3_4x3_c4ac4adc-5b7b-4828-8749-5e211b8de7cb.jpg": 92107,
	"./ID00069_NFEDUCATIONCENTRE_4_4x3_94bb5ef0-035a-4789-a552-1d483d4ffece.jpg": 46096,
	"./ID00070_22050923-Hong-Kong-Fire-Services-Department-600x849_1.jpg": 12670,
	"./ID00071_1_4x3_645787f2-c7e0-4812-b054-cf6d14a72211.jpg": 30720,
	"./ID00072_2025_1_4x3_76fbaf5f-1e50-4c7c-a8ec-49dd63b6bead.jpg": 55361,
	"./ID00073_InspireWorkshop__InspireWorkshop_1_4x3_52f84a44-b146-428f-a65f-c8cdcf594aa9.jpg": 12900,
	"./ID00073_InspireWorkshop__InspireWorkshop_2_4x3_9af80d33-df93-4e5f-b464-142a7c6a428f.jpg": 90711,
	"./ID00073_InspireWorkshop__InspireWorkshop_3_4x3_a7ea4537-e26f-48db-b97c-c7f060644c0e.jpg": 68920,
	"./ID00074_12_1.png": 87672,
	"./ID00075_TKD_TKD_1_4x3_4f8bdb5a-0031-4adb-bd5e-ba60d2dd363b.jpg": 81312,
	"./ID00075_TKD_TKD_2_4x3_a827ba90-29b9-44aa-9381-3f986f015d2a.jpg": 26543,
	"./ID00076_01b357_0ad833b38bbe474fa7c183b13006ce2a_mv2_1.png": 55886,
	"./ID00076_01b357_776f688dde7a470da283d9a7f115d9d2_mv2_1.png": 37439,
	"./ID00076_01b357_a9d1d639ecb84621afe344af81ccf09c_mv2_1.png": 57303,
	"./ID00076_01b357_bdba2afe69ad4cc2abb235c1b10cf3e5_mv2_1.png": 59851,
	"./ID00076_01b357_d6ca35ba63df45dd8c19083c7e4a0841_mv2_1.png": 51304,
	"./ID00076_01b357_e8db8e61e292419dbfdc523f34993a4e_mv2_1.png": 7530,
	"./ID00077_1_4x3_dc7aace7-3011-416c-b8c5-865d4320169b.jpg": 28534,
	"./ID00077_2_4x3_58495e2e-6b0e-44e2-9a7c-785c7b1f96cf.jpg": 40031,
	"./ID00077_3_4x3_839bdc3a-d9c9-4edb-a961-5652bfa89b7b.jpg": 73735,
	"./ID00077_4_4x3_bab10a68-0b24-4544-a9e1-b6190311dac1.jpg": 52873,
	"./ID00078_SunshineEducationCentre_HangHau__1_4x3_f8720913-ade6-4a66-9d0c-1db2bb9e5b2e.jpg": 58204,
	"./ID00078_SunshineEducationCentre_HangHau__2_4x3_49996cd8-2d04-4b5d-8ae4-42007061776f.jpg": 90160,
	"./ID00078_SunshineEducationCentre_HangHau__3_4x3_f751ddf4-0467-4f2b-81ff-43ead7e54e03.jpg": 48763,
	"./ID00078_SunshineEducationCentre_HangHau__4_4x3_2156df51-e8ed-4d31-a95e-08a2b85d2649.jpg": 10544,
	"./ID00079_LearningBoatEducationCentre_1_4x3_940834fb-adfd-434a-8bff-5732bbb4d1ae.jpg": 40593,
	"./ID00079_LearningBoatEducationCentre_2_4x3_6ebad507-03d6-4759-8d55-72267071ace5.jpg": 69061,
	"./ID00079_LearningBoatEducationCentre_3_4x3_0742f94b-9f65-45bf-b270-b58587d101f8.jpg": 66187,
	"./ID00079_LearningBoatEducationCentre_4_4x3_77830e09-c0c9-46a0-934f-7dd1a0ba95d2.jpg": 92040,
	"./ID00080_2025-09-24124848.png": 97429,
	"./ID00081_ICAP_1_4x3_1a22a436-1c23-4cab-ace4-327be3782bbf.jpg": 57178,
	"./ID00082_1_4x3_3b09905b-a26d-4322-a588-d29e49d74166.jpg": 43097,
	"./ID00082_2_4x3_9623ffa1-36ab-49d6-860d-1368d9983ab1.jpg": 69401,
	"./ID00082_3_4x3_6aa991fb-3aae-499d-a01d-e525887d13d1.jpg": 20926,
	"./ID00082_4_4x3_10785b1c-6e48-460f-a919-0233d2b2fd78.jpg": 6678,
	"./ID00083_SmileyPlanet__1_4x3_9430adef-7c24-4c9d-a946-65870b0d32cc.jpg": 86347,
	"./ID00083_SmileyPlanet__2_4x3_b16872a5-3b1d-416a-8007-0d0ac76ebecf.jpg": 67550,
	"./ID00083_SmileyPlanet__3_4x3_c09c0655-c74c-4bfc-996c-848fe7adc8db.jpg": 368,
	"./ID00084_KidProEducationCentre_1_4x3_ccf441c9-b5e6-41de-bf32-256130d47639.jpg": 79927,
	"./ID00084_KidProEducationCentre_2_4x3_f7139ce4-e385-4bbd-90e4-b9dcb01a7830.jpg": 75595,
	"./ID00084_KidProEducationCentre_3_4x3_957101ec-1e9f-4560-81c1-3eb5f435a47a.jpg": 36905,
	"./ID00085_1_4x3_4x3_206adefb-c9fe-4629-8264-b8583bbcb464.jpg": 78486,
	"./ID00085_2_4251eab6-cf28-446b-a101-ca368a4faeed.jpg": 26573,
	"./ID00085_3_4x3_e5b0bd8d-471c-4a17-b756-25461e0d1dc5.jpg": 94159,
	"./ID00085_4_4x3_cba5188a-a3b2-4bba-a1fb-358d7aea64b2.jpg": 75900,
	"./ID00086_TINGEREDUCATIONALLIMITED_1_4x3_88ed50bd-677a-4cd8-b325-f5c4bd795a7d.jpg": 77512,
	"./ID00086_TINGEREDUCATIONALLIMITED_2_4x3_6f8a77cd-7d84-4b5d-9883-7b2689e6224d.jpg": 73729,
	"./ID00087_NYEducationCentre_1_4x3_8036d0a7-ffc1-4220-9229-f253b0b67213.jpg": 55260,
	"./ID00087_NYEducationCentre_2_4x3_5a92e1e7-7b23-49ba-abfa-34c7453a1a84.jpg": 52162,
	"./ID00087_NYEducationCentre_3_4x3_ff9847ae-fd29-43c7-96b2-b5105f0f988a.jpg": 45228,
	"./ID00087_NYEducationCentre_4_4x3_a9049775-9d85-4a42-a5ae-8e5734f61350.jpg": 10031,
	"./ID00088_SSCAdmissionTalk_ig_1.jpg": 95665,
	"./ID00089_schoolopenday_eventpostertemplateA4portirat_2.jpg": 78180,
	"./ID00090_1_4x3_b2055c2e-ab46-4ab3-bd1b-7d7bf98500b7.jpg": 4714,
	"./ID00090_2_4x3_00a54534-54fa-4800-9627-d7515437d0d8.jpg": 96994,
	"./ID00091_schoolopenday_eventpostertemplateA4portirat_1.jpg": 95056,
	"./ID00092_holy_trinity_1.jpg": 99271,
	"./ID00093_Po_Leung_Kuk_Lam_Man_Chan_English_Primary_School.jpg": 93035,
	"./ID00094_Home_Default_St._Hilary_s_Primary_School.pdf_1_4x3_3979701a-af83-4fb3-9fd9-d14ab078b1a3.jpg": 95313,
	"./ID00095_1_4x3_56eb3a05-4a3d-4d62-9d81-8af5bee8e133.jpg": 53563,
	"./ID00096_St_Margarets_2_4x3_039321e3-f4aa-4b93-b4cf-7be25c95733c.jpg": 29928,
	"./ID00097_LittleStarTreeStudio__1_4x3_874ccef3-a633-4d2f-bc85-5aadabfc3099.jpg": 21242,
	"./ID00097_LittleStarTreeStudio__2_4x3_dec891e7-2214-40c4-b542-003335834ad6.jpg": 90186,
	"./ID00098_CharlotteArtHouse__1_4x3_eb4c970f-c37f-4768-b043-53fb8e6ee461.jpg": 12945,
	"./ID00098_CharlotteArtHouse__2_4x3_d123a1ef-1f48-48f7-917b-c8032ca28045.jpg": 58582,
	"./ID00098_CharlotteArtHouse__3_4x3_d36cdd55-db81-4451-8660-c8993414a478.jpg": 11496,
	"./ID00098_CharlotteArtHouse__4_4x3_0e45271e-9858-4bfe-a2ed-3d67e1d14675.jpg": 35020,
	"./ID00099_2_4x3_35b5b4a9-3124-415c-89cc-7191843eea43.jpg": 75365,
	"./ID00099_PianoforteMusicCentre__1_4x3_d6714b82-2774-4c5b-98d5-1a50e622384a.jpg": 4799,
	"./ID00100_CadenzaPianoStudio_1_4x3_39641b18-faaa-4a46-ba9a-a031a93a773a.jpg": 35153,
	"./ID00100_CadenzaPianoStudio_2_4x3_82fa0845-bf4b-4176-ab3f-4dbf5e34d809.jpg": 86028,
	"./ID00100_CadenzaPianoStudio_3_4x3_bda3a19c-9d75-40a8-8336-bdd3a89eb6c1.jpg": 65429,
	"./ID00100_CadenzaPianoStudio_4_4x3_593baecf-fb3e-444c-a946-750bef5f76af.jpg": 31641,
	"./ID00101_TheJourneyEnglishEducationCentre_1_4x3_5eb3a131-1e50-4738-a174-1f322cf2d9dd.jpg": 84378,
	"./ID00101_TheJourneyEnglishEducationCentre_2_4x3_0d95156d-c0eb-4420-b8fb-2fe53be15aaf.jpg": 98046,
	"./ID00101_TheJourneyEnglishEducationCentre_3_4x3_d04bb94b-38e4-4ba9-a17c-8db67bd2053c.jpg": 43476,
	"./ID00101_TheJourneyEnglishEducationCentre_4_4x3_85f8a682-d933-471d-999d-fb8c53dadc20.jpg": 88523,
	"./ID00102_RobinENGLISHCENTRE_1_4x3_81f03da7-1e8d-4123-9a32-2b3cc4217558.jpg": 57145,
	"./ID00102_RobinENGLISHCENTRE_2_4x3_bc660ad4-ce3e-420f-afdf-e42cc2f23e79.jpg": 22548,
	"./ID00102_RobinENGLISHCENTRE_3_4x3_725ee295-75b8-4575-a165-fa593d9a83a3.jpg": 61692,
	"./ID00103_ProacticeEnglishLearningCenter.28.41_1_4x3_1091e43a-9e6d-4126-85bb-191e24c644b2.jpg": 98812,
	"./ID00103_ProacticeEnglishLearningCenter.28.41_2_4x3_f5c2b050-7c23-46bc-a9e6-2c88442caeb4.jpg": 40710,
	"./ID00104_1_4x3_483c8b60-5c25-45c3-b466-912022228c2b.jpg": 62166,
	"./ID00104_2_4x3_33dde174-500b-4196-ba8d-33059933716c.jpg": 18759,
	"./ID00104_3_4x3_04d0ecf4-b021-45c1-b10b-fd0f7c234819.jpg": 80499,
	"./ID00104_4_4x3_e64b3ae6-cd48-4893-aafc-a924b585bfab.jpg": 11515,
	"./ID00105_9_13__1_4x3_ccf0e01b-2655-49f0-8397-5c3386e9a14c.jpg": 76971,
	"./ID00106_schoolopenday_eventpostertemplateA4portirat.jpg": 56325,
	"./ID00107_SparkleEducationCentre_1_4x3_8baab12d-ea7e-4ad7-ba25-e042459b3d46.jpg": 31395,
	"./ID00107_SparkleEducationCentre_2_4x3_834a75d6-0629-4072-9f6c-3cf207e84e76.jpg": 72109,
	"./ID00108_Joyfulworkshop_1_4x3_938f75dd-3afb-443e-a4f0-0b702bf252bf.jpg": 10331,
	"./ID00108_Joyfulworkshop_2_4x3_be777e0d-b441-4e57-b723-003e5af26d04.jpg": 80236,
	"./ID00109_1_4x3_561701ff-012d-4d63-a8af-77dae6048e86.jpg": 87819,
	"./ID00110_ColorShowARTCENTER_1_4x3_12ed493d-6d7d-4ba6-846f-b47fcc01a2f0.jpg": 96724,
	"./ID00110_ColorShowARTCENTER_2_4x3_da5383df-f4c0-4dde-9eba-7f932ede9b5b.jpg": 96762,
	"./ID00110_ColorShowARTCENTER_3_4x3_d86d98d5-399d-4c1c-a45d-2639b2edc3ad.jpg": 51179,
	"./ID00110_ColorShowARTCENTER_4_4x3_a81e1d28-880a-4562-9fc7-8b982d903e7f.jpg": 92154,
	"./ID00111_ILoveSummer_2025_1.jpg": 27947,
	"./ID00112_new_doc_2025-8-12_18.48.47_1_4x3_4c8a5883-9cce-48d5-af23-f3e4ea3e6bef.jpg": 10864,
	"./ID00113_2025_1_4x3_4159f32f-18f5-457a-82fd-11f6c104ee87.jpg": 33367,
	"./ID00114_eb23c4b260a92c2e865a2dcfd4498a92.jpg": 60535,
	"./ID00115_KUMON_1_4x3_2913faf7-965b-4860-bff3-ac43762ce7d0.jpg": 91365,
	"./ID00115_KUMON_2_4x3_8f65446b-b7ae-42e2-91ba-f683c647ed8a.jpg": 25828,
	"./ID00115_KUMON_3_4x3_0a5fa926-11e6-47f0-8d4b-e820cd7e3a52.jpg": 25991,
	"./ID00115_KUMON_4_4x3_83cd0291-4fe7-4f9f-87d1-6679ecf228e3.jpg": 92332,
	"./ID00116_1_4x3_47351b42-de59-47ec-b968-139b75ca69ff.jpg": 41999,
	"./ID00117_Kiddikids__1_4x3_354f2d2e-5ab8-48f9-ab4b-b4d382587b64.jpg": 31639,
	"./ID00117_Kiddikids__2_4x3_75bfd155-d3e6-4bd4-9a3e-4f6162c3d647.jpg": 81813,
	"./ID00118_MUSIK__1_4x3_17dfa2a4-0cb9-4c65-8bf9-86dea5c55e28.jpg": 44957,
	"./ID00118_MUSIK__2_4x3_6bec5610-52d0-4fd9-a784-febda3428cc3.jpg": 18898,
	"./ID00119_ChieflistEducationCentre_6_4x3_b8d7af04-0258-46e4-8af8-aa16cff77ee8.jpg": 88904,
	"./ID00119_ChieflistEducationCentre_7_4x3_ea89a02e-b116-4131-b705-b82e909af115.jpg": 58175,
	"./ID00119_ChieflistEducationCentre_8_4x3_8a15261c-d41f-48ab-b27b-bba9327a9668.jpg": 39257,
	"./ID00119_ChieflistEducationCentre_9_4x3_3304c8d4-9b25-4d5e-801f-5c410dc09c44.jpg": 69656,
	"./ID00120_EnglishMathsONEducation_1_4x3_b26c4136-de89-401c-b8d6-71c3829b92ee.jpg": 25079,
	"./ID00120_EnglishMathsONEducation_2_4x3_f4ed1ce7-554b-4a00-8329-8ae5edf1b22a.jpg": 20587,
	"./ID00120_EnglishMathsONEducation_3_4x3_f2b5b31b-129d-47d8-adb5-a5e1467909b6.jpg": 73357,
	"./ID00120_EnglishMathsONEducation_4_4x3_eae9772a-d068-4d32-818e-39c59303ddeb.jpg": 90459,
	"./ID00121_1_4x3_9e3c9b5c-970e-4d02-9c92-757fd2a071a7.jpg": 23167,
	"./ID00121_2_4x3_1d0163ea-a534-434f-9933-1398a4b462a5.jpg": 86838,
	"./ID00121_3_4x3_8f79c329-e37f-412d-86cd-157ea0b921e3.jpg": 75669,
	"./ID00121_4_4x3_d87e800f-9eaa-4b91-b1ff-ff34c4229985.jpg": 84737,
	"./ID00122_1_4x3_336707fb-02b0-40aa-a73a-7ce9bad8f176.jpg": 89358,
	"./ID00122_2_4x3_bd756807-eaed-4ef3-b4e5-d271cbb4b9b1.jpg": 58965,
	"./ID00122_3_4x3_20471d05-57bd-4052-ad50-55862ad0cfac.jpg": 24213,
	"./ID00122_4_4x3_14403219-40ae-4a6c-90ee-e19856708673.jpg": 92514,
	"./ID00123_ThePlayWayEducationCentre_1_4x3_7d30ed5b-0078-4e6f-8199-532a6fa0bb02.jpg": 25341,
	"./ID00123_ThePlayWayEducationCentre_2_4x3_7414eb3f-eb19-45d6-a171-b192544b89f0.jpg": 91931,
	"./ID00123_ThePlayWayEducationCentre_3_4x3_b769ef7a-dd44-4ce5-9a58-900e1b6e6d58.jpg": 10836,
	"./ID00123_ThePlayWayEducationCentre_4_4x3_bf18ec12-02c7-4e2c-9d66-945c63d8e2b7.jpg": 37924,
	"./ID00124_1_4x3_c6bfa7bb-31f2-47a6-ae58-61fe874025ea.jpg": 82989,
	"./ID00124_2_4x3_f6576b15-f80e-452c-bd08-f81c8989b0bb.jpg": 18721,
	"./ID00125_OmniscienceEducationCentre_1_4x3_498eaabb-bda9-42f2-b51e-7c35e9b01afb.jpg": 92066,
	"./ID00125_OmniscienceEducationCentre_2_4x3_b592bd0b-2e9c-4250-b41a-2fa2c64f5538.jpg": 78141,
	"./ID00125_OmniscienceEducationCentre_3_4x3_99796f93-4759-49e5-9bb2-a8ebfdcad06c.jpg": 24651,
	"./ID00125_OmniscienceEducationCentre_4_4x3_944e8c0f-6f6d-4960-908d-42155e4768c5.jpg": 80614,
	"./ID00126_1_4x3_2a3fabd9-642b-4fb5-b0f8-eb4a8f310c21.jpg": 77766,
	"./ID00126_2_4x3_52639e71-641d-427e-a686-c974805aa423.jpg": 35973,
	"./ID00126_3_4x3_2ed02b59-a250-49f5-8906-66e32e2883b2.jpg": 96403,
	"./ID00126_4_4x3_fa716ab8-b51b-4c7c-97ac-f0cea100970e.jpg": 71716,
	"./ID00127_CleverBeanLearningCentre_1_4x3_7cff7de9-2f13-4712-b15f-21deaf1599f1.jpg": 17692,
	"./ID00127_CleverBeanLearningCentre_3_4x3_a427334a-6ec0-4c4c-813b-4eee94c992c3.jpg": 70401,
	"./ID00127_CleverBeanLearningCentre_4_4x3_13abe3e8-be2f-496d-9b0f-879570b40290.jpg": 9380,
	"./ID00127_CleverBeanLearningCentre_5_4x3_0a6e3503-0f01-4353-ace8-58f8efc6667d.jpg": 84277,
	"./ID00128_DitoMusicAcademy_1_4x3_31721dbf-186f-4585-94e0-3b4ad0c6578e.jpg": 36194,
	"./ID00128_DitoMusicAcademy_2_4x3_16257bb6-2834-4c32-848c-92a7ae0e577b.jpg": 39410,
	"./ID00128_DitoMusicAcademy_3_4x3_7544e7a0-351a-41bf-89b0-242b7e6c33be.jpg": 77750,
	"./ID00128_DitoMusicAcademy_5_4x3_1428c9cb-ec82-4e04-9158-f3b93aef3e42.jpg": 21984,
	"./ID00128_DitoMusicAcademy_6_4x3_2c1cd0d3-25ef-49be-ba26-410c63f3c1c1.jpg": 62279,
	"./ID00129_1_4x3_d33dcdef-e5ac-498d-8449-aa09d041f747.jpg": 37276,
	"./ID00129_2_4x3_4af0d7b3-aa2c-484f-a7d7-1b9f224b72d9.jpg": 80508,
	"./ID00129_3_4x3_5078c7ce-2935-434e-99e9-80004f99b7e8.jpg": 11157,
	"./ID00129_4_4x3_03bc0c5c-0d1c-4eb7-9b73-38719c1eb67c.jpg": 48600,
	"./ID00130_5_4x3_c537d362-a87d-443e-9b27-fb59aa4bfb19.jpg": 74011,
	"./ID00130_6_4x3_d1df401d-e1fd-41df-8821-3b239ead2670.jpg": 66681,
	"./ID00130_7_4x3_cd884619-a244-48a6-8e8a-92311772f7a5.jpg": 56860,
	"./ID00130_8_4x3_f446e36b-1e4f-42fb-b747-52937152e089.jpg": 49929,
	"./ID00131_1_4x3_472da8ce-3cdf-4adb-87fc-87becdb729fd.jpg": 20053,
	"./ID00131_2_4x3_c7db5616-04ea-4c79-8e92-6cda2042a466.jpg": 95864,
	"./ID00131_3_4x3_f8102a68-9a5b-40e1-8a62-e2c8cc5e2e92.jpg": 73847,
	"./ID00131_4_4x3_8d19b621-fd93-44ee-9c3c-e332ef935584.jpg": 75535,
	"./ID00131_5_4x3_4a66c0d6-375f-4b8c-af8b-36b589d6fe95.jpg": 79406,
	"./ID00132_QUEENSCASTLELEARNING_1_4x3_32358f47-9fd3-4a85-8284-153b1eecd78e.jpg": 76853,
	"./ID00132_QUEENSCASTLELEARNING_2_4x3_28a7963f-0927-4f17-bb64-16594795c7d4.jpg": 86755,
	"./ID00132_QUEENSCASTLELEARNING_3_4x3_062759c1-2094-40ad-b3ef-ea9e88ced1c0.jpg": 35381,
	"./ID00132_QUEENSCASTLELEARNING_4_4x3_141b21c7-968e-40ef-ba01-988f8e1feeb8.jpg": 22656,
	"./ID00132_QUEENSCASTLELEARNING_5_4x3_f6ff9490-6bc2-4356-8049-1c0bccd04531.jpg": 36271,
	"./ID00133_1_4x3_a2507e5c-9e0e-450c-bdf5-9f250715bc7d.jpg": 60940,
	"./ID00134_1_4x3_79f3a96a-4d8b-4837-abeb-9e90082edeba.jpg": 4592,
	"./ID00134_1_4x3_fe0b53cd-04c3-421c-bc5f-e24721cfd2b4.jpg": 33398,
	"./ID00134_2_4x3_34d6aa4f-ae51-4c08-94f6-f5d94c99b8e7.jpg": 50965,
	"./ID00134_3_4x3_a43439dd-676e-46e1-9218-f240b747e564.jpg": 15926,
	"./ID00135_1_4x3_3807130c-2da4-42d8-9f5e-fbc02332c972.jpg": 34046,
	"./ID00136_SmileyEnglishLearningCentre_1_4x3_dc924f7b-a18d-44d0-a8e1-edefd4fde9c0.jpg": 29016,
	"./ID00136_SmileyEnglishLearningCentre_2_4x3_3f458624-e91e-4750-8f1d-ada10e080376.jpg": 53397,
	"./ID00136_SmileyEnglishLearningCentre_3_4x3_d05849a7-6f0f-484e-830b-9a4e414a7bfa.jpg": 8186,
	"./ID00136_SmileyEnglishLearningCentre_4_4x3_7e6b389e-c177-4bcf-828c-ddc940175ebc.jpg": 99594,
	"./ID00137_FabulousEducationCentre_1_4x3_7e3f91e6-e029-423e-a500-e98199834e82.jpg": 57337,
	"./ID00137_FabulousEducationCentre_2_4x3_5d714fae-edca-4d83-9644-b1732aad5148.jpg": 48292,
	"./ID00137_FabulousEducationCentre_3_4x3_5ea8c949-2778-4c1d-9a7c-60379b2afbf5.jpg": 74851,
	"./ID00137_FabulousEducationCentre_4_4x3_35ecbbd3-d21e-4376-8c7c-eb0b6f400e14.jpg": 5538,
	"./ID00138_ODLE_1_4x3_558f8ed8-03fa-4fde-accd-d865e097de7b.jpg": 94710,
	"./ID00139_1_4x3_7b1ed762-bce7-4023-8d17-9e7babac7ca6.jpg": 65908,
	"./ID00139_2_4x3_87f068fb-873f-4a56-a71b-eb45d8814a40.jpg": 97614,
	"./ID00139_3_4x3_3c7565ab-9f9f-406f-abd0-848a3d6d1961.jpg": 51881,
	"./ID00139_4_4x3_989903a3-0c11-4090-96c4-e4cd3b634ad4.jpg": 83559,
	"./ID00140_SHININGSTARS_1_4x3_39c773f0-e062-4c43-950a-4bff0809de81.jpg": 58336,
	"./ID00140_SHININGSTARS_2_4x3_9780a0e9-e151-4f03-b598-4e633930f257.jpg": 31317,
	"./ID00140_SHININGSTARS_3_4x3_a3a6e3ec-766f-467c-bc1b-22f19a0f6e3c.jpg": 28685,
	"./ID00140_SHININGSTARS_4_4x3_7a5a7858-bf5d-42b9-b405-7d498ef141ad.jpg": 50847,
	"./ID00141_AELearningDimensions_1_4x3_e2b50b13-b3ca-498e-bbba-dd3a37b3c1dd.jpg": 92061,
	"./ID00142_5_4x3_c7317674-0917-48e6-af24-45cd128be2fb.jpg": 80732,
	"./ID00142_6_4x3_4317ba71-21aa-4cd2-be4a-2360f3cfa960.jpg": 1465,
	"./ID00143_GRANDMASTEREDUCATION_1_4x3_0cd564b5-8ae5-4fcf-89be-06ffa8c3597d.jpg": 93032,
	"./ID00143_GRANDMASTEREDUCATION_2_4x3_cc9f8660-ed47-4515-8eab-7b9942f1c820.jpg": 21923,
	"./ID00143_GRANDMASTEREDUCATION_3_4x3_c3875a6f-466d-467e-9b08-c9e0e926d3ba.jpg": 76988,
	"./ID00143_GRANDMASTEREDUCATION_5_4x3_f933a391-fd79-4ea4-966c-45b3fe95c5d9.jpg": 91970,
	"./ID00144_GainTreeEducationHouse__GainTreeEducationHouse__4x3_ef261a99-2145-465f-9656-a2bcea4aa6be.jpg": 60834,
	"./ID00145_WONDERLAB_1_4x3_8aae88ac-2297-4c2b-a035-70fa725629fd.jpg": 98597,
	"./ID00146_HeiTingEducationCentre_1.jpg": 83334,
	"./ID00147_EasyPeasyEducationalCentre_1_4x3_e214ad6f-e278-40ae-a411-b621dc9b7a45.jpg": 16815,
	"./ID00147_EasyPeasyEducationalCentre_2_4x3_6fcd29a8-83a0-4e2e-8e07-00b76a547524.jpg": 50764,
	"./ID00147_EasyPeasyEducationalCentre_3_4x3_d6f82e75-c872-480f-bf27-290ef4570751.jpg": 57884,
	"./ID00147_EasyPeasyEducationalCentre_4_4x3_d88c76c6-5103-4fab-9dc8-c68ffbea62dc.jpg": 27521,
	"./ID00148_CIDCKIDS__1_4x3_7f877ca2-4fb7-4c59-b02e-8ad7027e1f1c.jpg": 15784,
	"./ID00148_CIDCKIDS__2_4x3_2946ad46-40c7-410d-80c7-3b7b7ebc292d.jpg": 49437,
	"./ID00148_CIDCKIDS__3_4x3_627e0594-36d4-43b4-b9e1-2f84305213f8.jpg": 34456,
	"./ID00148_CIDCKIDS__4_4x3_124bf0ab-b40f-4706-a0b7-157e672f767f.jpg": 2514,
	"./ID00149_UIKOREATAEKWONDO_1_4x3_b458b2c2-c108-4feb-ac2a-0e5e7b29291c.jpg": 83713,
	"./ID00149_UIKOREATAEKWONDO_2_4x3_31bc1c0a-50ad-42a0-a8a0-eacaeceb1ab4.jpg": 48530,
	"./ID00149_UIKOREATAEKWONDO_3_4x3_e5873bbf-f84c-46a0-bdc3-5c7e2ada0d36.jpg": 98622,
	"./ID00149_UIKOREATAEKWONDO_4_4x3_433def42-f38e-4c89-b80a-502df607af91.jpg": 73521,
	"./ID00150_CherryKidsEnglishEducationCentre_1_4x3_b86a24ed-cfcf-42a9-9b87-72fdced40a0c.jpg": 2115,
	"./ID00150_CherryKidsEnglishEducationCentre_2_4x3_1e86a862-4ac9-4159-8e03-09101d4f125e.jpg": 98382,
	"./ID00150_CherryKidsEnglishEducationCentre_3_4x3_689d0ad1-4d27-49fe-805f-760875084e01.jpg": 61932,
	"./ID00150_CherryKidsEnglishEducationCentre_4_4x3_fa3f7dce-87e0-4da3-a74d-241dc61f637b.jpg": 16869,
	"./ID00151_WorldWhy_1_4x3_4ef47a75-22e8-4c96-980e-ccc80e782e96.jpg": 2219,
	"./ID00151_WorldWhy_2_4x3_8cfe82f2-926a-4362-809e-2906fe3e6e80.jpg": 27857,
	"./ID00151_WorldWhy_3_4x3_eff223ce-6d70-4ff5-81ee-400aef253da6.jpg": 85348,
	"./ID00151_WorldWhy_4_4x3_0bd5ba26-e6a9-4aff-a7e3-1cf2c581b754.jpg": 74040,
	"./ID00152_BRIANCHEUNGTUTORIALSCHOOL_1_4x3_b86a0ea7-8b09-4356-8c11-2c53889f95af.jpg": 17912,
	"./ID00152_BRIANCHEUNGTUTORIALSCHOOL_2_4x3_e8680dd9-319a-482b-a97b-0c9233354e6f.jpg": 94286,
	"./ID00152_BRIANCHEUNGTUTORIALSCHOOL_3_4x3_31e2588e-861a-4b2f-8ebc-c16ed85adc6e.jpg": 38301,
	"./ID00152_BRIANCHEUNGTUTORIALSCHOOL_4_4x3_ad17fe7e-d276-43e2-bc36-8f91bca23d05.jpg": 89115,
	"./ID00153_2025_1c25c7ff-2b73-4949-8a72-e7cdaa19250f.jpg": 51396,
	"./ID00154_AboutArt_1_4x3_cfc979c6-d432-4287-91bb-cb2a9e3e4f3a.jpg": 35775,
	"./ID00154_AboutArt_2_4x3_19f416ae-b360-4650-bb1b-e2a2d0342676.jpg": 94238,
	"./ID00154_AboutArt_3_4x3_95898b75-e582-410a-b515-3bb46b48a22e.jpg": 4626,
	"./ID00154_AboutArt_4_4x3_5173121d-00fd-478a-a2c6-6e976c942969.jpg": 22783,
	"./ID00155_1_4x3_544e5c26-6eb8-4b1a-a16a-f3fea9ca8cf7.jpg": 50853,
	"./ID00155_2_4x3_5c39ec40-c8ca-4c03-a02e-46b2e74ee69f.jpg": 9036,
	"./ID00155_3_4x3_66facf3f-af45-43d2-be21-0650b3d8d229.jpg": 18460,
	"./ID00155_4_4x3_edef4b77-65fa-4b58-95ed-65f9e8bb06cd.jpg": 94322,
	"./ID00156_1_4x3_600e62fe-f15b-4edf-be21-4cab19d92551.jpg": 92101,
	"./ID00156_2_4x3_56da6999-95f2-462f-8342-f7a15b43eb0a.jpg": 71498,
	"./ID00156_3_4x3_3750b58d-4687-42a8-850d-90084cfcb66b.jpg": 82420,
	"./ID00156_4_4x3_2849b723-cffd-4f65-b672-b56888f3952f.jpg": 33113,
	"./ID00157_1_4x3_a933c61a-4f1d-4bdb-b7d6-530e8e21fcba.jpg": 96365,
	"./ID00157_2_4x3_fe079ba3-7515-4547-b60c-3a34a1417a9b.jpg": 82685,
	"./ID00157_3_4x3_dada12b1-fdfa-4368-a168-39fe31077e8f.jpg": 33475,
	"./ID00157_4_4x3_c34ea04c-0ebe-4b01-b3bb-924fad1a55a8.jpg": 40998,
	"./ID00158_VISTAPLUSEDUCATION_1_4x3_ce2c895f-cdff-4e14-8806-2e7fa268c21b.jpg": 76481,
	"./ID00158_VISTAPLUSEDUCATION_2_4x3_04156d6b-dc26-4277-8732-d863cf4be046.jpg": 92283,
	"./ID00158_VISTAPLUSEDUCATION_3_4x3_18c8c095-029c-4d1d-9d94-36c68163b029.jpg": 66741,
	"./ID00158_VISTAPLUSEDUCATION_4_4x3_90e8e8c2-a98b-4568-938d-680ca361476e.jpg": 45428,
	"./ID00159_1_4x3_0c4259fd-f8f0-4cc2-8832-bcc38f4711ec.jpg": 45801,
	"./ID00159_2_4x3_14788955-cca1-440d-9021-9c32a8c3acd4.jpg": 44191,
	"./ID00159_3_4x3_9f7569dc-923a-411b-a0f2-38e4273be8ff.jpg": 8495,
	"./ID00159_4_4x3_0b8f9a0a-2d21-4cb6-856c-9f78a3d92f2a.jpg": 9595,
	"./ID00160_1_4x3_9808ff09-6347-449f-87d2-a44ab984567c.jpg": 94869,
	"./ID00160_2_4x3_b7f5cc37-7905-417f-a633-2f1bcfe646ee.jpg": 16949,
	"./ID00160_3_4x3_49eed5c2-6015-4841-bfb2-05d97a08e472.jpg": 91679,
	"./ID00160_4_4x3_98093b13-1dbc-456e-8f25-621aa25c8bb7.jpg": 18036,
	"./ID00161_1_4x3_b8e5639c-c8ca-4acb-97ba-cbca55536869.jpg": 94155,
	"./ID00161_2_4x3_ec9b98a6-299f-4741-a21c-2f9bc9843996.jpg": 26151,
	"./ID00161_3_4x3_7cb1e26d-af4c-4a4c-9b92-2de46b3d17de.jpg": 7375,
	"./ID00161_4_4x3_235420b6-fd7e-47e2-892a-9e13dbe37de1.jpg": 25824,
	"./ID00162_1_4x3_8820fa1e-4e35-47fa-bc92-6f9368a9c466.jpg": 32742,
	"./ID00162_2_4x3_e32a3b6b-4597-465a-9acc-4c616d3b92a9.jpg": 56815,
	"./ID00162_3_4x3_3a5c4604-a1af-466a-be7a-82cf23651566.jpg": 36107,
	"./ID00162_4_4x3_47bfd173-7f7d-41d7-a2be-0319aa29ef36.jpg": 58476,
	"./ID00163_2025_bec69267-2734-4d62-bb46-cb323ee487ab.jpg": 28495,
	"./ID00164_JoyPlusEducationCentre_1_4x3_b10f4685-6ad7-4912-af5f-db226e1d7ad2.jpg": 14315,
	"./ID00165_GohinEducation_1_4x3_199ae373-36ba-4291-ab67-4626df9ca840.jpg": 92675,
	"./ID00166_littlepianists_1_4x3_09569f1e-0832-4e12-81c8-f154b3709229.jpg": 64257,
	"./ID00167_BeyondEducation_1_4x3_b19adcf0-adeb-4111-9ed7-a589806c1a61.jpg": 87333,
	"./ID00168_Khanate_Education_1_4x3_14c273d3-67ff-4583-91ec-5d6b5daa421c.jpg": 99833,
	"./ID00168_Khanate_Education_2_4x3_1dc49d77-0007-4848-8e4f-5841c7b309a5.jpg": 80223,
	"./ID00168_Khanate_Education_3_4x3_b500a00b-b06c-4401-9a2a-223f93b0c0ca.jpg": 67592,
	"./ID00169_CENTURYEDUCATION__CENTURYEDUCATION_1_4x3_f88aba53-bbcc-4694-a60e-55db033027c2.jpg": 5850,
	"./ID00170_ArtPointStudio__ArtPointStudio__1_4x3_47b12271-e184-4d2a-b98e-b106ea98eb47.jpg": 34933,
	"./ID00170_ArtPointStudio__ArtPointStudio__2_4x3_5a22a2f1-d54c-4ede-a97b-8b4a8adf098e.jpg": 75088,
	"./ID00170_ArtPointStudio__ArtPointStudio__3_4x3_5ca18dba-1418-46ab-921f-f116c07b3d07.jpg": 48154,
	"./ID00170_ArtPointStudio__ArtPointStudio__4_4x3_0e7dabde-e378-4ec1-94a1-8e1627816812.jpg": 10261,
	"./ID00171_SQcircle_1_4x3_a7f1b0c2-9c35-408d-9635-139bbea50435.jpg": 26809,
	"./ID00172_GCEducationCentre_1_4x3_810f40c3-c6a3-4096-afe6-cc82c0ec41d2.jpg": 44425,
	"./ID00172_GCEducationCentre_2_4x3_42ec7528-5689-4812-84e7-4401e5db82a0.jpg": 8230,
	"./ID00173_GraceuponGraceLearningCentre_1_4x3_19f52091-309f-4672-98c7-618d54a93591.jpg": 88468,
	"./ID00173_GraceuponGraceLearningCentre_2_4x3_d456bbbe-d9f2-4a2e-8525-2ddfa9908afa.jpg": 72596,
	"./ID00174_1_4x3_525a20a4-2f4c-46ce-aecb-c3ad27a78589.jpg": 65882,
	"./ID00174_2_4x3_9e44c58b-1eac-4f00-9fe7-66120e4b1097.jpg": 20151,
	"./ID00174_3_4x3_ee7329b2-77b2-4283-a688-7ca6840e9751.jpg": 23877,
	"./ID00174_4_4x3_bcf894d9-1df2-4dc6-ad29-3ff91ebb159b.jpg": 2665,
	"./ID00175_HAPPYSOUNDMUSIC_1_4x3_0a3dad60-9664-4148-9b08-a1d9c4016eeb.jpg": 51099,
	"./ID00175_HAPPYSOUNDMUSIC_2_4x3_b7f456dd-d947-434b-945b-3ce8bc581f04.jpg": 71828,
	"./ID00175_HAPPYSOUNDMUSIC_3_4x3_2dfe9bad-bac7-4166-b0a3-2cfb5988b28a.jpg": 96335,
	"./ID00175_HAPPYSOUNDMUSIC_4_4x3_f63eb44a-5ff2-4c0e-aae9-2c938bba140d.jpg": 46794,
	"./ID00176_AceEdu_1_4x3_e50bb156-0eb5-443c-8c09-a2cc5e395e8e.jpg": 97896,
	"./ID00176_AceEdu_2_4x3_c75f645c-ece9-498c-8f09-7ff1026f4481.jpg": 7596,
	"./ID00177_KIDSBRIDGEEDUCATIONCENTRE_1_4x3_849f4ebe-13dd-4d40-a54e-1cd46a0500a6.jpg": 87094,
	"./ID00177_KIDSBRIDGEEDUCATIONCENTRE_2_4x3_f3bb37c0-a6b5-4837-a39d-be6e9d5fd993.jpg": 30870,
	"./ID00177_KIDSBRIDGEEDUCATIONCENTRE_3_4x3_f5fe76ea-86a2-4f4e-9cb3-03e1e53b9286.jpg": 31438,
	"./ID00177_KIDSBRIDGEEDUCATIONCENTRE_4_4x3_67db79b6-9555-4448-be6c-81fe1b1786e5.jpg": 78738,
	"./ID00178_1_4x3_cf22709f-67f9-441d-ab9d-3f7850fdc1cb.jpg": 95680,
	"./ID00178_2_4x3_a4f3ae27-ed4b-4fcc-a0c9-cadda5b89bc4.jpg": 35638,
	"./ID00179_K.L.__1_4x3_451148a1-5833-4760-926b-4bf92120d444.jpg": 64224,
	"./ID00179_K.L.__2_4x3_7281e92c-6802-40b5-889f-5a732b1144ab.jpg": 7571,
	"./ID00180_1_4x3_cc5fccbc-77a9-48e6-904f-4c24f60f84af.jpg": 64655,
	"./ID00180_2_4x3_f561c8dc-18e0-4593-b506-264585147bf9.jpg": 7945,
	"./ID00180_3_4x3_4d53a912-289b-4c0d-bf08-06df5dcc258c.jpg": 87201,
	"./ID00180_4_4x3_fbff4b2f-9148-41e9-a870-440363981613.jpg": 97777,
	"./ID00180_Fine_Music_Fine_Music_1_4x3_d0558b87-9b58-465f-9b89-60e4293d6a63.jpg": 48034,
	"./ID00180_Fine_Music_Fine_Music_2_4x3_53dc3480-6aec-44b1-9491-9ea27e21e04a.jpg": 95993,
	"./ID00180_Fine_Music_Fine_Music_3_4x3_1b1a9593-f45c-49a7-8851-5890d072e8f3.jpg": 44130,
	"./ID00180_Fine_Music_Fine_Music_4_4x3_3d0fdb70-c4dd-4ac8-a8c7-4575b9680e73.jpg": 72117,
	"./ID00181_BrightQualityLearningEducationCentre_1_4x3_20064a98-cb5d-4057-9c67-5a96b98cd3ab.jpg": 63869,
	"./ID00181_BrightQualityLearningEducationCentre_2_4x3_b6578b8e-9284-4d22-8db3-25e78a6b3800.jpg": 23284,
	"./ID00181_BrightQualityLearningEducationCentre_3_4x3_3885d1f4-5d5e-458d-a011-7ec85653026f.jpg": 34711,
	"./ID00181_Bright_Quality_Learning_Education_Centre_5_4x3_f873d58a-68f4-450a-81b9-2f35334573d7.jpg": 61495,
	"./ID00182_1_4x3_6bdcb8b5-2a1b-4757-b7c7-67b2e0151f13.jpg": 83294,
	"./ID00182_1_4x3_d47878ae-7a5f-428c-9ef8-9b89a82b2964.jpg": 85683,
	"./ID00182_2_4x3_01efa6c3-61d9-450b-8e04-14310edbfe58.jpg": 51217,
	"./ID00182_2_4x3_27bd1b3c-fef3-4015-8868-a7bd4903b5c9.jpg": 22473,
	"./ID00182_3_4x3_87cb3c01-51f0-4230-b252-5bd26b7698a6.jpg": 74978,
	"./ID00182_4_4x3_ed8fdcce-da0c-47d5-ba4a-d87fccd088ce.jpg": 62411,
	"./ID00182_5_4x3_87b88cac-3b2a-4a6a-9745-3e05890277c0.jpg": 45015,
	"./ID00183_ProfoundWisdomEducation_1_4x3_03f1408d-c6c2-4ff9-8942-dfd95edbefa9.jpg": 29869,
	"./ID00183_ProfoundWisdomEducation_2_4x3_08c180c4-22e9-4346-9928-f8fee1f9c1cb.jpg": 61513,
	"./ID00183_ProfoundWisdomEducation_3_4x3_f1fcff64-ca4d-423a-8d39-419afddeaf23.jpg": 5253,
	"./ID00183_ProfoundWisdomEducation_4_4x3_b98fae9d-a348-4ff7-939d-c82937856661.jpg": 67414,
	"./ID00184_HARPITIME_1_4x3_46a47aff-2b79-4172-9df3-91c590f89acd.jpg": 38788,
	"./ID00184_HARPITIME_2_4x3_8e7c273d-079e-4b1d-b07b-37a306fbed33.jpg": 17159,
	"./ID00184_HARPITIME_3_4x3_4d088333-217c-4630-bf68-d828e5f8db3e.jpg": 25044,
	"./ID00184_HARPITIME_4_4x3_43e4f588-28a9-4aa0-9a3f-c16b67e11b0e.jpg": 41171,
	"./ID00185_SMARTPROFESSIONALEDUCATION_1_4x3_51287992-499a-4458-bf1e-e16b9a65635c.jpg": 65982,
	"./ID00185_SMARTPROFESSIONALEDUCATION_2_4x3_8acb7ae7-631e-4490-8c06-6f5602f66844.jpg": 59682,
	"./ID00185_SMARTPROFESSIONALEDUCATION_3_4x3_4fb8f183-f872-4e47-b52b-9f1db91802e6.jpg": 63430,
	"./ID00185_SMARTPROFESSIONALEDUCATION_4_4x3_0e5367ff-e804-49c0-ac1c-1612dbce0a89.jpg": 62593,
	"./ID00186_EliteGroupEducationCentre_2_4x3_1cce818c-f9b9-4102-bc29-b85104f1d1be.jpg": 93710,
	"./ID00186_EliteGroupEducationCentre_3_4x3_19493134-af2d-466f-b448-814937b888e3.jpg": 6900,
	"./ID00186_EliteGroupEducationCentre_4_4x3_20dae822-3e1a-4a40-8e2f-008556d36650.jpg": 11466,
	"./ID00186_EliteGroupEducationCentre_5_4x3_10ec4a16-39e5-40e9-bb8c-f4988163e5ed.jpg": 33931,
	"./ID00187_1_4x3_f8d72845-5978-4f7b-94f1-4825331d937f.jpg": 99805,
	"./ID00187_2_4x3_8a534c9e-6edc-4eca-b3b5-bfab04bc6b0a.jpg": 51485,
	"./ID00187_3_4x3_4785a292-a914-43dc-a228-4507ed406cec.jpg": 26300,
	"./ID00187_4_4x3_59efac08-47ba-4610-8ed2-73bcdfdc7f89.jpg": 72918,
	"./ID00188_CaringZoneKids_1_4x3_fc73e5d8-e548-44d5-ae22-beedefabfed1.jpg": 9571,
	"./ID00188_CaringZoneKids_2_4x3_e006783e-2a65-4030-9ba9-d97bdb4f156a.jpg": 87195,
	"./ID00189_new_doc_2025-7-16_11.48.06_1_4x3_a0e27fe1-1481-4874-9e79-ac3dc418eb65.jpg": 87344,
	"./ID00189_new_doc_2025-7-16_11.48.06_2_4x3_fabadca5-9be6-4b66-866d-3a809b8e16de.jpg": 84413,
	"./ID00189_newdoc2025-7-1611.48.06_3_4x3_51a3df24-7f43-42b3-88a0-7b0eeac3132c.jpg": 45019,
	"./ID00189_newdoc2025-7-1611.48.06_4_4x3_806bea4f-ffee-4f89-ac22-b5f39a82b93c.jpg": 17271,
	"./ID00190_AchieverEducationCentre_1_4x3_c5ffb9ee-f61a-4f18-93a4-4fe8a7294d33.jpg": 59802,
	"./ID00190_AchieverEducationCentre_2_4x3_34952b22-e422-4aff-bb08-b05e09bec88c.jpg": 45371,
	"./ID00191_1_4x3_c5b4f704-fbce-4a26-b05c-07ab5ebdbcff.jpg": 82666,
	"./ID00191_Wise_and_Diligent_Education_Centre_2_4x3_348b264e-0135-4106-8451-af47c5d767c9.jpg": 24433,
	"./ID00192_FUNGWINGEDUCATION__1_4x3_1bb7cfed-191b-452e-91ac-6109f9e35972.jpg": 43850,
	"./ID00192_FUNGWINGEDUCATION__2_4x3_b94cbb54-138a-4d0a-be85-35e396e63c05.jpg": 42362,
	"./ID00192_FUNGWINGEDUCATION__3_4x3_79b5877f-625f-4c33-b4a9-9118a947bfe4.jpg": 15859,
	"./ID00192_FUNGWINGEDUCATION__4_4x3_89daeb9d-1c98-4660-847e-fa3f27aa556f.jpg": 18978,
	"./ID00193_Thankyouland_1_4x3_c22216a2-b1aa-4a74-b2e6-dd4245e760eb.jpg": 46993,
	"./ID00193_Thankyouland_2_4x3_4bf3bd70-12a7-462c-a133-b93601f86d23.jpg": 75491,
	"./ID00194_1_4x3_5e9f1f04-d407-4832-bdff-ece4d208998d.jpg": 68027,
	"./ID00194_2_4x3_865260b0-91ba-4fe9-bdc2-15ae8e9e1738.jpg": 52802,
	"./ID00194_3_4x3_e1574e72-be86-4339-bb3a-f017411c7ae8.jpg": 52304,
	"./ID00194_4_4x3_13fea720-4c89-44be-90be-038bc9f2e6dc.jpg": 42182,
	"./ID00195_1_4x3_4a2b5066-6c58-4af0-a203-973f45ea429e.jpg": 55172,
	"./ID00195_2_4x3_a613912a-b1df-4b48-930e-0406caff41af.jpg": 27244,
	"./ID00195_3_4x3_b719a30d-b173-4ca3-81a2-07395b724c29.jpg": 51189,
	"./ID00195_4_4x3_b327b27e-ccfe-48ae-b902-c0e93e23ecb1.jpg": 77149,
	"./ID00196_1_4x3_bed19991-95cf-470a-83f4-fe82817cf1da.jpg": 72000,
	"./ID00196_EnjoySquareLearningCentre_Aberdeen__2_4x3_c6c58987-5d3b-47e4-9987-40801e9fec45.jpg": 56121,
	"./ID00197_ALAMEDUCATIONCENTRE_1_4x3_6f2bd711-fee3-444b-806d-6df47a6d3853.jpg": 47803,
	"./ID00197_ALAMEDUCATIONCENTRE_2_4x3_cf3aeca9-bf13-4954-b053-b602734db38d.jpg": 51121,
	"./ID00198_SunHeiMathematicsEducationCentre_1_4x3_948793da-2150-487d-8278-5033185e95bb.jpg": 88483,
	"./ID00198_SunHeiMathematicsEducationCentre_2_4x3_8553550a-4e08-476f-99d7-edaffbb321a8.jpg": 71895,
	"./ID00198_SunHeiMathematicsEducationCentre_3_4x3_fc10d95b-9db7-417d-b42b-b6a4358c075f.jpg": 59786,
	"./ID00198_SunHeiMathematicsEducationCentre_4_4x3_7bfcd1bd-90bb-44f8-9504-8788fa770f09.jpg": 2366,
	"./ID00199_1_4x3_aaddd7e3-4285-4924-9c77-24a7270d6a16.jpg": 15585,
	"./ID00199_2_4x3_44a2384b-0532-4be4-af64-1bb6cbb4552e.jpg": 64953,
	"./ID00199_3_4x3_887f0e3c-0d90-4b51-b7c2-5979aca634f0.jpg": 27796,
	"./ID00199_4_4x3_4af10668-b66e-4c34-bbfa-6178bd04db4e.jpg": 92985,
	"./ID00200_Bluebird_1_4x3_6b0d1a0e-44dc-4fa5-bb21-b7ad675d8d20.jpg": 69289,
	"./ID00200_Bluebird_2_4x3_e182861c-1be0-4cd9-9ad7-3b9e7104ff15.jpg": 11971,
	"./ID00200_Bluebird_3_4x3_19b16278-94d6-4450-a0dd-eee62b2604b8.jpg": 22694,
	"./ID00200_Bluebird_4_4x3_7929d349-9ad2-4ea3-8fa5-e4151566cf84.jpg": 18903,
	"./ID00201_1_4x3_e54de426-87a2-440b-a4b6-6847f01378e5.jpg": 51885,
	"./ID00201_EasyMathsEducationCentre_2_4x3_d997cf93-3dd0-46a1-8203-6b9be16e1743.jpg": 1248,
	"./ID00201_EasyMathsEducationCentre_3_4x3_687e48ef-e7d5-404d-b7e1-b09900f40b73.jpg": 42489,
	"./ID00201_EasyMathsEducationCentre_4_4x3_0493aee2-a601-48b0-b0b0-1cf28d756925.jpg": 71274,
	"./ID00202_WinnieChoiArtStudio_1_4x3_caffe479-cf91-40ae-880f-f2f9fcedadfd.jpg": 89251,
	"./ID00202_WinnieChoiArtStudio_2_4x3_f6651c02-8fe4-4f8c-9bee-910757977607.jpg": 81757,
	"./ID00202_WinnieChoiArtStudio_3_4x3_3235ab61-26df-44f3-a0b7-3fdf6af63ffb.jpg": 19892,
	"./ID00202_WinnieChoiArtStudio_4_4x3_0b0a37ad-7fbc-4481-ac4f-c71010134295.jpg": 41629,
	"./ID00203_TheUnparalleledInsight__TheUnparalleledInsight__1_4x3_7053fb72-1c19-4a97-98a8-1fe54ee7e662.jpg": 88877,
	"./ID00203_TheUnparalleledInsight__TheUnparalleledInsight__2_4x3_e9b387cd-bcff-4cc1-8342-23c894639664.jpg": 35945,
	"./ID00203_TheUnparalleledInsight__TheUnparalleledInsight__3_4x3_b0c5e68c-8dfa-4d22-aafb-3ed97798b397.jpg": 86499,
	"./ID00203_TheUnparalleledInsight__TheUnparalleledInsight__4_4x3_da166265-45a5-4265-8176-22334b2c7e9a.jpg": 83734,
	"./ID00204_GrandSuccessEducationCenter_1_4x3_5753ef36-7447-4ee2-91ad-3d7feef01d80.jpg": 47655,
	"./ID00204_GrandSuccessEducationCenter_2_4x3_ba32cdb0-e91c-40fc-b013-1f37608f39b4.jpg": 7695,
	"./ID00204_GrandSuccessEducationCenter_3_4x3_4e627ff0-65c0-4275-a4f2-b5099f15bea0.jpg": 98599,
	"./ID00204_GrandSuccessEducationCenter_4_4x3_27fa6656-7c1b-4671-b067-b414bb73f1d0.jpg": 53547,
	"./ID00205_2_4x3_73f5fd3c-b46e-4248-86b3-4861c5a96b41.jpg": 2889,
	"./ID00205_BravuraMusicCentre_1_4x3_da1fe0fc-10e5-4e7b-a869-719aec9e5d8b.jpg": 67457,
	"./ID00205_BravuraMusicCentre_3_4x3_6d6a6e95-eb0d-4c32-9461-1f2eaee5cac5.jpg": 40864,
	"./ID00206_ARTSPAINTINGWORKSHOP_1_4x3_42d48b36-6f04-4507-b116-2834ceff8a16.jpg": 50278,
	"./ID00206_ARTSPAINTINGWORKSHOP_2_4x3_f0f1a5ae-107d-473b-8c43-2eacb7849914.jpg": 28043,
	"./ID00207_InspirationLearningCenter_2_4x3_e1e8b91c-d63b-4b9e-b303-7d96942fcf97.jpg": 58033,
	"./ID00207_InspirationLearningCenter_3_4x3_dbd2d28e-af1d-426a-805d-26aae7f607e2.jpg": 34520,
	"./ID00207_InspirationLearningCenter_4_4x3_c1f675c8-f267-4431-a758-a29093148a2c.jpg": 57322,
	"./ID00207_InspirationLearningCenter_6_4x3_e59a771c-ba5d-4c86-b7d2-921a218c4b8b.jpg": 14359,
	"./ID00207_InspirationLearningCenter_7_4x3_106fb53c-2979-4151-8ea4-09a049183cce.jpg": 3533,
	"./ID00207_InspirationLearningCenter_9_4x3_01463c0f-8fa1-45c3-b913-9264803781ad.jpg": 16685,
	"./ID00208_MusicologyStudio__MusicologyStudio_1_4x3_0c0fb9d4-7daf-4713-84d0-0752557bce5c.jpg": 58139,
	"./ID00209_1_4x3_9b47429d-2279-43f2-a8f7-5c24921d7294.jpg": 78303,
	"./ID00209_2_4x3_d6ab4290-348b-472e-b05b-58b5af178ae2.jpg": 75139,
	"./ID00209_3_4x3_c6b5c6c4-a9f5-47dd-a15e-98b21ca82943.jpg": 40381,
	"./ID00209_4_4x3_574e7400-e0e0-4648-846b-e2b60cf45302.jpg": 54838,
	"./ID00209_5_4x3_aad48daa-78ed-4edc-afda-22f92bc1690f.jpg": 99247,
	"./ID00209_6_4x3_71b5f701-6913-495a-ac87-2708fda18caa.jpg": 9088,
	"./ID00209_7_4x3_db5d83e7-5b00-41e8-8581-f0605d26ece0.jpg": 16572,
	"./ID00209_8_4x3_5a0dca50-08be-412e-9164-ab88c708a9a6.jpg": 35864,
	"./ID00209_9_4x3_f66982d0-24d4-4e8d-abad-b1c6029f59e5.jpg": 13658,
	"./ID00210_CherryTree_CherryTree_1_4x3_27e0332f-e988-451b-bef0-bbc86753722c.jpg": 89260,
	"./ID00210_CherryTree_CherryTree_2_4x3_01be4811-9554-40aa-be75-a418c914883e.jpg": 12637,
	"./ID00210_CherryTree_CherryTree_3_4x3_76bf460a-7f7e-46fc-9777-7b8f0dd1525e.jpg": 42534,
	"./ID00210_CherryTree_CherryTree_4_4x3_2610416d-0995-4414-bc28-bd786bb56fd5.jpg": 42438,
	"./ID00211_WhatsAppImage2025-07-12at12.53.26PM_1__4x3_437ba4b3-bd48-4b58-bc98-81c55f2dc51f.jpg": 46113,
	"./ID00211_WhatsAppImage2025-07-12at12.53.26PM_2__4x3_c4ee541f-4e84-417b-b907-ecce27805149.jpg": 8492,
	"./ID00211_WhatsAppImage2025-07-12at12.53.26PM_3__4x3_5c1a463f-c380-4cd1-b63a-451d7620bdf1.jpg": 34602,
	"./ID00211_WhatsAppImage2025-07-12at12.53.26PM_4x3_911bf758-d290-4879-ba31-0170772697c1.jpg": 45989,
	"./ID00212_10495bf319550e29f64b6e01cf9d6d55_9b0f2be8-4e7b-404d-8f13-974f2c0d4136.jpg": 40069,
	"./ID00213_1ec0c8a256b012003afed6c5aac45cd5.jpg": 26822,
	"./ID00214_4_4x3_a969bee9-8924-431c-b105-b939916beef9.jpg": 36556,
	"./ID00214_DREDUCATIONLEARNINGCENTER_2_4x3_9c45f305-c18a-4490-b75e-33240ee8a8d7.jpg": 97128,
	"./ID00214_DREDUCATIONLEARNINGCENTER_3_4x3_1b921a4b-2f80-4e2f-bd16-22075304fd52.jpg": 90961,
	"./ID00215_COASELearningCentre_1_4x3_c1d9c622-3aaf-4675-a2f1-17c591589f97.jpg": 9866,
	"./ID00215_COASELearningCentre_2_4x3_769c72d1-7184-4fbf-bf66-dfcb282b3097.jpg": 7059,
	"./ID00215_COASELearningCentre_3_4x3_37cf1974-cacd-4555-9be1-2cc6467dc0e8.jpg": 92773,
	"./ID00215_COASELearningCentre_4_4x3_1a8ffae8-13a3-4dd0-8252-23c97653fd03.jpg": 14490,
	"./ID00215_COASELearningCentre_5_4x3_32050bde-1627-4324-9be7-a01e34b9d42f.jpg": 64607,
	"./ID00216_BalletBean_3_4x3_6902f3b5-92fc-4c25-a4a3-918d953f1d0a.jpg": 30881,
	"./ID00216_BalletBean_BalletBean_1_4x3_4x3_56a49d29-a0f2-4465-ab44-d36475977652.jpg": 23501,
	"./ID00216_BalletBean_BalletBean_2_4x3_59ff9e0a-75fa-47d4-99ce-c822f76af54b.jpg": 74609,
	"./ID00217_c6ff5d27a69e57e2feb3525590687068.jpg": 20520,
	"./ID00218_bc9a14b2d99a8e78164b0e1f5f8fddda_f222ac85-0e9c-4258-bc23-525cbeb4da85.jpg": 40047,
	"./ID00219_IsarangtaekwondoKorea_IsarangtaekwondoKorea_WhatsAppImage2025-07-08at2.21.14PM_4x3_bc56d911-0ba1-4e18-9362-2eee6ce43dd5.jpg": 33376,
	"./ID00219_IsarangtaekwondoKorea_IsarangtaekwondoKorea_WhatsAppImage2025-07-08at2.21.22PM_4x3_dd07bad2-67cc-4c24-bcd2-42a6783965f8.jpg": 40755,
	"./ID00219_IsarangtaekwondoKorea_IsarangtaekwondoKorea_WhatsAppImage2025-07-08at2.22.23PM_4x3_033bb8f1-a619-4830-9c7e-09d964e75af7.jpg": 71171,
	"./ID00219_IsarangtaekwondoKorea_IsarangtaekwondoKorea_WhatsAppImage2025-07-08at2.22.27PM_4x3_863228e6-8b11-486f-9308-1a14fc962946.jpg": 28509,
	"./ID00219_IsarangtaekwondoKorea_IsarangtaekwondoKorea_WhatsAppImage2025-07-08at3.38.31PM_4x3_0768f472-f95c-466e-97f1-800135469077.jpg": 10209,
	"./ID00220_Sportfest_Hong_Kong_Sportfest_Hong_Kong_Sportfest_Hong_Kong_4x3_bb40ef86-0b07-4977-8fa1-170f568d5b9e.jpg": 86045,
	"./ID00221_TheArtroom_TheArtroom_WhatsAppImage2025-07-05at12.45.59PM_4x3_82c2624f-6836-4916-a727-df35eed2c6f5.jpg": 11357,
	"./ID00222_WhatsAppImage2025-07-05at12.44.53PM_4x3_28d2cb07-e7df-4001-a7a3-874cba0e82bf.jpg": 66565,
	"./ID00222_WhatsAppImage2025-07-05at12.44.54PM_1__4x3_3b4104b7-423f-4467-8b66-2cd1cc535460.jpg": 2616,
	"./ID00222_WhatsApp_Image_2025-07-05_at_12.44.51_PM_1__4x3_d5cbf182-1cd0-4130-ba11-a3ea991908be.jpg": 46859,
	"./ID00223_TWGHsE-CoVillage.jpg": 38124,
	"./ID00224_f878cd094f8a0b179024a51fc1deb44a_3a649cf6-ab26-457f-ac5f-4dd9e732bab8.jpg": 42026,
	"./ID00225_Hong_Kong_Space_Museum__Hong_Kong_Space_Museum_4x3_63ff31af-ed47-4b36-b5eb-46444fba3b73.jpg": 64071,
	"./ID00226_1_4x3_d88a465c-8545-482e-8c0f-97d3923f842e.jpg": 52475,
	"./ID00226_2_4x3_b240d84a-658c-4eae-be7c-cb75457dc2ba.jpg": 61089,
	"./ID00226_3_4x3_05dfb94b-47e7-4d53-bd36-0d7b77e0e1c5.jpg": 65456,
	"./ID00227_LittleGoodTimeeeStudio_3_4x3_d00e0f89-ed06-486b-87b9-dc885f3c608f.jpg": 18261,
	"./ID00227_LittleGoodTimeeeStudio_4_4x3_853d9f24-b71a-4176-8946-07b76cb2ada6.jpg": 2657,
	"./ID00228_1_4x3_0bcff360-53e7-4de2-9bb7-1f166143bf1d.jpg": 82520,
	"./ID00228_2_4x3_cafdaf9b-48c2-43ac-9ab7-dc9bd0924e82.jpg": 61812,
	"./ID00228_3_4x3_df5bfd3c-3abc-4fc1-8f56-d11be3c769a7.jpg": 72324,
	"./ID00228_4_4x3_c7f3e924-9907-45d0-a3f6-ed54e6403331.jpg": 46937,
	"./ID00229_PREMIEREDUCATIONCENTRE_1_4x3_e4578ae3-aa33-405a-8cfb-ea79f4aaf8f7.jpg": 43313,
	"./ID00229_PREMIEREDUCATIONCENTRE_2_4x3_13788103-1370-4352-a60d-0b37e235af10.jpg": 38274,
	"./ID00229_PREMIEREDUCATIONCENTRE_3_4x3_e87e9954-f0c1-4931-bc73-d2ea2ecbe6cc.jpg": 15188,
	"./ID00229_PREMIEREDUCATIONCENTRE_4_4x3_6664e529-202d-43db-a697-441afe761709.jpg": 32172,
	"./ID00229_premier_1_4x3_15e4229e-5d58-474a-81e6-cf96ab891d4f.jpg": 57738,
	"./ID00229_premier_2_4x3_44df2f07-9b0d-40ae-a6ed-83b5b8b3c18d.jpg": 60068,
	"./ID00230_TreasureHunt_1_4x3_367f9050-cc5c-43a0-9b87-dc5ebde8b9e3.jpg": 93265,
	"./ID00231_1_4x3_d3c1ea62-a9b9-43e0-b7a0-a0d7979d53ad.jpg": 55906,
	"./ID00231_2_4x3_3ed48b1c-e2a8-4975-858f-29e8c880012c.jpg": 56190,
	"./ID00231_3_4x3_618f3bf5-1bb3-414f-a254-39927d8819c4.jpg": 54831,
	"./ID00231_4_4x3_dd9d46bc-0da2-4df9-821b-986f5c8b1bac.jpg": 1108,
	"./ID00232_1_4x3_585a6ec2-93c4-4d14-b25c-335ff3d3725a.jpg": 97442,
	"./ID00232_2_4x3_c290d903-6db9-48ff-ac90-d5d5d9812391.jpg": 89261,
	"./ID00232_3_4x3_be0b6929-9f93-4f65-85d1-7016cdb3dc5d.jpg": 88482,
	"./ID00232_4_4x3_2045b1e2-1858-493d-8163-2563bbc5955b.jpg": 89916,
	"./ID00233_1_4x3_f3265b52-684d-4dc2-80bb-aa9c266e51c1.jpg": 12840,
	"./ID00233_2_4x3_c687e50f-712b-4a47-92fa-f74d9d2d0ca1.jpg": 31480,
	"./ID00233_3_4x3_b6c41d78-6a9d-4c7d-900e-60e8d9fb0037.jpg": 67711,
	"./ID00233_4_4x3_69bd9ec9-2fd1-4a9e-9cb3-2fd2c422c204.jpg": 55835,
	"./ID00233_Smartland_Learning_Centre_1_4x3_095961ca-497b-40eb-afc8-bef93dd23797.jpg": 26918,
	"./ID00233_Smartland_Learning_Centre_2_4x3_71c4ba94-7687-4cb8-8158-4d1e0335b9fd.jpg": 35655,
	"./ID00233_Smartland_Learning_Centre_3_4x3_0d69777b-cdac-4887-8ac0-35d4ebdd38ee.jpg": 55590,
	"./ID00233_Smartland_Learning_Centre_4_4x3_af282f37-2de3-44b2-95fa-f1b0a49fdc42.jpg": 92777,
	"./ID00234_OlympicEducation_1_4x3_156832ce-781c-4415-a052-7162d4f9c40f.jpg": 91117,
	"./ID00234_OlympicEducation_2_4x3_1f8f8c6b-57bf-42e2-97c6-21fa8a696cb2.jpg": 40905,
	"./ID00234_OlympicEducation_3_4x3_36b38b31-a5e5-440b-9eda-589a4f2ffd03.jpg": 68582,
	"./ID00234_OlympicEducation_4_4x3_1de20f54-c686-4dd6-962a-b4c8c82da943.jpg": 43959,
	"./ID00235_DKACADEMY_1_4x3_9e2f209e-adfa-43a0-9660-f9951cf233d9.jpg": 11149,
	"./ID00235_DKACADEMY_2_4x3_619aff0f-4319-4940-b4ba-82595b2eb68c.jpg": 43986,
	"./ID00235_DKACADEMY_3_4x3_9bc76788-087d-4770-91da-f93ee2e9fed9.jpg": 66942,
	"./ID00235_DKACADEMY_4_4x3_07713e3b-6840-4c58-a9b0-60bd3be98c26.jpg": 81051,
	"./ID00236_ScenewayPianoCentre_1_4x3_e649d37b-562d-474e-a7e4-e020a1f6a2c1.jpg": 51995,
	"./ID00236_ScenewayPianoCentre_2_4x3_ac12fa36-88c3-4040-95b5-70858ecba7a1.jpg": 86482,
	"./ID00237_MapleEducationGroup_1_4x3_935e9ed2-3994-4b4e-b4c1-27a76f3760c6.jpg": 56431,
	"./ID00237_MapleEducationGroup_2_4x3_c321d71b-530b-41f1-8b67-55fbe53177fc.jpg": 35139,
	"./ID00238_Inno-EduStudio_1_4x3_6fc4b8b4-9011-4483-a4de-fbdf0c0fe2c5.jpg": 98148,
	"./ID00239_WellEducationCentre_1_4x3_dfdff905-4ae6-4c63-81f4-5d60ecd0c896.jpg": 9068,
	"./ID00239_WellEducationCentre_2_4x3_2dc1b973-3c11-4444-be8b-64b893cbe274.jpg": 29886,
	"./ID00239_WellEducationCentre_3_4x3_0b21763d-5463-48b8-a484-1c266db55adc.jpg": 57676,
	"./ID00239_WellEducationCentre_4_4x3_0149e416-30a7-44b8-a284-9488d2c100ac.jpg": 34250,
	"./ID00240_SunnyClassroom_1_4x3_8bce2671-0f48-4455-aca8-09ec04aa46cb.jpg": 12092,
	"./ID00240_SunnyClassroom_2_4x3_af89a539-2ac4-4c46-b81a-b0edc1ee42df.jpg": 99958,
	"./ID00241_RONSCIENCE__1_4x3_d54cd689-7c75-4d78-a415-503f6a687183.jpg": 54185,
	"./ID00241_RONSCIENCE__2_4x3_bce0fb4e-afd0-4127-9c26-2958742079ef.jpg": 43033,
	"./ID00242_1_4x3_136e220c-20c9-437b-9608-b178a4a6623d.jpg": 29816,
	"./ID00242_2_4x3_1d2be8bf-7287-4b44-97e5-2e4b89fdec4b.jpg": 15921,
	"./ID00243_FancyGallery__1_4x3_a30367a1-a43b-4ac7-a234-7fd22e844a62.jpg": 13122,
	"./ID00243_FancyGallery__2_4x3_40372926-ded3-4dcb-b80d-0dd3b4eebd00.jpg": 9196,
	"./ID00243_FancyGallery__3_4x3_7174589a-a85e-424b-8580-ddd20ec0ce90.jpg": 32681,
	"./ID00243_FancyGallery__4_4x3_824a3dbb-0fc8-4252-8143-f5db04248886.jpg": 47646,
	"./ID00244_1_4x3_528424c7-57e7-47b5-901a-1aebc0f889f6.jpg": 57857,
	"./ID00244_2_4x3_b58ef3e3-b52a-4469-bd3a-1c76e4004b02.jpg": 50389,
	"./ID00244_3_4x3_a53253be-5adc-4d79-9ecf-6334d338089c.jpg": 58072,
	"./ID00245_LEVELUPLearningCenter_1_4x3_b307d4bd-0668-44ab-8837-4fe5a59f10b7.jpg": 90012,
	"./ID00245_LEVELUPLearningCenter_2_4x3_926d94c1-2fbd-4089-a6ed-e0a7b854f560.jpg": 26529,
	"./ID00246_1_4x3_2821e534-1fe0-49a9-b0d4-3cd2bf326ebd.jpg": 29479,
	"./ID00246_2_4x3_7a21c53d-9230-47e9-9bb6-54277ce16792.jpg": 4459,
	"./ID00247_SHANE__1_4x3_be96085a-b0af-4d3e-9935-d2c49bb0d320.jpg": 89050,
	"./ID00247_SHANE__2_4x3_904286f0-8dc9-4373-ac4e-f1cbd81a9a38.jpg": 44543,
	"./ID00247_SHANE__3_4x3_3a6f6810-70a0-4ee1-ac30-535612463e05.jpg": 71438,
	"./ID00247_SHANE__4_4x3_efa5f3b9-ce50-4c0b-89db-0d75dd31f80c.jpg": 78290,
	"./ID00248_1_4x3_fa1dfe0d-a131-4b3c-8724-967e1e5a189f.jpg": 51131,
	"./ID00248_2_4x3_c1f197f3-3315-42fd-983f-3ecd85eb990c.jpg": 21997,
	"./ID00248_3_4x3_8e94429e-ac10-4ee5-9fca-a20b39d95c00.jpg": 9381,
	"./ID00248_4_4x3_ee8f664b-7ec1-4769-a9c7-e4e67f911215.jpg": 46691,
	"./ID00249_MUSICOFFICE_1_4x3_9eecce8e-5180-49f8-b615-7e5bb6f373d5.jpg": 61094,
	"./ID00249_MUSICOFFICE_2_4x3_976c3633-1606-4fea-9bd6-a65119e6f752.jpg": 94976,
	"./ID00250_KATRINSCLASSROOM_1_4x3_35f46115-a4a4-4fbb-a240-0085999cc92e.jpg": 3735,
	"./ID00250_KATRINSCLASSROOM_2_4x3_84c1da37-be59-4077-b4b5-bf4dbabaa563.jpg": 11538,
	"./ID00251_1_4x3_8e4c21d0-3443-4c54-a8d5-27d16f70a5a9.jpg": 36900,
	"./ID00251_2_4x3_afa90708-6acf-4eed-bd67-3550cb1a14d3.jpg": 16576,
	"./ID00251_3_4x3_615bd8e4-d707-4883-be41-5cdb7c479268.jpg": 20326,
	"./ID00251_4_4x3_abb23c53-1c76-4236-afe3-4f5297c0f02b.jpg": 69951,
	"./ID00252_Childwalker__1_4x3_6846a090-44da-4199-bb22-29c99fc34cf6.jpg": 49464,
	"./ID00252_Childwalker__1_4x3_b602e23f-f9d9-4e49-91c6-4bfdf5ada066.jpg": 50305,
	"./ID00252_Childwalker__2_4x3_025c44ff-6b73-49fb-a547-a3d5c5c9acf1.jpg": 95606,
	"./ID00252_Childwalker__3_4x3_edc3b016-a134-4528-938a-bcd1667440de.jpg": 67522,
	"./ID00252_Childwalker__4_4x3_f78f61cb-0dba-4a71-8e08-f461558addb8.jpg": 55020,
	"./ID00253_MasterSnookerKingdom__1_4x3_fe04858a-9791-4c91-aef4-bf952835980a.jpg": 86304,
	"./ID00253_MasterSnookerKingdom__2_4x3_9c8b8401-bb2c-4818-a6a1-a09d9c483e7f.jpg": 31506,
	"./ID00254_4068be93d92740377c9dd1feb91b4a7e_b93e86e8-359d-4c1b-9ac2-41e5d2562e70.jpg": 45811,
	"./ID00255_WhatsAppImage2025-06-16at4.07.04PM_1__4x3_262b7577-8d73-47be-916c-61451b5f784a.jpg": 72519,
	"./ID00255_WhatsAppImage2025-06-16at4.07.04PM_2__4x3_3d76455f-351e-4e66-a1f5-8e3f84974808.jpg": 66079,
	"./ID00255_WhatsAppImage2025-06-16at4.07.04PM_3__4x3_68d2bed6-612f-465d-9e3e-196acf5c8739.jpg": 24436,
	"./ID00256_LuminantEducationCentre_WhatsAppImage2025-06-16at3.53.28PM.jpg": 51309,
	"./ID00256_LuminantEducationCentre_WhatsAppImage2025-06-16at3.53.28PM_1.jpg": 59925,
	"./ID00256_LuminantEducationCentre_WhatsAppImage2025-06-16at3.53.28PM_2.jpg": 92586,
	"./ID00256_LuminantEducationCentre_WhatsAppImage2025-06-16at3.53.28PM_3.jpg": 31591,
	"./ID00257_UniqueArtStudio_1_4x3_df16d3b5-d546-4183-85d4-1151e2746ade.jpg": 25466,
	"./ID00257_UniqueArtStudio_2_4x3_b746bc9e-c4cc-47ad-9b84-b3e4d9456755.jpg": 71417,
	"./ID00257_UniqueArtStudio_3_4x3_c9837a3b-8f2d-4926-bf9e-e6e1739bd1a2.jpg": 55654,
	"./ID00258_WILLTONWORKSHOP_2_4x3_98c9d393-53c6-4251-a564-04aba8970b36.jpg": 38471,
	"./ID00258_WILLTONWORKSHOP_3_4x3_9b4d71df-0b7b-4d28-8121-d1ee500a6b05.jpg": 21006,
	"./ID00258_WILLTONWORKSHOP_4_4x3_af4fd512-bd51-43ef-be91-8becd7927046.jpg": 94434,
	"./ID00258_WILLTONWORKSHOP_5_4x3_ecaa4221-849f-4c8d-9a49-9b9c02e699ea.jpg": 45632,
	"./ID00259_WONDERLANDWORKSHOP_1.jpg": 95419,
	"./ID00259_WONDERLANDWORKSHOP_2.jpg": 68972,
	"./ID00260_Morimokei_Design_Workshop__1_4x3_2e9a8c38-02ed-48d5-beb6-c42cb91829a3.jpg": 48164,
	"./ID00260_Morimokei_Design_Workshop__2_4x3_c111e224-a7ab-477a-8b34-d7bf7b103e15.jpg": 41407,
	"./ID00260_Morimokei_Design_Workshop__3_4x3_fc1a54a8-76cf-4c51-8b12-ca2f44bcac03.jpg": 32956,
	"./ID00260_Morimokei_Design_Workshop__4_4x3_f98b8f85-ddf2-4dad-b133-9360e4ac77ae.jpg": 85579,
	"./ID00261_1_ff7a09e8-4aaf-40de-868d-7bbeb98710ff.jpg": 73235,
	"./ID00261_2_f8d67b71-a02f-4c90-8a67-614ec9890aa0.jpg": 28439,
	"./ID00261_3_ecd28841-2996-4c53-a245-c6cd3aa01c7d.jpg": 39069,
	"./ID00261_4_c492542e-8cc6-483f-ac2f-cf07c8931384.jpg": 1260,
	"./ID00262_joyful_english_WhatsApp_Image_2025-06-13_at_2.17.45_PM.jpg": 49149,
	"./ID00262_joyful_english_WhatsApp_Image_2025-06-13_at_2.17.45_PM_1.jpg": 61285,
	"./ID00262_joyful_english_WhatsApp_Image_2025-06-13_at_2.17.46_PM.jpg": 87584,
	"./ID00262_joyful_english_WhatsApp_Image_2025-06-13_at_2.18.10_PM.jpg": 55824,
	"./ID00263_DoReMi_DoReMiMusicAcademy_1.jpg": 1005,
	"./ID00263_DoReMi_DoReMiMusicAcademy_2.jpg": 31778,
	"./ID00263_DoReMi_DoReMiMusicAcademy_3.jpg": 23487,
	"./ID00263_DoReMi_DoReMiMusicAcademy_4.jpg": 45204,
	"./ID00264_LITTLEWOODSTUDIO_1.jpg": 67843,
	"./ID00264_LITTLEWOODSTUDIO_2.jpg": 66036,
	"./ID00264_LITTLEWOODSTUDIO_3.jpg": 44561,
	"./ID00264_LITTLEWOODSTUDIO_4.jpg": 48002,
	"./ID00265_SMARTLearningCentre_1.jpg": 26297,
	"./ID00265_SMARTLearningCentre_2.jpg": 27630,
	"./ID00266_1_b0f40807-e6fa-4317-85ed-7554fa7f3d83.jpg": 35185,
	"./ID00266_2_0d706fdf-7cd7-4f34-808f-51131530718f.jpg": 431,
	"./ID00267_1_8c335c36-45f1-449a-a617-d143075e8b94.jpg": 67272,
	"./ID00267_2_39038281-3c15-40ce-8eca-70e78d83e24e.jpg": 20443,
	"./ID00268_ARTPALACE_1.jpg": 59739,
	"./ID00268_ARTPALACE_2.jpg": 82764,
	"./ID00269_1_e6f46783-9be7-4ce2-ba7e-c1de2d235777.jpg": 8020,
	"./ID00269_2_4c4f6c44-7da1-4d36-bea5-1f5fb3f9644a.jpg": 3972,
	"./ID00270_Leap_Taddepol_Education_Centre__1_4x3_4a1978d0-5e1a-43ca-8f95-2a5f16ad7ae8.jpg": 54328,
	"./ID00270_Leap_Taddepol_Education_Centre__2_4x3_7a1c4aae-65b5-46c4-b1e3-f041abb205ca.jpg": 17085,
	"./ID00271_1_e71f2a01-09e3-47e8-b1ed-5d66e265043e.jpg": 37813,
	"./ID00271_2_ec1d385a-0228-4d3c-8444-d3752653fc02.jpg": 5103,
	"./ID00272_1_11a33afe-df18-455a-8b6f-3d4a62782e04.jpg": 81032,
	"./ID00272_2_f9b24a2c-646e-4f6b-92cd-11302db46465.jpg": 25892,
	"./ID00272_3_dc32cc26-1c76-4e11-b7c5-bf18db07b73d.jpg": 51906,
	"./ID00272_4_1e2c937f-933d-4e22-a3da-5bf060323590.jpg": 96782,
	"./ID00273_1_a0bf600a-bcbc-4c7a-b63e-f1cb92c91cfb.jpg": 69292,
	"./ID00273_life-wide_fencing_1_4x3_2a173a75-adb4-4f69-8360-4447fab5ff73.jpg": 25227,
	"./ID00273_life-wide_fencing_2_4x3_d2038487-d6a5-485a-84f9-244d2a846a4a.jpg": 49747,
	"./ID00273_life-wide_fencing_3_4x3_c1a8d0fa-7887-4f37-b9d2-97a041f97dd8.jpg": 72875,
	"./ID00273_life-wide_fencing_4_4x3_6da602a4-b11b-49dd-95ae-343d4b0ed102.jpg": 53542,
	"./ID00274_UNIMINDSENGLISHEDUCATIONCENTRE_1_4x3_2cc47330-ee87-4846-897e-be83c0246721.jpg": 68080,
	"./ID00274_UNIMINDSENGLISHEDUCATIONCENTRE_2_4x3_34a5bca5-a571-4906-9904-90304ddab737.jpg": 53502,
	"./ID00274_UNIMINDSENGLISHEDUCATIONCENTRE_3_4x3_59434b2e-baa5-4ac7-bea6-66fc683a55f5.jpg": 3366,
	"./ID00274_UNIMINDSENGLISHEDUCATIONCENTRE_4_4x3_15881b0b-d5c5-4bae-9a54-25ffe4da48cd.jpg": 73542,
	"./ID00274_UNIMINDS_1.jpg": 40114,
	"./ID00274_UNIMINDS_2.jpg": 59069,
	"./ID00274_UNIMINDS_3.jpg": 33504,
	"./ID00275_1_8532cf74-de88-4ee2-9808-1092761ddd88.jpg": 22672,
	"./ID00275_2_03613549-bfe6-43c9-944a-cb5e7411f45c.jpg": 2066,
	"./ID00275_3_c618181a-8425-4db0-b5d2-8400cfff4130.jpg": 26180,
	"./ID00276_1_1558eb21-9663-4706-99cd-2ef47f7b61f7.jpg": 52353,
	"./ID00276_2_8bb1abc9-b925-4a76-946c-a3a19a8f3acc.jpg": 71468,
	"./ID00276_3_971a4a52-a94f-45f5-9687-8d4e52151175.jpg": 44985,
	"./ID00276_4_886453ef-ce19-471b-a3cb-e46c7c822016.jpg": 37061,
	"./ID00277_TutorialKingdom_1.jpg": 47425,
	"./ID00277_TutorialKingdom_2.jpg": 14166,
	"./ID00277_TutorialKingdom_3.jpg": 69427,
	"./ID00277_TutorialKingdom_4.jpg": 29120,
	"./ID00278_art_farm_1_4x3_c5140510-2323-4857-8e99-cb38955ceb5d.jpg": 90038,
	"./ID00278_art_farm_2_4x3_be5565ca-0ff0-4174-95c8-3bbddb4b24e5.jpg": 78879,
	"./ID00278_artfarm_1.jpg": 50288,
	"./ID00278_artfarm_2.jpg": 65247,
	"./ID00279_HUGTHEART_1.jpg": 16618,
	"./ID00279_HUGTHEART_2.jpg": 57109,
	"./ID00279_HUGTHEART_3.jpg": 95928,
	"./ID00279_HUGTHEART_4.jpg": 99531,
	"./ID00280_Sport_Impact_p.1_update2__Sport_Impact_p.1_update2.jpg": 32206,
	"./ID00280_Sport_Impact_p.1_update2__Sport_Impact_p.2_update2.jpg": 28877,
	"./ID00281_2026-2027.jpg": 48179,
	"./ID00282_555ac9d7105b433dbaf6338c3571cebc.thumbnail.0000000000.jpg": 34932,
	"./ID00282_c18bb1b67efe1b39ea051462d4b6261d.jpg": 54926,
	"./ID00283_2025-2026.jpg": 96013,
	"./ID00284_1_93128c16-dae5-4f35-a42d-96a3f95022f1.jpg": 21681,
	"./ID00285_HKST.jpg": 80661,
	"./ID00286_jpg.jpg": 92941,
	"./ID00287_71fe3187a1a89561a4376597455ed297_59bb4b65-1bae-472e-8c59-206fcd5d8263.jpg": 36681,
	"./ID00288_DADiEDUCATION__1.jpg": 78213,
	"./ID00288_DADiEDUCATION__2.jpg": 20986,
	"./ID00289_1_7288259f-0130-4527-8a49-1356a19749d1.jpg": 89122,
	"./ID00289_2_30c1a35a-3195-4688-80ea-c2bb875c7199.jpg": 10517,
	"./ID00289_3_8ea266a4-2477-4a90-a2e3-abbd611b8a0f.jpg": 93221,
	"./ID00289_4_f7222eea-4d11-48df-9010-3b57c58abf85.jpg": 98115,
	"./ID00290_2_45f3220a-c197-4dce-9cab-3b06c2112037.jpg": 25706,
	"./ID00291_findartsstudio_1.jpg": 5699,
	"./ID00291_findartsstudio_2.jpg": 59636,
	"./ID00291_findartsstudio_3.jpg": 31441,
	"./ID00291_findartsstudio_4.jpg": 46210,
	"./ID00291_findartsstudio_5.jpg": 54271,
	"./ID00292_JEANM.WONGSCHOOLOFBALLET_1.jpg": 99724,
	"./ID00292_JEANM.WONGSCHOOLOFBALLET_2.jpg": 76699,
	"./ID00293_CHEUNGTOKWAN_1.jpg": 10986,
	"./ID00293_CHEUNGTOKWAN_2.jpg": 61973,
	"./ID00294_JackJillTreehouse_1.jpg": 19235,
	"./ID00294_JackJillTreehouse_2.jpg": 89524,
	"./ID00294_JackJillTreehouse_3.jpg": 61329,
	"./ID00294_JackJillTreehouse_4.jpg": 76098,
	"./ID00295_TheLearningHub_1.jpg": 51206,
	"./ID00295_TheLearningHub_2.jpg": 67057,
	"./ID00295_TheLearningHub_3.jpg": 95252,
	"./ID00295_TheLearningHub_4.jpg": 89887,
	"./ID00296_AMEDoubleCheese_WhatsAppImage2025-05-28at9.24.11PM.jpg": 25117,
	"./ID00296_AMEDoubleCheese_WhatsAppImage2025-05-28at9.24.11PM_1.jpg": 56389,
	"./ID00296_AMEDoubleCheese_WhatsAppImage2025-05-28at9.24.11PM_2.jpg": 50138,
	"./ID00297_WhatsAppImage2025-05-28at12.24.41PM.jpg": 77349,
	"./ID00297_WhatsAppImage2025-05-28at12.24.41PM_1.jpg": 46749,
	"./ID00298_1_4x3_20c2efc2-016f-4e3b-bef0-d5490a5ffead.jpg": 94237,
	"./ID00299_24a06fe0a23820e8b370d1a1413faebb.jpg": 29462,
	"./ID00300_1_42b57e24-9f39-4eb0-919f-1aa42bb2f090.jpg": 16905,
	"./ID00301_1_764ef843-e9b0-45a0-8567-0c4b34e52bf3.jpg": 55610,
	"./ID00302_2025_60aa361d-8f41-43c7-ad7e-daa9293a9a7a.jpg": 95274,
	"./ID00303_2025_3818a16c-3f4c-4813-ac3e-43fe2a48c8bf.jpg": 96663,
	"./ID00304_0a90043a31c5325d12102f4396b8919f.jpg": 48856,
	"./ID00305_1_PinguEnglish.jpg": 80179,
	"./ID00305_2_PinguEnglish.jpg": 79530,
	"./ID00305_3_PinguEnglish.jpg": 30533,
	"./ID00305_4_PinguEnglish.jpg": 72980,
	"./ID00306_1_d94cf835-2770-4596-95d2-39ea0b762e05.jpg": 52708,
	"./ID00306_2_99d5cf4c-8b1d-4f7e-a33d-00a8fca60d6b.jpg": 89194,
	"./ID00306_3_e4afe1ba-aa84-4091-8cf8-2a57478f308d.jpg": 75712,
	"./ID00306_4_95f24a74-a34d-4cdc-b3e6-47dde4e22c16.jpg": 37653,
	"./ID00307_1_3178061e-9eb3-47c0-8a7e-ecaad13dfe48.jpg": 55174,
	"./ID00307_2_340a57ac-09f2-4c70-b66a-ed6d4baf805b.jpg": 80384,
	"./ID00307_3_a3269585-536d-4bd5-9b16-a5bcdfece118.jpg": 94054,
	"./ID00307_4_dce7e415-dc36-4957-bf57-1af78f00922c.jpg": 86895,
	"./ID00307_Learning_Times_Education_Centre_1_4x3_1c36ab7d-f757-4c31-be61-1c5bd5c100c2.jpg": 48924,
	"./ID00308_1_CHaNSir.jpg": 69181,
	"./ID00308_2_CHaNSir.jpg": 4954,
	"./ID00308_3_CHaNSir.jpg": 78175,
	"./ID00308_4_CHaNSir.jpg": 22356,
	"./ID00309_1_2c030950-8303-447a-933f-e3b9d7379f3f.jpg": 84621,
	"./ID00309_2_2f7292f9-65b9-41da-ac05-a44cdf2c1fc4.jpg": 73080,
	"./ID00310_1_211d4f92-8949-4155-8343-128ee2bc3c3d.jpg": 35089,
	"./ID00310_2_3e4068c8-d530-45df-87d0-19be50f905d6.jpg": 68036,
	"./ID00310_3_5355659d-5da4-433e-9483-3f7838aa04ac.jpg": 35384,
	"./ID00311_1_PLAYPLUSGROUP.jpg": 99154,
	"./ID00311_2_PLAYPLUSGROUP.jpg": 98857,
	"./ID00312_1_Mr.EnglishEducationCenter.jpg": 97266,
	"./ID00312_2_Mr.EnglishEducationCenter.jpg": 45409,
	"./ID00312_3_Mr.EnglishEducationCenter.jpg": 48,
	"./ID00312_6_Mr.EnglishEducationCenter.jpg": 79053,
	"./ID00313_1_PREMIUMEDUCATIONCENTRE.jpg": 25189,
	"./ID00313_2_PREMIUMEDUCATIONCENTRE.jpg": 62448,
	"./ID00313_3_PREMIUMEDUCATIONCENTRE.jpg": 94375,
	"./ID00313_4_PREMIUMEDUCATIONCENTRE.jpg": 73850,
	"./ID00314_1__STARKEYEDU.jpg": 6916,
	"./ID00314_2__STARKEYEDU.jpg": 33287,
	"./ID00314_3__STARKEYEDU.jpg": 63522,
	"./ID00314_4__STARKEYEDU.jpg": 76237,
	"./ID00315_1_07bd9f32-2852-4cfd-b281-ab5354731170.jpg": 93066,
	"./ID00315_1_510485b9-a5ef-46cc-bfcf-fface217338f.jpg": 63360,
	"./ID00316_1_YW_YWBadukAcademy.jpg": 90644,
	"./ID00316_2_YW_YWBadukAcademy.jpg": 62055,
	"./ID00316_3_YW_YWBadukAcademy.jpg": 57742,
	"./ID00316_4_YW_YWBadukAcademy.jpg": 81073,
	"./ID00317_2_16410e95-c4b0-4789-aff3-f89c8e711044.png": 65378,
	"./ID00317_3_ef449aa0-56d0-4259-8684-935c4b62d9b7.png": 58122,
	"./ID00317_4_7e014158-e433-4ec7-9086-940a1f5d3750.png": 67993,
	"./ID00317_Balloonies_Learning_Centre_1.jpg": 38488,
	"./ID00318_1_15693047-f927-4b03-a313-69ec81ebfbd3.jpg": 56418,
	"./ID00318_2_c364543b-b6fd-49df-91a8-717a93a99a78.jpg": 92276,
	"./ID00319_1__PROMIXLEARNINGCENTER.jpg": 59778,
	"./ID00320_1__StarkidsCreativeLearningCentre.jpg": 14489,
	"./ID00320_2__StarkidsCreativeLearningCentre.jpg": 42894,
	"./ID00320_3__StarkidsCreativeLearningCentre.jpg": 31659,
	"./ID00321_1_c82f5105-9ae1-4c77-93f6-b18210902e71.jpg": 83439,
	"./ID00321_2_2362d2aa-839f-4754-b435-222278429baf.jpg": 44941,
	"./ID00321_3_d86507dd-0d16-44ae-a931-0b70c2ad831f.jpg": 78578,
	"./ID00321_4_2b148ca7-3043-4ce5-9dc4-c12ac85b9cfb.jpg": 88171,
	"./ID00322_1_MUSHROOMLANDHKCREATIVEART.jpg": 29267,
	"./ID00322_2_MUSHROOMLANDHKCREATIVEART.jpg": 24584,
	"./ID00323_1__HONGKONGCREATIVEARTROOM.jpg": 81421,
	"./ID00323_2__HONGKONGCREATIVEARTROOM.jpg": 23232,
	"./ID00323_3__HONGKONGCREATIVEARTROOM.jpg": 87887,
	"./ID00323_4__HONGKONGCREATIVEARTROOM.jpg": 17098,
	"./ID00324_5__WILLINGLEARNINGCENTRE.jpg": 20767,
	"./ID00324_6__WILLINGLEARNINGCENTRE.jpg": 99806,
	"./ID00324_7__WILLINGLEARNINGCENTRE.jpg": 52069,
	"./ID00324_8__WILLINGLEARNINGCENTRE.jpg": 75444,
	"./ID00325_1_d352c347-e279-4fb3-b90a-e43f5b972d36.jpg": 58063,
	"./ID00325_2_1004f1d3-5de0-4d9e-b579-3d7150d9fc76.jpg": 50006,
	"./ID00325_3_1dcba8ec-5bab-46eb-a612-0eea195dc16e.jpg": 12349,
	"./ID00325_4_d2db3e66-914e-4ecb-9679-5b72fc9706b9.jpg": 56831,
	"./ID00326_1__Level-upEducationCentre.jpg": 28929,
	"./ID00326_2__Level-upEducationCentre.jpg": 26076,
	"./ID00326_3__Level-upEducationCentre.jpg": 11655,
	"./ID00326_4__Level-upEducationCentre.jpg": 74018,
	"./ID00327_2__ChunWingEducationCentre.jpg": 41996,
	"./ID00327_3__ChunWingEducationCentre.jpg": 29543,
	"./ID00327_4__ChunWingEducationCentre.jpg": 82930,
	"./ID00327_5__ChunWingEducationCentre.jpg": 88141,
	"./ID00328_1__DirectingEducation.jpg": 12183,
	"./ID00328_2__DirectingEducation.jpg": 99224,
	"./ID00328_3__DirectingEducation.jpg": 36677,
	"./ID00328_4__DirectingEducation.jpg": 85414,
	"./ID00329_1__WILLINGLEARNINGCENTRE.jpg": 78120,
	"./ID00329_1_new_doc_2025-05-21_16.03.42.jpg": 76928,
	"./ID00329_2__WILLINGLEARNINGCENTRE.jpg": 8461,
	"./ID00329_2_new_doc_2025-05-21_16.03.42.jpg": 82543,
	"./ID00330_1__YOHEYEDUCATION.jpg": 80029,
	"./ID00330_2__YOHEYEDUCATION.jpg": 97838,
	"./ID00330_3__YOHEYEDUCATION.jpg": 96723,
	"./ID00330_4__YOHEYEDUCATION.jpg": 63916,
	"./ID00331_1__YantoEducationCentre.jpg": 64886,
	"./ID00331_2__YantoEducationCentre.jpg": 89937,
	"./ID00331_3__YantoEducationCentre.jpg": 71020,
	"./ID00331_4__YantoEducationCentre.jpg": 2471,
	"./ID00332_1_f25a79ed-efc9-48b9-bb6a-d2ee1152899f.jpg": 19785,
	"./ID00333_1_2bf64f35-ca31-4842-a8d1-c9a5851e396a.jpg": 33421,
	"./ID00334_1_f3cd4d1b-01c0-4eac-b626-cd0f6acbc575.jpg": 83339,
	"./ID00334_2_1509478d-2116-4e7a-9a95-8697d818632f.jpg": 70738,
	"./ID00334_4_54cf0c17-dc4f-4595-8fb2-e7a742371980.jpg": 33064,
	"./ID00334_5_672bbd0f-a579-497c-a8a0-dc9c15745fde.jpg": 88136,
	"./ID00335_1_30266f8e-43e9-4ea1-8bf7-f597e1745125.jpg": 46559,
	"./ID00335_2_a4d7801f-8360-49a2-9b3a-3329672db239.jpg": 58741,
	"./ID00335_3_a0e21950-4c97-45d6-acdf-790cf0a664a1.jpg": 90714,
	"./ID00335_4_e85dfcde-19b5-4aec-8b64-1f638d4cebbb.jpg": 16660,
	"./ID00336_GoingClass_poster_template_A4_portirat.jpg": 70141,
	"./ID00337_1_EasyALearningCentre.jpg": 19257,
	"./ID00337_2_EasyALearningCentre.jpg": 31150,
	"./ID00337_3_EasyALearningCentre.jpg": 98327,
	"./ID00337_4_EasyALearningCentre.jpg": 63548,
	"./ID00338_1_e1b52743-6772-4a0f-8b11-4b93bab5ab6a.jpg": 75010,
	"./ID00339_1_Easylearning.jpg": 18575,
	"./ID00339_2_Easylearning.jpg": 13030,
	"./ID00340_1_c0fa2d8a-10c6-4a27-9ec5-00bab50a6dfe.jpg": 75488,
	"./ID00340_2_7cd69163-2ad1-47f1-9e59-02ccddf7fa29.jpg": 16170,
	"./ID00340_summer.jpg": 57340,
	"./ID00341_1_bbfc48f1-5f9a-4da0-b49a-32c9a31e3bfb.jpg": 5258,
	"./ID00342_GoingClasspostertemplateA4portirat_84522f25-386f-491b-8f5e-65da6f9e6e4c.jpg": 60550,
	"./ID00343_1_talenttoshine.jpg": 36270,
	"./ID00343_2_talenttoshine.jpg": 79245,
	"./ID00343_3_talenttoshine.jpg": 49116,
	"./ID00343_4_talenttoshine.jpg": 43883,
	"./ID00344_1_platformartjamming.jpg": 71056,
	"./ID00344_3_platformartjamming.jpg": 39866,
	"./ID00344_4_platformartjamming.jpg": 32623,
	"./ID00344_5_platformartjamming.jpg": 10924,
	"./ID00345_1_dbf9c0e4-ec0d-43aa-9c49-1cdc4a6870ba.jpg": 18407,
	"./ID00345_2_9d231e0f-0ac3-4f4b-97f2-4d790df2e3a8.jpg": 34217,
	"./ID00345_3_40ce2b74-376e-4f94-8261-588ca9988990.jpg": 26221,
	"./ID00345_4_56399efc-df86-4f23-a1dd-19ce3e9e8f58.jpg": 74105,
	"./ID00346_1_15605e9c-f6b3-440a-8277-01152b45cf0f.jpg": 58370,
	"./ID00346_2_425615fe-25d6-412f-aca5-d84d4538a191.jpg": 90874,
	"./ID00346_3_aaac2d87-1c53-468c-87a1-46469650cf23.jpg": 22522,
	"./ID00346_4_a640cd03-ea07-4bd7-8544-a3d97f315daa.jpg": 18035,
	"./ID00347_1_efd96c67-e760-4f04-90c0-d79dfaefc80f.jpg": 53585,
	"./ID00348_1_yudongstudio.jpg": 27797,
	"./ID00349_1_fb95f19c-cd9d-4c8a-acb3-30bbd0cdeaba.jpg": 65435,
	"./ID00349_1_fencing.jpg": 5352,
	"./ID00349_2_5ffe4ab4-abdb-4c8d-872a-652335c24cb1.jpg": 87467,
	"./ID00350_1_800b9cd5-708a-4099-b110-6d3ce76c7fde.jpg": 84452,
	"./ID00350_1_dcd1afe6-d878-4d7e-839f-64caf6e3e9e6.jpg": 88104,
	"./ID00351_1_8cba7e29-8820-4660-8445-d5e5afa9b205.jpg": 19486,
	"./ID00352_1_fancyart.jpg": 81534,
	"./ID00353_1_d7d8254d-c9aa-4727-a92d-e989f5ef7d7d.jpg": 35038,
	"./ID00353_1_joyous.jpg": 36138,
	"./ID00353_2_0413a119-3816-4cfd-868c-64273f1d2e70.jpg": 23137,
	"./ID00354_6c6579463d86d66fbe36d94113953816.jpg": 39505,
	"./ID00355_2_ec673a0e-a4de-419d-8d96-0e6b02ffb1ce.jpg": 13767,
	"./ID00356_1_beeebf75-ae35-4194-ac6a-4ac095f14535.jpg": 3676,
	"./ID00357_1_48d3b295-1cde-42c9-a95e-5880ff578f0a.jpg": 80515,
	"./ID00358_WhatsAppImage2025-04-29at1.04.41PM.jpg": 57089,
	"./ID00358_WhatsAppImage2025-04-29at1.04.42PM.jpg": 84206,
	"./ID00358_WhatsAppImage2025-04-29at1.04.43PM.jpg": 55715,
	"./ID00358_WhatsAppImage2025-04-29at1.04.43PM_1.jpg": 81783,
	"./ID00359_1_455bad29-353d-42ce-8fc1-bb37b0e3b23f.jpg": 81961,
	"./ID00360_1_7d8f6cf0-d4f0-440e-b083-3d82b7773a77.jpg": 27519,
	"./ID00361_1_8255bdba-30c4-4e9a-8e29-e2c6a2cccbfe.jpg": 18591,
	"./ID00361_2_3ca1bdf7-aa3f-4681-84ea-81c2e8fba0dc.jpg": 36163,
	"./ID00361_3_ce69f05e-e294-4499-87d3-4c1f2f14c073.jpg": 83905,
	"./ID00361_4_c84a6021-922c-4378-9078-38edf46ccfa8.jpg": 32693,
	"./ID00362_HKMU1.png": 21941,
	"./ID00363_CMT_1.jpg": 9258,
	"./ID00363_CMT_2.jpg": 49749,
	"./ID00364_53b01a920b7dea00fdbc7fdcb79ed15f.jpg": 25125,
	"./ID00365_poster.jpg": 10277,
	"./ID00366_1_b0ad4b7e-4698-4843-bd17-b6105a441062.jpg": 87544,
	"./ID00366_2_0b2cfbc9-e358-42ca-bb79-d00069809439.jpg": 95894,
	"./ID00367_1_growsparkids.jpg": 98942,
	"./ID00367_2_growsparkids.jpg": 68375,
	"./ID00367_3_growsparkids.jpg": 26612,
	"./ID00367_4_growsparkids.jpg": 925,
	"./ID00368_1_CPDA.jpg": 58237,
	"./ID00368_2_CPDA.jpg": 6808,
	"./ID00368_3_CPDA.jpg": 32635,
	"./ID00368_4_CPDA.jpg": 68518,
	"./ID00369_1_Eggie.jpg": 35565,
	"./ID00369_2_Eggie.jpg": 90530,
	"./ID00369_3_Eggie.jpg": 86483,
	"./ID00369_4_Eggie.jpg": 3344,
	"./ID00370_1_GranvilleCampusEnglishCenter.jpg": 66734,
	"./ID00370_2_GranvilleCampusEnglishCenter.jpg": 81601,
	"./ID00370_summer_2025.jpg": 78365,
	"./ID00371_1_MACEDUCATIONCENTRE.jpg": 89523,
	"./ID00371_2_MACEDUCATIONCENTRE.jpg": 98214,
	"./ID00371_3_MACEDUCATIONCENTRE.jpg": 71469,
	"./ID00371_4_MACEDUCATIONCENTRE.jpg": 42712,
	"./ID00372_1_ALPINEEDUCATION.jpg": 65193,
	"./ID00372_2_ALPINEEDUCATION.jpg": 31450,
	"./ID00372_3_ALPINEEDUCATION.jpg": 62671,
	"./ID00372_4_ALPINEEDUCATION.jpg": 43288,
	"./ID00373_1_directacademic.jpg": 31075,
	"./ID00373_2_directacademic.jpg": 93466,
	"./ID00373_3_directacademic.jpg": 58685,
	"./ID00373_4_directacademic.jpg": 50932,
	"./ID00374_1_WISDOMLEADEDUCATIONCENTRE.jpg": 14492,
	"./ID00375_1_APEXBrilliantEducationCentre.jpg": 33547,
	"./ID00375_2_APEXBrilliantEducationCentre.jpg": 26494,
	"./ID00376_1__i-EssenceEducationCentre.jpg": 29264,
	"./ID00376_2__i-EssenceEducationCentre.jpg": 74407,
	"./ID00376_3__i-EssenceEducationCentre.jpg": 41210,
	"./ID00376_4__i-EssenceEducationCentre.jpg": 24057,
	"./ID00377_1_MATHLOGICEDUCATIONCENTRE.jpg": 75878,
	"./ID00377_2_MATHLOGICEDUCATIONCENTRE.jpg": 11943,
	"./ID00378_1_newdoc2025-04-2818.25.27.jpg": 70662,
	"./ID00378_2_newdoc2025-04-2818.25.27.jpg": 47119,
	"./ID00378_3_newdoc2025-04-2818.25.27.jpg": 66404,
	"./ID00378_4_newdoc2025-04-2818.25.27.jpg": 57365,
	"./ID00379_1_megamatheducation.jpg": 82141,
	"./ID00379_2_megamatheducation.jpg": 44838,
	"./ID00379_3_megamatheducation.jpg": 86975,
	"./ID00379_4_megamatheducation.jpg": 65400,
	"./ID00380_1_a53966a1-d0ae-4b52-ae5e-69751374dd60.jpg": 28790,
	"./ID00380_2_7c3e3db6-d3a6-49f1-856b-a98cd40868f4.jpg": 49415,
	"./ID00380_3_b9412771-6b9d-4914-abd2-3c8e451d449f.jpg": 43075,
	"./ID00380_4_1106b386-8467-4ed0-8029-79c919b4fb02.jpg": 878,
	"./ID00380_E__WhatsApp_Image_2025-07-16_at_6.28.02_PM_4x3_3eda799a-e17a-498f-a974-c92c35ab23f2.jpg": 18002,
	"./ID00381_1_JoyMusic.jpg": 71863,
	"./ID00381_2_JoyMusic.jpg": 27986,
	"./ID00381_3_JoyMusic.jpg": 30565,
	"./ID00381_4_JoyMusic.jpg": 40,
	"./ID00382_1_2da765ea-0fee-41d9-b860-38b4de1b6707.jpg": 77595,
	"./ID00382_2_14e9c1ce-f3fe-4a72-8c0b-c64c6f0ba632.jpg": 88858,
	"./ID00383_2_30103df4-85a2-463c-aaba-ed80adbc152b.jpg": 27314,
	"./ID00383_3_8fe8fa71-09b7-48cb-a74a-5eb7c4d59323.jpg": 99384,
	"./ID00383_4_c2287be5-dbc2-4c58-816e-454b69095e90.jpg": 40500,
	"./ID00383_5_b7301019-1585-4b83-bbd8-8b6553648780.jpg": 88891,
	"./ID00384_1_LOVEKINGDOMEDUCATION.jpg": 24064,
	"./ID00384_2_LOVEKINGDOMEDUCATION.jpg": 56709,
	"./ID00384_3_LOVEKINGDOMEDUCATION.jpg": 82674,
	"./ID00384_4_LOVEKINGDOMEDUCATION.jpg": 33455,
	"./ID00385_tiny_talents_1_4x3_ef4f7980-fa2f-44cc-be3b-a386c9286212.jpg": 52532,
	"./ID00385_tiny_talents_2_4x3_3008c5d0-7764-4e8e-93ea-bd5d9d4dd778.jpg": 86647,
	"./ID00385_tiny_talents_3_4x3_83f95ee3-b3e5-4657-b026-51e1bd5e38e0.jpg": 79646,
	"./ID00386_1_KiddoCornerEducationCentre.jpg": 38166,
	"./ID00386_2_KiddoCornerEducationCentre.jpg": 87339,
	"./ID00386_3_KiddoCornerEducationCentre.jpg": 67828,
	"./ID00386_4_KiddoCornerEducationCentre.jpg": 51193,
	"./ID00387_1_COOLMOONARTSTUDIO.jpg": 83449,
	"./ID00387_2_COOLMOONARTSTUDIO.jpg": 45790,
	"./ID00388_1_0de80e15-6da2-49a7-93d1-af8743934bdc.jpg": 71840,
	"./ID00388_2_9c49c1b4-19ce-46c4-8040-436c280f6235.jpg": 562,
	"./ID00388_3_fe603bcc-4001-4916-8624-f3e81a56b70e.jpg": 84167,
	"./ID00388_4_f447fb37-5c7f-41b7-827c-fc72ea15df5a.jpg": 98952,
	"./ID00389_1_5ef11b5f-b2ca-4ba8-bb79-3671d9dad897.jpg": 44835,
	"./ID00389_2_f30849da-9417-4c96-b6fe-69288d6a43a1.jpg": 67853,
	"./ID00390_1_PartyArt_PartyArt.jpg": 40969,
	"./ID00390_2_PartyArt.jpg": 61872,
	"./ID00391_1_mr.wildartstudio.jpg": 43927,
	"./ID00391_2_mr.wildartstudio.jpg": 33474,
	"./ID00391_3_mr.wildartstudio.jpg": 60617,
	"./ID00391_4_mr.wildartstudio.jpg": 38060,
	"./ID00392_WhatsApp_Image_2025-07-15_at_2.05.10_PM_1__4x3_28c7b756-f928-4d99-98f4-50199e0cf915.jpg": 57625,
	"./ID00392_WhatsApp_Image_2025-07-15_at_2.05.10_PM_4x3_38b4f3bb-77c6-428e-9dac-222b74b59bca.jpg": 70477,
	"./ID00392_WhatsApp_Image_2025-07-15_at_2.05.11_PM_1__4x3_26cc7810-ff8a-47a4-98bc-e7879f67198e.jpg": 30412,
	"./ID00392_WhatsApp_Image_2025-07-15_at_2.05.11_PM_4x3_d61a4c45-712f-47ac-8da5-8b2f73791d0a.jpg": 78333,
	"./ID00393_1_f72d55c0-23f0-4626-8a5a-49ad5e04f610.jpg": 46678,
	"./ID00393_2_3f97b9c4-a7c6-4418-a968-f7bdc979b525.jpg": 46862,
	"./ID00394_1_5625f6ed-509f-47dc-911a-6a243a84dd43.jpg": 79611,
	"./ID00394_2_8d006299-9c64-4990-9638-a30b47a08582.jpg": 1080,
	"./ID00394_3_8212b1d0-f8e0-4d45-9e8f-1aaaad748641.jpg": 6783,
	"./ID00394_4_3d3bfe15-2692-4d48-9809-faf137a78171.jpg": 25216,
	"./ID00395_1_logictutorial.jpg": 68305,
	"./ID00395_2_logictutorial.jpg": 15850,
	"./ID00395_3_logictutorial.jpg": 18195,
	"./ID00395_4_logictutorial.jpg": 19772,
	"./ID00396_1_mathhouse.jpg": 94308,
	"./ID00396_2_mathhouse.jpg": 32671,
	"./ID00396_3_mathhouse.jpg": 94430,
	"./ID00396_4_mathhouse.jpg": 377,
	"./ID00397_1_4b04662e-c3fc-4f93-be76-ab3d8ea70d33.jpg": 83870,
	"./ID00397_2_dc1d4ad6-a46d-45b6-a9ae-be9e83a79997.jpg": 42315,
	"./ID00398_1_RAINWORKSHOP.jpg": 33435,
	"./ID00398_2_RAINWORKSHOP.jpg": 12606,
	"./ID00398_3_RAINWORKSHOP.jpg": 2629,
	"./ID00399_1_bf303e52-a5d7-4686-8db6-fb62599f00ba.jpg": 89502,
	"./ID00399_2_1b20c03d-d5b5-4d32-b3d1-4ae254953201.jpg": 99441,
	"./ID00400_1_Torcheducation.jpg": 23850,
	"./ID00400_2_Torcheducation.jpg": 62839,
	"./ID00400_3_Torcheducation.jpg": 10052,
	"./ID00400_4_Torcheducation.jpg": 11769,
	"./ID00401_1_ec6fbef4-d6c2-4c59-84cc-f41a481dcc6f.jpg": 20585,
	"./ID00401_2_e723311e-8e1f-4a40-bbb7-70b0749cad22.jpg": 32892,
	"./ID00402_1_e94cf09f-6548-4034-8c54-18670c735251.jpg": 17910,
	"./ID00402_2_bbfef812-89f2-4e01-b475-d5690ffbf5d3.jpg": 57780,
	"./ID00402_3_d49cb605-1e64-4d1a-b40b-5a5962731ace.jpg": 82301,
	"./ID00403_1_DCAcademic.jpg": 71189,
	"./ID00403_WhatsApp_Image_2025-04-17_at_8.11.48_PM.jpg": 50048,
	"./ID00404_1_24c1af7a-12c5-4cdf-ae3e-832f75b972ba.jpg": 97669,
	"./ID00404_2_308801cc-4a52-4fa2-9e2f-4b659e0fe6f5.jpg": 8827,
	"./ID00405_1_CongratsLearningCentre.jpg": 41717,
	"./ID00405_2_CongratsLearningCentre.jpg": 37684,
	"./ID00406_1_enjoy_education.jpg": 73068,
	"./ID00407_1_8671b3ec-2fda-49ad-957a-fc18043b8df2.jpg": 96774,
	"./ID00407_2_df2e87c8-266c-49db-930f-27f8436e4760.jpg": 25137,
	"./ID00408_1_KEducation.jpg": 47809,
	"./ID00408_2_KEducation.jpg": 27968,
	"./ID00409_1_new_doc_2025-04-28_18.30.36.jpg": 5314,
	"./ID00409_2_new_doc_2025-04-28_18.30.36.jpg": 9421,
	"./ID00409_3_new_doc_2025-04-28_18.30.36.jpg": 96572,
	"./ID00409_4_new_doc_2025-04-28_18.30.36.jpg": 62191,
	"./ID00410_1__STANDWELL.jpg": 94610,
	"./ID00410_2__STANDWELL.jpg": 60175,
	"./ID00411_GoingClasspostertemplateA4portirat_9d1ce6ca-1b4c-4074-b5b9-d4500cb213e8.jpg": 69170,
	"./ID00412_1_3f799998-e4c2-4b60-8a84-1081e21df813.jpg": 1802,
	"./ID00412_2_1a2c15d0-834c-4fb5-b4b7-9cb29ba57253.jpg": 16645,
	"./ID00412_3_4c584747-5f04-4863-a484-485499919f38.jpg": 23047,
	"./ID00412_4_248fbc45-46da-4f76-9100-134f21fb1744.jpg": 40385,
	"./ID00413_1_6e034af0-4a2f-4097-b9e5-457aefd086cb.jpg": 91588,
	"./ID00414_1_2bd18730-50b2-4e43-8da5-3d1177fd9a14.jpg": 68271,
	"./ID00415_1_99797125-1595-4384-a60e-342b3cef9342.jpg": 41474,
	"./ID00416_1_7f681328-941a-492b-a6eb-cc47562a54e4.jpg": 32711,
	"./ID00417_1_c382231f-593d-4d05-8b27-df0634d47e6d.jpg": 85464,
	"./ID00418_1_d7b92750-c856-4c58-a69d-86f2fcd99aac.jpg": 6683,
	"./ID00418_5_46dde845-d300-4469-9eb0-d9f04a8b7bcc.jpg": 93236,
	"./ID00418_6_1d05b5fd-4343-4bdd-ae19-d7b56a05f4e9.jpg": 91061,
	"./ID00419_1_GeniusArt.jpg": 74624,
	"./ID00419_2_8b2552c1-60bf-4615-8274-9c9b5823ab6d.jpg": 7942,
	"./ID00420_2_cc2da905-2ba8-467d-b8a5-58c099390658.jpg": 98901,
	"./ID00420_3_7c982344-03a9-4348-a3e1-59a58afc10a8.jpg": 88020,
	"./ID00420_4_4e2aff55-1acd-45ed-917e-69a9da014ee0.jpg": 68581,
	"./ID00420_5_febffeb8-5eed-42e9-9882-3aec678201b1.jpg": 59179,
	"./ID00421_1_f45e4842-0aa2-417c-bf55-7e5653746feb.jpg": 36061,
	"./ID00421_2_3efb0f91-0c20-42b5-865f-bd3892c14290.jpg": 42102,
	"./ID00422_1_42d71b48-8dbb-4196-ace1-6cba477a3297.jpg": 4094,
	"./ID00422_2_903c3a5b-607c-4653-a83a-f8f108fb5b6b.jpg": 91440,
	"./ID00422_3_342af824-6aab-497b-93ba-a60f0c07ef9f.jpg": 42588,
	"./ID00422_4_a2bd9d70-b2c8-40c2-8fc9-944f2ca4e4df.jpg": 15408,
	"./ID00423_1_Enchantedlearning.jpg": 25371,
	"./ID00423_2_Enchantedlearning.jpg": 23584,
	"./ID00423_3_Enchantedlearning.jpg": 95077,
	"./ID00423_4_Enchantedlearning.jpg": 74730,
	"./ID00424_1__SAPLING.jpg": 329,
	"./ID00424_2__SAPLING.jpg": 31500,
	"./ID00424_3__SAPLING.jpg": 10311,
	"./ID00424_4__SAPLING.jpg": 24946,
	"./ID00425_1_75df9e98-ea05-4885-a974-c07c2acf6a0f.jpg": 8379,
	"./ID00425_3_PROENGLISH.jpg": 33878,
	"./ID00425_4_PROENGLISH.jpg": 38963,
	"./ID00425_5_PROENGLISH.jpg": 24488,
	"./ID00426_1__Think-InEducation.jpg": 7697,
	"./ID00426_2__Think-InEducation.jpg": 92572,
	"./ID00426_3__Think-InEducation.jpg": 94839,
	"./ID00426_4__Think-InEducation.jpg": 84354,
	"./ID00427_1__CHARISEDUCATION.jpg": 93614,
	"./ID00427_2__CHARISEDUCATION.jpg": 96623,
	"./ID00427_3__CHARISEDUCATION.jpg": 90276,
	"./ID00427_4__CHARISEDUCATION.jpg": 88413,
	"./ID00428_WhatsApp_Image_2025-06-11_at_3.04.01_PM.jpg": 12629,
	"./ID00428_WhatsApp_Image_2025-06-11_at_3.04.02_PM_2.jpg": 55959,
	"./ID00428_WhatsApp_Image_2025-06-11_at_3.04.02_PM_3.jpg": 61498,
	"./ID00428_WhatsApp_Image_2025-06-11_at_3.04.02_PM_4.jpg": 46985,
	"./ID00429_1_7489b1c3-4c4e-47ef-ab8a-4f4377b69570.jpg": 69882,
	"./ID00429_2_173458d7-6050-4a86-a47e-7fd59036b473.jpg": 57720,
	"./ID00429_3_9b80abcd-34b8-40ae-8704-48cccecdba1a.jpg": 29368,
	"./ID00429_4_6fc135fc-09ef-4b94-a863-363f79973cef.jpg": 64189,
	"./ID00430_1__ShirmiLearningCentre.jpg": 8591,
	"./ID00430_2__ShirmiLearningCentre.jpg": 4060,
	"./ID00430_3__ShirmiLearningCentre.jpg": 16549,
	"./ID00430_4__ShirmiLearningCentre.jpg": 9858,
	"./ID00431_1_1759cb7e-d411-48ad-b18a-6bd100f0d955.jpg": 29424,
	"./ID00431_2_f71f4977-a7d8-435b-add8-ae216ea12ebb.jpg": 27748,
	"./ID00431_3_7ae45389-0ac9-44d7-8324-094b6d7336f1.jpg": 1154,
	"./ID00431_4_3408ea42-e4d6-492f-971e-67e59b931f20.jpg": 277,
	"./ID00432_1_imath_32858943-4135-4291-a28b-b4142b1499f9.jpg": 96324,
	"./ID00432_2_imath_bb114230-488b-419a-8888-8d6c55deceb6.jpg": 82314,
	"./ID00432_3_imath_29a62abd-4da0-4e6a-a038-f794504a42f4.jpg": 76381,
	"./ID00432_4_imath_f34126d5-e052-4288-b9b8-bee11720735e.jpg": 11131,
	"./ID00433_GoingClass_poster_template_A4_portirat_2.jpg": 65620,
	"./ID00434_GoingClasspostertemplateA4portirat_fc6b3cc9-066d-45a1-bcb0-2882c638d5fe.jpg": 82950,
	"./ID00435_1_a9444b46-4068-4946-ac9f-3e785796ee73.jpg": 71446,
	"./ID00436_1_KIDSMARTSCHOOL.jpg": 10524,
	"./ID00436_2_KIDSMARTSCHOOL.jpg": 31373,
	"./ID00436_3_KIDSMARTSCHOOL.jpg": 96262,
	"./ID00436_4_KIDSMARTSCHOOL.jpg": 7215,
	"./ID00436_kid_smart_school_1.jpg": 14282,
	"./ID00436_kid_smart_school_2.jpg": 24181,
	"./ID00436_kid_smart_school_3.jpg": 16312,
	"./ID00437_1_09a0d993-71c4-4f73-b666-c56111acbc6f.jpg": 448,
	"./ID00437_2_362999df-4dfc-489a-887a-7946ae8ed0dd.jpg": 34145,
	"./ID00437_3_c188d14e-d917-43ee-83dd-aa475b3a61b4.jpg": 85432,
	"./ID00437_4_bfc240e8-dda6-4845-88de-e6898d577e91.jpg": 32524,
	"./ID00437_5_2f24183f-bdd4-4eb6-bb63-92b78ba13c8a.jpg": 68121,
	"./ID00438_1_funfun.jpg": 81443,
	"./ID00438_2_funfun.jpg": 31522,
	"./ID00438_3_funfun.jpg": 84149,
	"./ID00438_4_funfun.jpg": 58196,
	"./ID00439_1_SERENDIPMUSICSTUDIO.jpg": 10553,
	"./ID00439_2_SERENDIPMUSICSTUDIO.jpg": 31430,
	"./ID00440_1_TIFFANYLAUCHILDRENCHOIR.jpg": 12489,
	"./ID00440_2_TIFFANYLAUCHILDRENCHOIR.jpg": 58218,
	"./ID00440_3_TIFFANYLAUCHILDRENCHOIR.jpg": 33067,
	"./ID00440_4_TIFFANYLAUCHILDRENCHOIR.jpg": 71276,
	"./ID00441_1_3f54215d-83a5-45d6-a8e6-b3f336824a6d.jpg": 72181,
	"./ID00441_2_a32204b1-76da-44a8-8173-61deee319ba1.jpg": 31632,
	"./ID00441_3_296106e1-1e79-4bdc-9c45-574886e9860d.jpg": 17601,
	"./ID00441_4_7da04d02-fb30-48ea-8ce2-a6efd347e815.jpg": 38508,
	"./ID00442_1__VineyardEducationCentre.jpg": 14286,
	"./ID00442_2__VineyardEducationCentre.jpg": 65175,
	"./ID00442_3__VineyardEducationCentre.jpg": 82524,
	"./ID00442_4__VineyardEducationCentre.jpg": 92645,
	"./ID00443_1_29ac671e-8fb3-455d-8612-5c0cffceb56c.jpg": 32220,
	"./ID00443_2_b2b75037-ff92-4950-bba8-4307a3d6836b.jpg": 58143,
	"./ID00443_3_a5b21130-c3fa-4d66-aace-9122ca34d69c.jpg": 3784,
	"./ID00443_4_38f2657d-f39c-4518-a222-e639d49e70d2.jpg": 76329,
	"./ID00444_1_APLUZA.jpg": 65015,
	"./ID00444_2_APLUZA.jpg": 11798,
	"./ID00444_3_APLUZA.jpg": 24069,
	"./ID00444_4_APLUZA.jpg": 58004,
	"./ID00445_1_e936c9bc-51af-43a4-89e5-8dff4f480abd.jpg": 73284,
	"./ID00445_2_5a64762f-3149-4484-9b88-c869627b772a.jpg": 63879,
	"./ID00446_1_03c0ac69-3f33-4193-9427-bc3c56b4ba43.jpg": 29045,
	"./ID00446_2_2193d9f7-2323-4c12-995e-de60a8ee169c.jpg": 43951,
	"./ID00446_3_a0088497-0563-4d03-98aa-3f726417cc4f.jpg": 89571,
	"./ID00446_4_feae5651-a3fa-462f-b6c2-cd988163051d.jpg": 68263,
	"./ID00447_1_8e55f2f7-d761-4464-a82d-fa91052d3482.jpg": 24501,
	"./ID00447_2_7950c044-6511-4fa3-b43d-b11594785cbb.jpg": 14363,
	"./ID00448_1_34503c26-a5c9-4cdf-a746-6aaa774eb8b0.jpg": 43153,
	"./ID00448_2_60fb62d9-a408-443d-9d46-1d3f3eb101f3.jpg": 32508,
	"./ID00448_3_ff6b7c8f-6c1e-4f3a-9010-e0286e26010a.jpg": 48453,
	"./ID00448_4_a8c9cf7c-5432-4785-9e4d-1191ee468699.jpg": 34119,
	"./ID00449_1_d20a375c-af53-4087-85ba-287931e11ed7.jpg": 40343,
	"./ID00449_2_204eeee5-a8aa-4cfc-8f29-41f14d62a532.jpg": 81606,
	"./ID00449_3_7539d7cc-8da9-4def-bf80-e884cae4854c.jpg": 85799,
	"./ID00449_4_c44c19a3-cf0c-4b6f-9c90-61cb1763e8eb.jpg": 77162,
	"./ID00450_1_KMeducation.jpg": 73285,
	"./ID00450_2_KMeducation.jpg": 26702,
	"./ID00450_4_KMeducation.jpg": 24168,
	"./ID00450_5_KMeducation.jpg": 80905,
	"./ID00451_1_c7947f2d-ca48-4f16-809e-8ee58b28ce10.jpg": 8413,
	"./ID00451_2_a7298252-258f-45f8-a32c-6429d257684b.jpg": 6865,
	"./ID00452_GMCmusic_1_4x3_edd06b53-fc46-44d9-a881-4f6aee4a2c09.jpg": 22695,
	"./ID00452_GMCmusic_2_4x3_5c89962c-89b8-4351-bfc3-55b05f09e673.jpg": 46093,
	"./ID00452_GMCmusic_3_4x3_9fd8b2ce-4743-47c7-a1dc-f5db29c82e2a.jpg": 47634,
	"./ID00452_GMCmusic_4_4x3_b128df84-12b9-42f2-8ba0-097e70be7650.jpg": 81844,
	"./ID00453_1__1.jpg": 96162,
	"./ID00453_2__1.jpg": 39795,
	"./ID00453_3__1.jpg": 83288,
	"./ID00453_5_f519b753-b3c6-4b46-a28c-07632971ff0f.jpg": 31757,
	"./ID00454_GoingClasspostertemplateA4portirat_2c067c41-6489-47b8-b541-374bb05f666a.jpg": 84335,
	"./ID00455_GAPSK.jpg": 32444,
	"./ID00456_66a537b8039a3d019170c62d1be1b794.jpg": 78465,
	"./ID00457_85096e_b3df3e95dc2d4fa397969f7e9d3800bc_mv2.jpg": 65075,
	"./ID00458_2_3_-2.jpg": 85493,
	"./ID00458_3-legged_Easter_screen_Vertical_v2_OP-min.jpg": 16766,
	"./ID00458_Social_Post_star_1080x1450px-04.jpg": 40717,
	"./ID00458_Social_Post_star_1080x1450px-06.jpg": 12223,
	"./ID00459_1__ConceptEducation.jpg": 57035,
	"./ID00459_2__ConceptEducation.jpg": 55048,
	"./ID00459_3__ConceptEducation.jpg": 47077,
	"./ID00459_4__ConceptEducation.jpg": 76370,
	"./ID00460_1__JoyKidsEducationCentre.jpg": 63197,
	"./ID00460_2__JoyKidsEducationCentre.jpg": 60002,
	"./ID00460_3__JoyKidsEducationCentre.jpg": 47032,
	"./ID00460_4__JoyKidsEducationCentre.jpg": 51184,
	"./ID00461_1_256b478b-dcfc-4119-9946-ea2840c98395.jpg": 59929,
	"./ID00461_2_db65d9e3-f115-4e12-a7a1-78cdb7a217e6.jpg": 42002,
	"./ID00461_3_321eb11f-5664-473e-8c6b-9ae6c714bb7c.jpg": 11217,
	"./ID00461_4_497de897-74cf-4e42-a60c-46adbcc2d01e.jpg": 39901,
	"./ID00462_1_ARTMUSE.jpg": 23265,
	"./ID00462_2_ARTMUSE.jpg": 24426,
	"./ID00462_3_ARTMUSE.jpg": 25215,
	"./ID00462_4_ARTMUSE.jpg": 63736,
	"./ID00463_1__EASYCENTRAL.jpg": 83217,
	"./ID00463_2__EASYCENTRAL.jpg": 57204,
	"./ID00463_3__EASYCENTRAL.jpg": 57703,
	"./ID00463_4__EASYCENTRAL.jpg": 73898,
	"./ID00464_1_FUNGWINGKIDS.jpg": 80092,
	"./ID00464_2_FUNGWINGKIDS.jpg": 51981,
	"./ID00464_3_FUNGWINGKIDS.jpg": 87170,
	"./ID00464_4_FUNGWINGKIDS.jpg": 32011,
	"./ID00464_Fung_Wing_Kids.jpg": 86956,
	"./ID00465_1_26399054-2121-4492-8b90-85eab712ccaf.jpg": 27833,
	"./ID00465_2_020fdf7c-a7eb-4ba4-ad99-d349203bb823.jpg": 95387,
	"./ID00466_1_BOYAENGLISHACADEMY.jpg": 29403,
	"./ID00466_2_BOYAENGLISHACADEMY.jpg": 166,
	"./ID00466_3_BOYAENGLISHACADEMY.jpg": 89861,
	"./ID00466_4_BOYAENGLISHACADEMY.jpg": 66512,
	"./ID00467_1_SMARTLEARNINGACADEMY.jpg": 41804,
	"./ID00467_2_SMARTLEARNINGACADEMY.jpg": 94941,
	"./ID00467_3_SMARTLEARNINGACADEMY.jpg": 41082,
	"./ID00467_4_SMARTLEARNINGACADEMY.jpg": 35931,
	"./ID00468_1_mathomeeducationcentre.jpg": 3590,
	"./ID00468_2_mathomeeducationcentre.jpg": 94835,
	"./ID00468_3_mathomeeducationcentre.jpg": 23416,
	"./ID00468_4_mathomeeducationcentre.jpg": 55397,
	"./ID00469_1_ELITELEARNINGCENTRE.jpg": 6725,
	"./ID00469_2_ELITELEARNINGCENTRE.jpg": 44322,
	"./ID00469_3_ELITELEARNINGCENTRE.jpg": 69475,
	"./ID00469_4_ELITELEARNINGCENTRE.jpg": 80624,
	"./ID00470_1_STANDBYKIDS.jpg": 21905,
	"./ID00470_2_STANDBYKIDS.jpg": 75726,
	"./ID00470_3_STANDBYKIDS.jpg": 79667,
	"./ID00470_4_STANDBYKIDS.jpg": 38576,
	"./ID00471_1_b8155011-f6fa-45e3-a36b-6bdc6b5e6c1e.jpg": 67961,
	"./ID00472_1_4x3_278cd3d5-c573-4d22-a97e-20a86a1a043d.jpg": 77376,
	"./ID00472_2_4x3_3f3c479f-0287-45d8-93a8-b57b42ade0d7.jpg": 58389,
	"./ID00472_4_4x3_96208c6d-8e98-44dd-9dcb-4bdc9e13398e.jpg": 33548,
	"./ID00472_6_4x3_17620ae6-fd1d-4eca-a57a-9eda0c0525f6.jpg": 61825,
	"./ID00473_1_1f136ae1-42eb-4eac-8806-e2364c3e1210.jpg": 90413,
	"./ID00473_2_3f81f3f4-222e-4f18-a48c-deb8cdb6a51b.jpg": 33617,
	"./ID00473_3_89dbcae6-f1a7-4057-a032-2ba7dde63e7e.jpg": 576,
	"./ID00473_4_b289adbb-3447-4204-b2f2-96a3dffda893.jpg": 3983,
	"./ID00474_1_094bc573-c878-44d2-ab34-e74fb97f095a.jpg": 84215,
	"./ID00474_2_2e95a3a2-99bf-45e2-9d3e-bfab0e613344.jpg": 92726,
	"./ID00474_3_29fe92e2-85cd-4067-b8ac-bb2dcbcd50f6.jpg": 78247,
	"./ID00474_4_183be967-859f-4abd-869b-3e089e078bc4.jpg": 69933,
	"./ID00475_1__CadenzaHarps.jpg": 27815,
	"./ID00475_2__CadenzaHarps.jpg": 40516,
	"./ID00475_3__CadenzaHarps.jpg": 17517,
	"./ID00476_1_GrammyMusic.jpg": 1151,
	"./ID00476_2_GrammyMusic.jpg": 85048,
	"./ID00476_3_GrammyMusic.jpg": 13025,
	"./ID00476_4_GrammyMusic.jpg": 59226,
	"./ID00477_1_TALENTEDUCATION.jpg": 84782,
	"./ID00478_1_StarOasisMusic.jpg": 72517,
	"./ID00478_2_StarOasisMusic.jpg": 94444,
	"./ID00479_1__ThinkMusicArtCentre.jpg": 10754,
	"./ID00479_2__ThinkMusicArtCentre.jpg": 33359,
	"./ID00479_3__ThinkMusicArtCentre.jpg": 21184,
	"./ID00479_4__ThinkMusicArtCentre.jpg": 14157,
	"./ID00480_1_NGmusic.jpg": 66614,
	"./ID00480_2_NGmusic.jpg": 76921,
	"./ID00480_3_NGmusic.jpg": 84508,
	"./ID00480_4_NGmusic.jpg": 5119,
	"./ID00481_2_68d1a5ce-100d-4c0a-aa1b-538531ef2c50.jpg": 79257,
	"./ID00482_1_KidsStudioEDUCATIONCENTRE.jpg": 79114,
	"./ID00482_2_KidsStudioEDUCATIONCENTRE.jpg": 60277,
	"./ID00482_3_KidsStudioEDUCATIONCENTRE.jpg": 33276,
	"./ID00482_5_KidsStudioEDUCATIONCENTRE.jpg": 49998,
	"./ID00483_1_greatfunenglish.jpg": 401,
	"./ID00483_2_greatfunenglish.jpg": 79742,
	"./ID00483_3_greatfunenglish.jpg": 99391,
	"./ID00483_4_greatfunenglish.jpg": 49204,
	"./ID00484_1_736350aa-9403-4173-b30b-15f3d2e615ef.jpg": 41617,
	"./ID00484_2_873ebd46-5c41-4871-a2a9-8449ca3833b6.jpg": 28500,
	"./ID00484_3_66594103-cf2c-4857-8e7b-162ae2bc0d13.jpg": 1274,
	"./ID00484_4_90c97c0a-233d-47c1-84a8-656f9cc9e29c.jpg": 45569,
	"./ID00484_HK_Young_talents_1_4x3_43b1ef09-8510-4443-aa10-409fd0e61ec1.jpg": 42291,
	"./ID00485_KV_Post-1024x1024.png": 29444,
	"./ID00486_1_e547583c-792c-4cd7-a25f-e82cdcd1e40d.jpg": 38980,
	"./ID00486_2_6e52c720-c0a0-4d2b-84e3-627f5b0372a2.jpg": 43266,
	"./ID00487_1_TOMS.jpg": 82940,
	"./ID00487_2_TOMS.jpg": 83945,
	"./ID00487_3_TOMS.jpg": 98605,
	"./ID00487_4_TOMS.jpg": 66719,
	"./ID00488_1_02adeafb-f96a-43e3-aae7-e3d98bedbe81.jpg": 84986,
	"./ID00488_1_4x3_c4f24b20-fcf1-4081-8885-59bb5dc7301e.jpg": 97433,
	"./ID00488_2_4x3_8bc24e72-cb30-4c50-b248-c2263a2a293a.jpg": 31203,
	"./ID00488_2_f9f18d52-324a-43e6-924f-b6336c644225.jpg": 13491,
	"./ID00488_3_76aa8136-9a63-404e-abd5-7941a740c003.jpg": 29948,
	"./ID00488_4_ec7b37a6-1f9b-4ba3-a4d0-9f1e5edf8bdf.jpg": 70377,
	"./ID00489_1_a3e46aa8-4ae5-41ea-b4a7-8d154fbec284.jpg": 16986,
	"./ID00489_2_18964c77-23c9-40f4-a254-79c830056e52.jpg": 84247,
	"./ID00489_3_3f1e4f83-ee01-4ac0-a499-b1124763c7b4.jpg": 89317,
	"./ID00489_4_ee3ed5a3-b53a-4f9d-9b2d-2a6076f1ad55.jpg": 36592,
	"./ID00490_WhatsApp_Image_2025-05-18_at_4.33.52_PM.jpg": 71703,
	"./ID00490_WhatsApp_Image_2025-05-18_at_4.33.52_PM_1.jpg": 74403,
	"./ID00490_WhatsApp_Image_2025-05-18_at_4.35.01_PM.jpg": 17353,
	"./ID00491_1_e07edc24-ff96-4b9c-8283-f9cd4abaf67c.jpg": 89498,
	"./ID00491_2_a23abdac-8535-4c9b-befb-fb2d5267d4a8.jpg": 76591,
	"./ID00492_1_dc1b8167-7a55-4fbd-8a5b-682342150823.jpg": 64139,
	"./ID00492_2_a6d21c9f-9f09-4744-8a20-8157e88a0b7b.jpg": 8882,
	"./ID00492_3_45263f8e-9fee-4972-991c-33c2536e1d27.jpg": 48493,
	"./ID00492_4_d5aec809-33d5-4527-a9ff-92accce28a4f.jpg": 60191,
	"./ID00493_1_RickyEnglish.jpg": 46372,
	"./ID00493_2_RickyEnglish.jpg": 97545,
	"./ID00493_3_RickyEnglish.jpg": 1398,
	"./ID00493_4_RickyEnglish.jpg": 48739,
	"./ID00494_1_THEENGLISHHUBEDUCATIONCENTRE.jpg": 43352,
	"./ID00494_2_THEENGLISHHUBEDUCATIONCENTRE.jpg": 7373,
	"./ID00494_3_THEENGLISHHUBEDUCATIONCENTRE.jpg": 64726,
	"./ID00494_4_THEENGLISHHUBEDUCATIONCENTRE.jpg": 19995,
	"./ID00495_2_be3b4ea7-289b-4059-bc2e-3d9beee14e87.jpg": 67007,
	"./ID00495_3_426d5fd2-a625-490a-8a9e-3cc6cffd61c8.jpg": 97592,
	"./ID00495_4_100cb233-364d-4431-a6fb-b7dc0c968d92.jpg": 97502,
	"./ID00495_5_66d4c8e6-0ba7-4846-9b46-00cd199d70e3.jpg": 84600,
	"./ID00496_1_OKAIstudio.jpg": 22459,
	"./ID00497_1_a1efbe5f-5592-4ccd-a203-6f1190d45194.jpg": 90042,
	"./ID00497_2_96ec2a3f-52af-4c5d-9bcf-63bd363a1e3f.jpg": 91113,
	"./ID00497_3_2fa9fb08-237a-4d01-b561-5f0b32901c54.jpg": 62532,
	"./ID00497_5_ef0314ef-8480-4bef-8f60-3eaa263cb68d.jpg": 64309,
	"./ID00498_1_Primastringartcenter.jpg": 58173,
	"./ID00498_2_Primastringartcenter.jpg": 11628,
	"./ID00498_3_Primastringartcenter.jpg": 63999,
	"./ID00498_4_Primastringartcenter.jpg": 81510,
	"./ID00499_1__GreeneryMusic.jpg": 58603,
	"./ID00499_2__GreeneryMusic.jpg": 40286,
	"./ID00500_1_437b99bc-246f-46ec-a81d-8481684fa9fc.jpg": 92384,
	"./ID00500_2_4f11fe2a-b382-45ca-a0ae-d140e308aad1.jpg": 64125,
	"./ID00500_3_efa30136-ea17-4eb4-960e-eee90a77624f.jpg": 78996,
	"./ID00500_4_b6552923-177d-44fb-b5ac-d02a9d5e684a.jpg": 98617,
	"./ID00501_1_98970095-1d85-45bb-9662-afc54a7b0479.jpg": 11292,
	"./ID00501_2_5d0f104f-5df7-4948-9d8f-ecffcbdc6740.jpg": 58978,
	"./ID00502_1__ArteMusicaCentre.jpg": 56975,
	"./ID00502_2__ArteMusicaCentre.jpg": 41520,
	"./ID00503_1_MEADOWARTSTUDIO.jpg": 25442,
	"./ID00503_2_MEADOWARTSTUDIO.jpg": 29053,
	"./ID00503_3_MEADOWARTSTUDIO.jpg": 33352,
	"./ID00503_4_MEADOWARTSTUDIO.jpg": 37163,
	"./ID00504_1__CreationKidsLand.jpg": 58733,
	"./ID00504_2__CreationKidsLand.jpg": 65894,
	"./ID00504_3__CreationKidsLand.jpg": 57171,
	"./ID00504_4__CreationKidsLand.jpg": 49812,
	"./ID00505_1_4x3_8818c5e6-609f-4b4c-9194-444861f26c9b.jpg": 22510,
	"./ID00505_2_4x3_8cc67f45-2fc6-4a3a-b5ef-1a7785000c1d.jpg": 61804,
	"./ID00505_3_4x3_816e058e-9330-469d-b747-6a27ce5dd0ca.jpg": 60013,
	"./ID00505_4_4x3_7b8c2ebb-31a8-422f-84d6-d58d3ebf27ac.jpg": 7305,
	"./ID00505_intrinsic__1_4x3_254319d3-19c2-4bbf-a47a-cb9ee74b0072.jpg": 5684,
	"./ID00505_intrinsic__2_4x3_b357b82c-1aef-4836-9c6d-bb385ee9b1b6.jpg": 30440,
	"./ID00505_intrinsic__3_4x3_65bdd67e-fccb-4b13-91ba-d613455721ad.jpg": 43655,
	"./ID00505_intrinsic__4_4x3_168c6492-7cd9-41d8-9283-3e47262f8d28.jpg": 41352,
	"./ID00506_1_9bf30d5b-785a-4226-b51e-0a7c22161e15.jpg": 53196,
	"./ID00507_1_5bcaf0cb-5082-4051-ab7a-d801ebabe965.jpg": 32070,
	"./ID00507_2_146abbbb-0876-408a-9c2c-f8e7ee63f2c4.jpg": 52442,
	"./ID00507_3_f702acd2-8132-4c7d-9ee5-15fa655648b7.jpg": 16509,
	"./ID00507_4_52d11e36-124d-463e-bdb6-3c84706d376d.jpg": 87956,
	"./ID00508_2_eee23853-8353-451c-9423-cfc6656738c3.jpg": 54669,
	"./ID00509_1_1.pdf_1.jpg": 8033,
	"./ID00509_2_1.pdf_1.jpg": 67178,
	"./ID00510_1_fc104c5f-8e28-4c41-baaf-92f9af5ad3dc.jpg": 16444,
	"./ID00511_1_5234d44b-6434-43d0-a083-c0057ad65aa2.jpg": 38438,
	"./ID00512_1_1.pdf.jpg": 99929,
	"./ID00512_2_1.pdf.jpg": 22438,
	"./ID00513_OpenDay2425_invitation_v5_ol_web-768x1153.jpg": 57459,
	"./ID00514_1_1fe96555-5928-4e0c-bc64-ec115d7008b8.jpg": 14067,
	"./ID00515_1_27245eb9-773f-4fc7-8086-d0560b1541ce.jpg": 51124,
	"./ID00516_1_de85d097-4b75-4f8b-9259-687997789b9f.jpg": 49570,
	"./ID00517_1_6ebdfce9-888e-4570-8162-806c858f1a0c.jpg": 79760,
	"./ID00518_482353885_978362327814272_5420878989515933801_n.jpg": 6949,
	"./ID00519_2_4x3_a1f95ad1-df28-4179-b506-6c25bf049add.jpg": 94980,
	"./ID00519_Kitty_Artist_Studio_1_4x3_69ad8b33-3af9-40d7-b9e2-6edb760aebe3.jpg": 87990,
	"./ID00519_Kitty_Artist_Studio_2_4x3_f04518ea-1a2d-4beb-9dd2-afa0da6a04ff.jpg": 10747,
	"./ID00519_Kitty_Artist_Studio_3_4x3_f8d5ddd3-bbdd-49c9-9f1c-7cc807f75534.jpg": 1678,
	"./ID00519_Kitty_Artist_Studio_4_4x3_466a4125-da87-465e-8e67-93a83f2abf5b.jpg": 39124,
	"./ID00520_1_121bc28c-525f-4628-9fe8-3ccb3497b9b4.jpg": 53144,
	"./ID00520_2_f359ca98-6770-4f2e-8b02-0f65a8d4e9ec.jpg": 98879,
	"./ID00520_3_e99b787a-c0b3-4f44-a70b-0a429f4a1ec5.jpg": 53358,
	"./ID00521_2_b9f3f44e-d636-4280-a7aa-8eb6f8bfe9d2.jpg": 23072,
	"./ID00521_3_66ce046a-8748-4f47-a33b-cb5e56c1639a.jpg": 27275,
	"./ID00521_4_2e193ac8-f886-419e-92a5-b23ee63218f5.jpg": 81587,
	"./ID00521_5_d2b08439-0e6f-4938-9da7-667583e5a7da.jpg": 23674,
	"./ID00522_1_i-STAREducation.jpg": 64629,
	"./ID00522_1_i_star.jpg": 86661,
	"./ID00522_2_i-STAREducation.jpg": 99898,
	"./ID00522_3_i-STAREducation.jpg": 98815,
	"./ID00523_1__Legendsmiles.jpg": 11095,
	"./ID00523_2__Legendsmiles.jpg": 86440,
	"./ID00523_3__Legendsmiles.jpg": 38081,
	"./ID00524_1_A1.jpg": 82549,
	"./ID00525_1__LynwoodEducation.jpg": 20805,
	"./ID00525_2__LynwoodEducation.jpg": 19230,
	"./ID00525_3__LynwoodEducation.jpg": 58263,
	"./ID00525_4__LynwoodEducation.jpg": 22544,
	"./ID00526_1_i-LearnerEducationCentre.jpg": 12397,
	"./ID00526_2_i-LearnerEducationCentre.jpg": 888,
	"./ID00526_3_i-LearnerEducationCentre.jpg": 20459,
	"./ID00526_4_i-LearnerEducationCentre.jpg": 29366,
	"./ID00527_1_49c63940-4150-4583-82d8-76593d6fc16f.jpg": 32354,
	"./ID00527_2_cf55dc3f-f1d8-45fb-af4b-d3186244846e.jpg": 46568,
	"./ID00527_3_eb62b809-23ea-41fd-afca-31ddd479c3a7.jpg": 79805,
	"./ID00527_4_c1b1ed78-8aff-44e2-b7f2-4a26875020cd.jpg": 36363,
	"./ID00528_1_3386b504-038a-4e54-87b3-1f7ec3732baf.jpg": 67226,
	"./ID00528_2_feac2224-1833-45cf-bc9e-d5bba46e3547.jpg": 54373,
	"./ID00528_3_a290606c-92c3-4a70-8189-a15d3dcf9511.jpg": 16662,
	"./ID00528_4_cdc5082e-ad8e-4dbb-b1e5-833213d2592d.jpg": 85737,
	"./ID00529_1_MFPlusEducation.jpg": 45299,
	"./ID00529_2_MFPlusEducation.jpg": 26616,
	"./ID00529_3_MFPlusEducation.jpg": 16193,
	"./ID00529_4_MFPlusEducation.jpg": 21822,
	"./ID00530_1_35b01224-75ef-434c-9a8e-7d38fa72ee35.jpg": 33411,
	"./ID00530_2_e1d611cb-00a3-41fa-9370-5d7d7c7219f1.jpg": 8133,
	"./ID00530_3_3c4a3a37-9a4e-4813-a507-77307878832f.jpg": 61587,
	"./ID00530_4_5b02608b-8238-4da7-9283-3bfcdc945361.jpg": 99844,
	"./ID00531_1_TeenieGreenieEducationCentre.jpg": 6005,
	"./ID00531_2_TeenieGreenieEducationCentre.jpg": 18716,
	"./ID00532_1_MindKey.jpg": 41987,
	"./ID00532_2_MindKey.jpg": 98680,
	"./ID00532_3_MindKey.jpg": 3229,
	"./ID00532_4_MindKey.jpg": 48322,
	"./ID00533_1__LanguageForestEducation.jpg": 40171,
	"./ID00533_2__LanguageForestEducation.jpg": 58786,
	"./ID00533_3__LanguageForestEducation.jpg": 31669,
	"./ID00533_4__LanguageForestEducation.jpg": 180,
	"./ID00534_1_dd013d53-20e4-449a-abc2-64ffdfb11697.jpg": 11907,
	"./ID00534_2_0aa82827-3b0a-4f60-bcc1-a58d4cf007ba.jpg": 15648,
	"./ID00535_1_1542f0cf-9381-4548-b11b-c524079aadf5.jpg": 90723,
	"./ID00535_2_ca3216c9-0b8a-48f7-a775-48877155f89d.jpg": 73254,
	"./ID00535_3_8be70fa3-3518-40b5-83c0-adfc2ec8b59a.jpg": 88786,
	"./ID00536_1__FunEducationCentre.jpg": 47215,
	"./ID00536_2__FunEducationCentre.jpg": 28272,
	"./ID00536_4__FunEducationCentre.jpg": 84622,
	"./ID00536_5__FunEducationCentre.jpg": 88459,
	"./ID00537_1__IgniteandShineLearningCentre.jpg": 54881,
	"./ID00537_2__IgniteandShineLearningCentre.jpg": 60310,
	"./ID00537_3__IgniteandShineLearningCentre.jpg": 37151,
	"./ID00537_4__IgniteandShineLearningCentre.jpg": 56796,
	"./ID00538_1_42311017-dcce-4c0a-bc3d-8975f826c95a.jpg": 16349,
	"./ID00538_2_17b6bdd7-0345-49f1-8242-a728b8d9923c.jpg": 63196,
	"./ID00538_3_f97abace-99f5-4d20-8fb5-64b95ffde664.jpg": 93835,
	"./ID00538_4_3aea0312-4d03-40d9-bbc3-b0a5ab3ee6e9.jpg": 3165,
	"./ID00539_1_CREATIVEPOWEREDUCATIONCENTRE.jpg": 10352,
	"./ID00539_2_CREATIVEPOWEREDUCATIONCENTRE.jpg": 75665,
	"./ID00540_1_GIFTICONEducationCentre.jpg": 69577,
	"./ID00540_2_GIFTICONEducationCentre.jpg": 3814,
	"./ID00541_1__PhD.jpg": 71199,
	"./ID00541_2__PhD.jpg": 29222,
	"./ID00541_3__PhD.jpg": 53701,
	"./ID00541_4__PhD.jpg": 47540,
	"./ID00542_1_PianoKids.jpg": 69203,
	"./ID00542_2_PianoKids.jpg": 50624,
	"./ID00542_3_PianoKids.jpg": 82829,
	"./ID00542_4_PianoKids.jpg": 8546,
	"./ID00543_1__POLAMMUSICCO.jpg": 81735,
	"./ID00543_2__POLAMMUSICCO.jpg": 76008,
	"./ID00543_3__POLAMMUSICCO.jpg": 39697,
	"./ID00544_1_VIVADANCEacademy.jpg": 25076,
	"./ID00544_2_VIVADANCEacademy.jpg": 8309,
	"./ID00544_3_VIVADANCEacademy.jpg": 3146,
	"./ID00544_4_VIVADANCEacademy.jpg": 74483,
	"./ID00545_1_Y.ArtWorkshop.jpg": 72215,
	"./ID00545_2_Y.ArtWorkshop.jpg": 84356,
	"./ID00545_3_Y.ArtWorkshop.jpg": 78525,
	"./ID00545_4_Y.ArtWorkshop.jpg": 2674,
	"./ID00546_1_2061f9f5-6b5f-4335-a7a4-029d6922d0ae.jpg": 39867,
	"./ID00546_2_d4c5df23-adfc-4d2a-b866-02a7bb580eec.jpg": 90766,
	"./ID00547_Manna_Creative_Studio_1_4x3_b4abd967-a44e-4f3b-8ba4-1510aace3768.jpg": 74631,
	"./ID00547_Manna_Creative_Studio_2_4x3_2405139a-63a7-4b14-93b6-bf59c604a93c.jpg": 54472,
	"./ID00547_Manna_Creative_Studio_3_4x3_9d0ab2d5-fefa-4c16-81db-5c59172335bf.jpg": 85282,
	"./ID00547_Manna_Creative_Studio_4_4x3_e8683a5f-a318-49c6-a26f-a016c08760d5.jpg": 87895,
	"./ID00548_1_RainbowCreativeArts.jpg": 10174,
	"./ID00548_2_RainbowCreativeArts.jpg": 74517,
	"./ID00548_3_RainbowCreativeArts.jpg": 3212,
	"./ID00548_4_RainbowCreativeArts.jpg": 39683,
	"./ID00548_rainbow_creative_arts.jpg": 2070,
	"./ID00549_1_TheKidsCreation.jpg": 67897,
	"./ID00549_2_TheKidsCreation.jpg": 68478,
	"./ID00550_1_coreeducation.jpg": 43335,
	"./ID00550_2_coreeducation.jpg": 83936,
	"./ID00550_3_coreeducation.jpg": 10249,
	"./ID00550_4_coreeducation.jpg": 54658,
	"./ID00551_2_Wiseland.jpg": 21457,
	"./ID00551_3_Wiseland.jpg": 47310,
	"./ID00551_4_Wiseland.jpg": 49707,
	"./ID00551_Wiseland_Elite_Learning_Centre_1_4x3_4a83f93d-a888-457c-97ba-486d53db60df.jpg": 60899,
	"./ID00552_1_OliveSpeechAcademyEducationCentre.jpg": 67582,
	"./ID00552_2_OliveSpeechAcademyEducationCentre.jpg": 46845,
	"./ID00552_3_OliveSpeechAcademyEducationCentre.jpg": 2952,
	"./ID00552_4_OliveSpeechAcademyEducationCentre.jpg": 5415,
	"./ID00553_1__ComeToLearnEducationCenter_362b82a7-ac7f-4228-9121-0010a40af2b3.jpg": 46696,
	"./ID00553_2__ComeToLearnEducationCenter_04a920fc-d552-4a38-953b-7a52d350b901.jpg": 61187,
	"./ID00553_4__ComeToLearnEducationCenter_d1776c4a-11d2-48ea-8b37-b652a2a385ff.jpg": 70612,
	"./ID00553_5__ComeToLearnEducationCenter_f79c9160-160c-4bbe-903d-a168920c14c4.jpg": 52183,
	"./ID00554_1_f9bfac6b-6d25-4f86-89f4-f44721e0170d.jpg": 95824,
	"./ID00554_2_03583a8c-ba34-43f3-886e-9fd7ae225573.jpg": 57639,
	"./ID00554_3_5cf62061-5d14-4213-8248-4f43a0c13ccb.jpg": 87392,
	"./ID00554_4_fd7e3d47-383a-4933-9b01-cff53ca851fb.jpg": 38412,
	"./ID00555_1_SapphireLearningCentre.jpg": 47594,
	"./ID00555_2_SapphireLearningCentre.jpg": 88187,
	"./ID00555_3_SapphireLearningCentre.jpg": 35708,
	"./ID00555_4_SapphireLearningCentre.jpg": 48741,
	"./ID00556_all_for_joy_1_4x3_3e2a4291-2910-43a5-854a-04af6aef8b01.jpg": 24143,
	"./ID00556_all_for_joy_2_4x3_c8b3f4a6-ccc6-4663-b234-745d271e36ef.jpg": 11187,
	"./ID00556_all_for_joy_3_4x3_888ca928-b3d5-482e-b927-72966e45cf03.jpg": 5813,
	"./ID00556_all_for_joy_4_4x3_321d72b7-6e41-4ec8-b7e2-17ea3ffc852d.jpg": 96693,
	"./ID00557_1_5f40b044-17c1-4159-8c9c-86824eed6b5f.jpg": 55235,
	"./ID00557_2_ca168613-bc98-4327-a4e6-bd6f2ae9e2b8.jpg": 11881,
	"./ID00557_3_d2ac27f4-ffaf-4933-b570-b5f09a777d35.jpg": 59592,
	"./ID00558_1_MentorhoodLEARNINGCENTER.jpg": 51640,
	"./ID00558_2_MentorhoodLEARNINGCENTER.jpg": 4009,
	"./ID00558_3_MentorhoodLEARNINGCENTER.jpg": 75814,
	"./ID00558_4_MentorhoodLEARNINGCENTER.jpg": 52447,
	"./ID00559_1_WISEKIDSEDUCATIONCENTRE_efeda532-9fdd-4ab7-90da-69c4946c1d7c.jpg": 84581,
	"./ID00560_1__CASUALACELEARNINGCENTRE.jpg": 30913,
	"./ID00560_2__CASUALACELEARNINGCENTRE.jpg": 77748,
	"./ID00560_3__CASUALACELEARNINGCENTRE.jpg": 41267,
	"./ID00560_4__CASUALACELEARNINGCENTRE.jpg": 82142,
	"./ID00561_1_Jolly_ByteCoding_Robotics.jpg": 5629,
	"./ID00561_2_Jolly_ByteCoding_Robotics.jpg": 65034,
	"./ID00561_3_Jolly_ByteCoding_Robotics.jpg": 62219,
	"./ID00561_4_Jolly_ByteCoding_Robotics.jpg": 23600,
	"./ID00562_GARY_CHAN_STUDIO_1_4x3_c76753ca-d044-4df3-9694-963aa91b68fa.jpg": 63470,
	"./ID00562_GARY_CHAN_STUDIO_2_4x3_3b36f952-630a-4ae7-a736-efd8b2925c83.jpg": 285,
	"./ID00563_1_HYPERPAINTSTUDIO.jpg": 74026,
	"./ID00563_2_HYPERPAINTSTUDIO.jpg": 25327,
	"./ID00563_3_HYPERPAINTSTUDIO.jpg": 59444,
	"./ID00563_4_HYPERPAINTSTUDIO.jpg": 91929,
	"./ID00564_1_JAMACADEMY.jpg": 61413,
	"./ID00564_2_JAMACADEMY.jpg": 1264,
	"./ID00564_3_JAMACADEMY.jpg": 1355,
	"./ID00564_5_JAMACADEMY.jpg": 42249,
	"./ID00565_1_THEARTGARDEN.jpg": 11951,
	"./ID00565_2_THEARTGARDEN.jpg": 99410,
	"./ID00566_1_9d658fcb-8d26-44bc-a42b-bac134ee9596.jpg": 53403,
	"./ID00566_2_krhythm.academy.jpg": 78957,
	"./ID00567_1_a44d7cf4-4acf-408a-925c-dfafd91ddd52.jpg": 60833,
	"./ID00568_1_DODOARTROOM.jpg": 86937,
	"./ID00569_GENIUSWORKSHOP_1_4x3_591bb326-0d47-47dd-b0c7-bda3d535086a.jpg": 49367,
	"./ID00569_Genius_workshop_1_4x3_7893a679-ecc5-48fa-b465-c041a879e5cb.jpg": 51232,
	"./ID00569_Genius_workshop_2_4x3_9c3f94b1-74b6-4121-8da9-0b28af2ebfb7.jpg": 62264,
	"./ID00569_Genius_workshop_3_4x3_c2dd34e1-cb52-4d75-b4ba-5a10d8f234c1.jpg": 36433,
	"./ID00569_Genius_workshop_4_4x3_e0e165b1-bd2f-4f2e-a3ac-37aa9937464a.jpg": 83084,
	"./ID00570_1_e8fd8151-3b3e-4ebf-aeee-7bfddf799a1b.jpg": 94804,
	"./ID00570_2_f2e742ee-0cb1-4a59-b013-0e40454c56a2.jpg": 37565,
	"./ID00570_3_fdd91b72-2291-4d9a-bf1a-78b7894b4736.jpg": 71248,
	"./ID00570_4_0e502e4d-dce1-4bf5-825d-fa76971b80f6.jpg": 28156,
	"./ID00571_CreAction_Art_Gallery_1_4x3_b0ba9cb2-5e17-4a42-9d25-b565042c4160.jpg": 89555,
	"./ID00571_CreAction_Art_Gallery_2_4x3_1e57dbd6-b707-4ee1-85ed-c63060eb3b0e.jpg": 27482,
	"./ID00571_CreAction_Art_Gallery_3_4x3_e6738de9-c929-4029-aefb-4dd0ff483255.jpg": 8599,
	"./ID00571_CreAction_Art_Gallery_4_4x3_07d1cb9f-4d01-4d96-9ebb-99156013ce39.jpg": 44756,
	"./ID00572_1__Dimension-SixEducationCentre.jpg": 15547,
	"./ID00572_2__Dimension-SixEducationCentre.jpg": 11936,
	"./ID00572_3__Dimension-SixEducationCentre.jpg": 7677,
	"./ID00572_4__Dimension-SixEducationCentre.jpg": 14058,
	"./ID00573_1_06b1a049-0ba1-4661-a087-2330a4d086b8.jpg": 62246,
	"./ID00573_2_2130d04d-8f0d-4ca6-bcee-562378b13b06.jpg": 98042,
	"./ID00573_5_0ad832f8-a95f-4147-af47-2f3067bf2978.jpg": 28308,
	"./ID00573_6_ed68bcfc-2b60-4a4a-bfcc-ed60a0b8f9ac.jpg": 56028,
	"./ID00573_EdFun__1_4x3_d1a16597-fb38-40f5-bfd6-ce121ed1fd12.jpg": 11070,
	"./ID00573_EdFun__2_4x3_ed672922-b796-4f37-a6a9-c56edd3a903d.jpg": 85785,
	"./ID00574_1_HibikiMusicandArtCentre.jpg": 56012,
	"./ID00574_2_HibikiMusicandArtCentre.jpg": 45159,
	"./ID00575_1_5e391d0d-4c50-48c8-962b-3a1a7558542b.jpg": 55799,
	"./ID00575_2_63c8e6d7-126a-4911-ade2-97f4aad2614a.jpg": 29389,
	"./ID00575_3_8bfa567f-98c7-47ca-a6e0-2332f881c2e0.jpg": 7219,
	"./ID00575_4_3ef852a5-48e1-4295-a28f-a4891cb31f0d.jpg": 60454,
	"./ID00575_5_23d63117-b881-48a0-8a80-5d26cee81856.jpg": 76565,
	"./ID00576_1_663c455e-f31a-4ede-b554-aa2f9eaed455.jpg": 97532,
	"./ID00576_1_88ae74cb-0f2f-4f3d-b3c9-d4d64d22855d.jpg": 97642,
	"./ID00576_2_9be613d6-b940-4e68-81f7-54dd63f1855c.jpg": 98050,
	"./ID00577_1_9ffb9313-d49a-437d-817b-e55d6561c60e.jpg": 52123,
	"./ID00578_Modern_Art_Studio_Modern_Art_Studio_1_4x3_19471cae-6d53-4dd8-aa72-c1e79db7fd25.jpg": 714,
	"./ID00578_Modern_Art_Studio_Modern_Art_Studio_2_4x3_168d46d4-73d0-4c3c-9d55-7dc806dd1c6c.jpg": 40517,
	"./ID00578_Modern_Art_Studio_Modern_Art_Studio_3_4x3_97fc0eae-6d7f-41f4-9c2d-f4b98b0a2819.jpg": 13828,
	"./ID00578_Modern_Art_Studio_Modern_Art_Studio_4_4x3_b1ea694a-e2c6-4fff-a920-242f3af8e09d.jpg": 2920,
	"./ID00579_1_hashtagartspace.jpg": 61130,
	"./ID00580_2_LittleDuckDanceandArtsAcademy_f8bf7f6f-fe7d-42e8-874d-e8082b37c7da.jpg": 10589,
	"./ID00581_1_24c17b62-4797-419f-8d02-0ca2ff54494a.jpg": 35605,
	"./ID00581_2_9308d5e7-30f8-422f-9f23-7625b0ca3154.jpg": 86728,
	"./ID00582_1.png": 64782,
	"./ID00582_3.png": 49692,
	"./ID00582_4.png": 49651,
	"./ID00582_ArtVenture.png": 99131,
	"./ID00583_EDF_DANCE_STUDIO_1_4x3_342a9e04-a58d-40a7-bffd-6cf3d975a016.jpg": 95152,
	"./ID00584_1_41b2ac48-d093-40d6-a234-df37320f40e0.jpg": 39348,
	"./ID00584_2_782e9705-e52e-4f12-a1cf-f7981cff2adb.jpg": 94983,
	"./ID00585_1_f72668ea-93ca-4518-848c-b2e6723d1be0.jpg": 63613,
	"./ID00586_1_wisdomtree.jpg": 97190,
	"./ID00587_1_2571b118-5715-4b80-9fd1-11014f4fd002.jpg": 42974,
	"./ID00587_2_ecb5b7b8-12dc-4c33-8932-9117f0050158.jpg": 55507,
	"./ID00587_3_00695cfd-6142-4139-ad1c-f5554ac7a9f2.jpg": 76996,
	"./ID00587_4_82d49f61-73c1-4fac-b711-85f18eed3526.jpg": 84382,
	"./ID00588_New_folKidzport_Education_Centre_1_4x3_c2592d88-25ba-4547-9c6e-b7ad5538275a.jpg": 9140,
	"./ID00588_New_folKidzport_Education_Centre_2_4x3_24197b8e-6aa1-4949-bf59-6eebf31808d6.jpg": 13126,
	"./ID00588_New_folKidzport_Education_Centre_3_4x3_84c0d78b-33da-4531-8777-b24b63266bca.jpg": 45699,
	"./ID00588_New_folKidzport_Education_Centre_4_4x3_476e3e3c-77b3-4140-ac95-c14ca5fb3a4d.jpg": 23684,
	"./ID00589_1_TopKidsClub.jpg": 4314,
	"./ID00589_2_TopKidsClub.jpg": 21741,
	"./ID00590_1_d0413fe6-6eaf-4d18-8113-d8879d189cd5.jpg": 30179,
	"./ID00590_2_aa04a939-e019-4bc4-9863-cfa227152e40.jpg": 2021,
	"./ID00590_3_8ac59149-d5e6-41d9-9c0c-850db9688bc3.jpg": 2685,
	"./ID00590_4_118d29f4-156f-4e0b-8705-62fa77763ed4.jpg": 34493,
	"./ID00591_1_c63b9850-bcb9-4e69-a7c8-a874c8e28a91.jpg": 89593,
	"./ID00591_2_f37d4806-d958-45fd-89ab-103db3b98821.jpg": 76954,
	"./ID00591_3_aa9be442-f633-4355-a4c8-36b5083834ee.jpg": 3752,
	"./ID00591_4_2e7897fd-91da-48cb-94e4-f5a8c2676c96.jpg": 33768,
	"./ID00592_1_6f7eddd8-beff-459f-b114-a46a78bd7e2e.jpg": 48659,
	"./ID00592_2_043b3a7c-aa9b-4f32-ace7-a0a869a13a60.jpg": 68873,
	"./ID00592_3_40db6585-0645-421d-995c-054247dbfa1b.jpg": 93798,
	"./ID00592_4_7fdf4183-b741-4f4c-ae6b-2a8e3e6b2291.jpg": 45769,
	"./ID00592_5_6b880e96-7776-4b1d-a4f9-b753e40c0959.jpg": 59706,
	"./ID00593_1_TwinkleStringsMusic.jpg": 8822,
	"./ID00593_2_TwinkleStringsMusic.jpg": 58893,
	"./ID00593_3_TwinkleStringsMusic.jpg": 72052,
	"./ID00593_4_TwinkleStringsMusic.jpg": 52043,
	"./ID00594_STELLA_WONGMUSIC_ACADEMY__1_4x3_331ad993-52c2-42ba-b948-1c8534918582.jpg": 96083,
	"./ID00594_STELLA_WONGMUSIC_ACADEMY__2_4x3_7a9972f3-6c3a-4ea7-aa95-55453a490cce.jpg": 89231,
	"./ID00594_STELLA_WONGMUSIC_ACADEMY__3_4x3_38a0efca-8db3-4ee3-b175-0b2cc5e23ae3.jpg": 34257,
	"./ID00594_STELLA_WONGMUSIC_ACADEMY__4_4x3_bdd37157-cb66-47b4-ac63-fdec265e6d7e.jpg": 67502,
	"./ID00595_1_APAcademyofDance.jpg": 77890,
	"./ID00595_2_APAcademyofDance.jpg": 78263,
	"./ID00596_1_ProMusicAcademyHK.jpg": 23815,
	"./ID00596_2_ProMusicAcademyHK.jpg": 45164,
	"./ID00597_1_SILVERACADEMYOFMUSIC.jpg": 21424,
	"./ID00597_2_SILVERACADEMYOFMUSIC.jpg": 58029,
	"./ID00597_3_SILVERACADEMYOFMUSIC.jpg": 90514,
	"./ID00597_4_SILVERACADEMYOFMUSIC.jpg": 56991,
	"./ID00598_1_new_doc_2025-05-24_10.23.38_38872969-1a6f-4751-adb2-23da2bc10543.jpg": 59901,
	"./ID00598_2_new_doc_2025-05-24_10.23.38.jpg": 45533,
	"./ID00599_1_WonderlandCreativeArts.jpg": 92416,
	"./ID00599_2_WonderlandCreativeArts.jpg": 161,
	"./ID00599_3_WonderlandCreativeArts.jpg": 4030,
	"./ID00599_4_WonderlandCreativeArts.jpg": 86479,
	"./ID00600_1_9d315306-87c4-4b39-a4ef-c42bdd2b9c46.jpg": 72580,
	"./ID00601_1_13bdbd45-699f-405f-9a87-6f88233e4cef.jpg": 3545,
	"./ID00602_1_17b61cef-94eb-43ce-8b3d-44558fbef609.jpg": 71277,
	"./ID00603_1_cc05feb6-f017-46f0-9559-d1742edf3f48.jpg": 46153,
	"./ID00604_1_f8291876-0bd1-4183-9a7c-c391a11d267a.jpg": 58039,
	"./ID00605_1_9cb729fd-2de4-41a6-a6e6-a5f8fc95b2dc.jpg": 34672,
	"./ID00606_1_c8255f12-176d-4198-ad95-738e7f32b015.jpg": 72140,
	"./ID00606_2_d37298ec-0eb7-47aa-8f24-fffd89005143.jpg": 48363,
	"./ID00607_1_ae4f2a15-d423-4d5b-a7b2-cfb5e1926b2a.jpg": 27902,
	"./ID00607_c471da0c3ccc9c6c41948430a7786970.jpg": 34071,
	"./ID00608_1_578b1220-afb1-4c5b-b8ba-15982822b040.jpg": 82475,
	"./ID00609_1_f02afedb-c5bd-4b84-bc83-e701af7385fa.jpg": 80149,
	"./ID00610_3_c126e771-ef77-41b3-92ea-c92a109f8274.jpg": 43573,
	"./ID00610_4_15267436-f8c4-45f9-81dc-f7393b676edf.jpg": 82377,
	"./ID00610_5_fb3e635e-05e2-4335-b85c-d0c34087707a.jpg": 22559,
	"./ID00610_acorn1.jpg": 55101,
	"./ID00610_studio_Acorn.jpg": 48137,
	"./ID00611_1_b9bcc551-0f0e-4243-8a2a-c25e4e940eff.jpg": 7318,
	"./ID00612_1_drawstation.jpg": 59473,
	"./ID00612_2_drawstation.jpg": 32574,
	"./ID00613_2025-02-03215925.png": 38220,
	"./ID00613_Soar_Table_Tennis_Association_1_4x3_44fc8fd4-409b-416f-8f9f-72667068cdd3.jpg": 19551,
	"./ID00614_1_4x3_dadc6682-60b8-45cb-afb4-6b0088df8432.jpg": 37365,
	"./ID00615_1_4c537605-9cd9-4171-abbf-043805c85553.jpg": 86301,
	"./ID00615_2_2490f628-8c5c-48f1-95c8-9808003b3dc0.jpg": 87087,
	"./ID00615_3_5ed5b326-82f6-49e7-ad75-eb77219a7166.jpg": 12846,
	"./ID00616_holisticenglish1.jpg": 19221,
	"./ID00616_holisticenglish2.jpg": 9322,
	"./ID00617_1__2025_0a882447-a589-4d5d-863b-d37ffbe54cba.jpg": 27946,
	"./ID00618_1_f2902f85-8914-4686-83b1-c7d3abb41785.jpg": 46742,
	"./ID00619_smartkids_house_1.jpg": 90485,
	"./ID00619_smartkids_house_2.jpg": 49994,
	"./ID00619_smartkids_house_3.jpg": 62151,
	"./ID00619_smartkids_house_4.jpg": 7740,
	"./ID00620_1__WISDOMTHOUGHTEDUCATION.jpg": 91421,
	"./ID00620_2__WISDOMTHOUGHTEDUCATION.jpg": 12266,
	"./ID00620_4__WISDOMTHOUGHTEDUCATION.jpg": 30476,
	"./ID00620_5__WISDOMTHOUGHTEDUCATION.jpg": 80313,
	"./ID00621_1_f442c78f-b34f-40bc-b354-495027051121.jpg": 96840,
	"./ID00621_2_4d3db465-3581-4c6a-b65f-82864d2943e4.jpg": 21311,
	"./ID00621_3_70234836-a23f-4021-af45-ca0af9d76a22.jpg": 21419,
	"./ID00621_4_27cbe23c-5910-4ee1-97ec-d98ac50adc1e.jpg": 43211,
	"./ID00622_1_WISDOMFOUNTAINTUTORIALCENTRE.jpg": 55170,
	"./ID00622_2_WISDOMFOUNTAINTUTORIALCENTRE.jpg": 40587,
	"./ID00623_1_41122bae-9a90-45ed-a0cb-753b38637a40.jpg": 37403,
	"./ID00623_2_d4fd182f-8c08-4bd4-a3bf-35c049eaea42.jpg": 31422,
	"./ID00624_1_SeedtoSaplingeducationcentre.jpg": 34509,
	"./ID00624_2_SeedtoSaplingeducationcentre.jpg": 20156,
	"./ID00624_3_SeedtoSaplingeducationcentre.jpg": 42595,
	"./ID00624_4_SeedtoSaplingeducationcentre.jpg": 94362,
	"./ID00625_1__BestTalentEducation.jpg": 14162,
	"./ID00625_2__BestTalentEducation.jpg": 37459,
	"./ID00625_3__BestTalentEducation.jpg": 16736,
	"./ID00625_4__BestTalentEducation.jpg": 22697,
	"./ID00626_1_GoLearning.jpg": 6968,
	"./ID00627_1_EnglishCastle.jpg": 87,
	"./ID00627_2_EnglishCastle.jpg": 71348,
	"./ID00627_3_EnglishCastle.jpg": 6045,
	"./ID00627_4_EnglishCastle.jpg": 23226,
	"./ID00628_1_MISSMARYCREATIVELEARNINGCENTRE.jpg": 88683,
	"./ID00628_2_MISSMARYCREATIVELEARNINGCENTRE.jpg": 71426,
	"./ID00628_3_MISSMARYCREATIVELEARNINGCENTRE.jpg": 39521,
	"./ID00628_4_MISSMARYCREATIVELEARNINGCENTRE.jpg": 10320,
	"./ID00629_ACE_English_1_4x3_8a67aa1e-23ab-4eb3-9a79-ae34ceb0ab78.jpg": 99059,
	"./ID00629_ACE_English_2_4x3_3e4c6f27-51b1-4c88-a940-5f5bf1a8ecde.jpg": 54336,
	"./ID00629_ACE_English_3_4x3_cff5f01b-efb6-4396-8a63-0e91cf95f5ac.jpg": 50585,
	"./ID00629_ACE_English_4_4x3_228f0c22-3c2c-4fae-9f73-d0d8e58d2070.jpg": 72095,
	"./ID00630_1__LONGHONOURLEARNINGCENTRE.jpg": 93450,
	"./ID00630_2__LONGHONOURLEARNINGCENTRE.jpg": 38221,
	"./ID00630_3__LONGHONOURLEARNINGCENTRE.jpg": 11088,
	"./ID00630_4__LONGHONOURLEARNINGCENTRE.jpg": 16059,
	"./ID00631_1_74662e49-135d-48cc-85c3-49f129171cab.jpg": 59113,
	"./ID00631_2_71b83a2c-c2fd-46b3-9771-8a449b8f36ec.jpg": 81139,
	"./ID00631_3_df6d9737-a764-4f76-8a56-e43501857f44.jpg": 97055,
	"./ID00631_5_961c1a2a-06bf-4d9e-ab2d-3f5191c0268e.jpg": 55306,
	"./ID00632_1_07741737-1003-4ec3-b49d-813635858cdb.jpg": 32683,
	"./ID00632_2_a1d0580b-2a0a-4909-b864-b25de9a538f7.jpg": 178,
	"./ID00632_3_fb0f91a4-1ce4-48e9-9e96-1b958afa5063.jpg": 77085,
	"./ID00632_4_3cb89159-c963-414d-97ab-d46bbc669ef5.jpg": 17775,
	"./ID00633_1__HONGKONGCHINACHESSSCHOOL.jpg": 24829,
	"./ID00633_2__HONGKONGCHINACHESSSCHOOL.jpg": 11562,
	"./ID00633_3__HONGKONGCHINACHESSSCHOOL.jpg": 50719,
	"./ID00633_4__HONGKONGCHINACHESSSCHOOL.jpg": 35612,
	"./ID00633_5__HONGKONGCHINACHESSSCHOOL.jpg": 12145,
	"./ID00634_1__KinderlandStudio.jpg": 58794,
	"./ID00634_2__KinderlandStudio.jpg": 38985,
	"./ID00634_3__KinderlandStudio.jpg": 25208,
	"./ID00634_4__KinderlandStudio.jpg": 94047,
	"./ID00635_1_Musicat.jpg": 64508,
	"./ID00635_2_Musicat.jpg": 76399,
	"./ID00635_3_Musicat.jpg": 29326,
	"./ID00635_4_Musicat.jpg": 17345,
	"./ID00635_Musicat_1_4x3_2292b05d-cb0c-432c-821f-745342caa9fa.jpg": 72298,
	"./ID00635_Musicat_2_4x3_42415835-c84a-40de-b70e-c8f81b9cbc05.jpg": 22589,
	"./ID00635_Musicat_3_4x3_fee1013c-d08d-4ab9-a70f-071888812929.jpg": 22334,
	"./ID00635_Musicat_4_4x3_cedad40d-164f-4ba4-9657-b013180fea44.jpg": 74455,
	"./ID00635_Musicat_5_4x3_7336db53-a1f9-4d53-a026-99622578e922.jpg": 23692,
	"./ID00636_1_JOYARTGALLERY.jpg": 94336,
	"./ID00636_2_JOYARTGALLERY.jpg": 57179,
	"./ID00636_3_JOYARTGALLERY.jpg": 22402,
	"./ID00636_4_JOYARTGALLERY.jpg": 58253,
	"./ID00637_1_Artland.jpg": 29260,
	"./ID00637_2_Artland.jpg": 35423,
	"./ID00638_1_Mouthwateringstudio.jpg": 51271,
	"./ID00638_1_a10b392e-e301-4a9c-a8a2-81e61fe8f37a.jpg": 33199,
	"./ID00638_2_70e8b420-6656-44e9-b470-6d05377d6b67.jpg": 22325,
	"./ID00638_2_Mouthwateringstudio.jpg": 59216,
	"./ID00638_3_5e454ad2-74ca-4c66-ab69-1a975129d7bf.jpg": 56735,
	"./ID00638_3_Mouthwateringstudio.jpg": 19525,
	"./ID00638_4_290e0c97-d122-4aed-b6e3-a9511b7f84c5.jpg": 68094,
	"./ID00638_4_Mouthwateringstudio.jpg": 99182,
	"./ID00639_1_95fc7426-ed10-493e-955b-6f9158df7466.jpg": 71708,
	"./ID00639_2_b23e6981-d368-49ab-8842-6906fe0dfc52.jpg": 38000,
	"./ID00639_3_60b2a88a-60fe-495b-b0b8-1c4b9a52a5c1.jpg": 74226,
	"./ID00640_1_4x3_8563611d-4b56-4ee1-9ccf-7895e22892bb.jpg": 29812,
	"./ID00640_2_4x3_804a360f-a454-4392-b3d8-0e6b1bc7c0be.jpg": 16974,
	"./ID00640_3_4x3_36a74e40-243b-4f4d-8fc2-60011d502717.jpg": 43302,
	"./ID00640_4_4x3_4dd7c22e-9615-4d6c-906a-645126cd0ab7.jpg": 12515,
	"./ID00641_1_476b7d9c-9f01-4902-9276-b9696e39380d.jpg": 17146,
	"./ID00641_2_3711e69d-4534-43d5-b27a-36b40d7c9d21.jpg": 6209,
	"./ID00641_3_d9b89d2c-830c-4a87-a85c-2f226e1f29b0.jpg": 51428,
	"./ID00641_4_5f74cc28-471b-4f7c-84f2-9ef6fc2448bc.jpg": 20382,
	"./ID00642_1_Byjoss.jpg": 62478,
	"./ID00642_2_Byjoss.jpg": 66367,
	"./ID00642_Byjoss__Byjoss__1_4x3_58d70961-83a8-4a14-8db9-ef3043008e30.jpg": 68330,
	"./ID00642_Byjoss__Byjoss__2_4x3_25a83ebd-1c31-47b1-bc68-0e06c938e839.jpg": 21467,
	"./ID00643_1_Auramusicstudio.jpg": 14477,
	"./ID00643_2_Auramusicstudio.jpg": 30170,
	"./ID00643_3_Auramusicstudio.jpg": 2703,
	"./ID00643_4_Auramusicstudio.jpg": 67884,
	"./ID00644_1_e7e923e6-a870-4215-aa41-3ef83b8d5aa4.jpg": 94901,
	"./ID00644_2_2c70814f-7250-4953-9a80-9c41ae47ae3f.jpg": 7868,
	"./ID00644_3_b599ed56-ac1a-4ff3-a971-d8c0eb6b544c.jpg": 7154,
	"./ID00644_4_54c95efa-43f1-4a9a-8315-c779e91b066c.jpg": 80335,
	"./ID00645_2__ROYALMUSICACADEMY.jpg": 22763,
	"./ID00645_3__ROYALMUSICACADEMY.jpg": 87972,
	"./ID00645_4__ROYALMUSICACADEMY.jpg": 72161,
	"./ID00645_Hong_Kong_Royal_Music_Academy__2_4x3_49cb99fa-36a7-44dd-b9db-1b3a97316306.jpg": 43148,
	"./ID00645_Hong_Kong_Royal_Music_Academy__3_4x3_a9979737-b5e9-491e-9371-9961893a704c.jpg": 56138,
	"./ID00645_Hong_Kong_Royal_Music_Academy__4_4x3_f785939d-b740-4b21-a762-6a5995647abc.jpg": 58664,
	"./ID00645_Hong_Kong_Royal_Music_Academy__5_4x3_687d5f5f-1c3c-45ce-8a49-20827f24c0f4.jpg": 98368,
	"./ID00646_1_PIANCOMUSICSPACE.jpg": 97665,
	"./ID00646_2_PIANCOMUSICSPACE.jpg": 64376,
	"./ID00646_4_PIANCOMUSICSPACE.jpg": 25198,
	"./ID00646_5_PIANCOMUSICSPACE.jpg": 9701,
	"./ID00647_1__TF-MUSIC.jpg": 29110,
	"./ID00647_2__TF-MUSIC.jpg": 48525,
	"./ID00647_3__TF-MUSIC.jpg": 28412,
	"./ID00647_5__TF-MUSIC.jpg": 31514,
	"./ID00648_1_1efa2799-6f08-413c-8d85-69ef35393bb1.jpg": 13972,
	"./ID00648_2_d4373523-319f-4e58-b1e5-6d59b61d2cbf.jpg": 15422,
	"./ID00648_3_9f26c871-9b54-4409-a100-d458a84df085.jpg": 29528,
	"./ID00648_4_42797359-6547-4a4b-9034-9d5830039b68.jpg": 36809,
	"./ID00649_1_51921618-e048-43fd-9ad8-5161ea19828f.jpg": 34921,
	"./ID00649_2_57106b59-3b81-4d94-a721-06106b00b780.jpg": 79367,
	"./ID00650_2_cc49fdfb-d0bd-40d4-9e05-ac36fbbe3a78.jpg": 25503,
	"./ID00650_3_9863128b-1834-4e3b-8d2c-8747a5c81e90.jpg": 37839,
	"./ID00650_4_e09b5f9c-e426-4e68-9b46-a9f52698b6c9.jpg": 63696,
	"./ID00650_5_c64121c0-072c-4f70-8c81-af65d04cf531.jpg": 30048,
	"./ID00651_1_EduStarCreativeCenter.jpg": 12140,
	"./ID00651_2_EduStarCreativeCenter.jpg": 88979,
	"./ID00652_1__WISELADEDUCATION.jpg": 83667,
	"./ID00652_3__WISELADEDUCATION.jpg": 56845,
	"./ID00652_4__WISELADEDUCATION.jpg": 37754,
	"./ID00652_5__WISELADEDUCATION.jpg": 38495,
	"./ID00653_1_INSPIREACADEMY.jpg": 88344,
	"./ID00653_2_INSPIREACADEMY.jpg": 37133,
	"./ID00653_3_INSPIREACADEMY.jpg": 4350,
	"./ID00653_4_INSPIREACADEMY.jpg": 93203,
	"./ID00654_1_MATHEMATICSEDUCATION.jpg": 44309,
	"./ID00654_2_MATHEMATICSEDUCATION.jpg": 90104,
	"./ID00654_3_MATHEMATICSEDUCATION.jpg": 88723,
	"./ID00654_4_MATHEMATICSEDUCATION.jpg": 93726,
	"./ID00654_Mathematics_Education_Centre__1_4x3_0731f241-74cb-4582-94b7-2dd7ab35c932.jpg": 85826,
	"./ID00654_Mathematics_Education_Centre__2_4x3_94022645-7e5d-4c82-b513-d296ac5559a0.jpg": 42596,
	"./ID00654_Mathematics_Education_Centre__3_4x3_0d181303-203a-4d9a-b0dd-6a0ba6084064.jpg": 9262,
	"./ID00655_1_Dr.SEMEducation.jpg": 26845,
	"./ID00655_2_Dr.SEMEducation.jpg": 60398,
	"./ID00655_3_Dr.SEMEducation.jpg": 21003,
	"./ID00655_4_Dr.SEMEducation.jpg": 77908,
	"./ID00656_1_JEILoveLearningCentre.jpg": 64276,
	"./ID00656_2_JEILoveLearningCentre.jpg": 72815,
	"./ID00656_3_JEILoveLearningCentre.jpg": 34814,
	"./ID00656_4_JEILoveLearningCentre.jpg": 91609,
	"./ID00657_1__NewmanEducation.jpg": 70361,
	"./ID00657_3__NewmanEducation.jpg": 50739,
	"./ID00657_4__NewmanEducation.jpg": 53874,
	"./ID00657_5__NewmanEducation.jpg": 44525,
	"./ID00658_1_4x3_1607528e-0a57-4d3c-a8b7-59c942f8c6ee.jpg": 17669,
	"./ID00658_1_4x3_64af7a64-dc3d-4a07-88e5-b2f4f37caa42.jpg": 82661,
	"./ID00658_2_4x3_25c075aa-afa0-48c8-bae7-65ea5fbc0fc6.jpg": 78000,
	"./ID00658_2_4x3_afc05165-a28e-4ea9-83b7-db64c2c850b8.jpg": 95321,
	"./ID00658_3_4x3_765062b1-de6c-4b2b-942f-f5c90a03df5c.jpg": 2554,
	"./ID00658_4_4x3_3b6f0219-47f5-4282-90cf-d078aa8c0421.jpg": 69852,
	"./ID00659_1_A.jpg": 79317,
	"./ID00659_2_A.jpg": 4502,
	"./ID00659_3_A.jpg": 23003,
	"./ID00659_4_A.jpg": 24620,
	"./ID00659_A__1_4x3_cba3369b-9472-4531-99ed-61ef72532171.jpg": 17760,
	"./ID00659_A__2_4x3_4bbb5b78-df13-4691-a6a9-73737bc11707.jpg": 65305,
	"./ID00659_A__3_4x3_c35ce33e-7340-457a-b67f-133ff3311c62.jpg": 66121,
	"./ID00659_A__4_4x3_289c2876-0617-4e1d-b73b-5ec1a09665ae.jpg": 79290,
	"./ID00660_1_16b6735f-6633-4c26-ad39-2f5cda18524b.jpg": 72913,
	"./ID00660_2_e0fcf123-e6d1-4524-8196-d0961a73a9b0.jpg": 17201,
	"./ID00660_3_759ca586-3170-4dae-9de8-728c78fe2b54.jpg": 56636,
	"./ID00660_4_ea79ee85-5364-422c-9e49-efea622861a8.jpg": 40641,
	"./ID00661_1_TREEHAUS.jpg": 60032,
	"./ID00661_2_TREEHAUS.jpg": 81493,
	"./ID00661_3_TREEHAUS.jpg": 83306,
	"./ID00661_4_TREEHAUS.jpg": 10423,
	"./ID00662_1_4x3_106e581e-0bc6-417e-9888-7af97467989a.jpg": 54266,
	"./ID00662_2_4x3_677bdfa9-64d1-4266-ba6f-cc8b6c50b721.jpg": 25287,
	"./ID00662_3_4x3_c982b5f0-ecf2-4a76-bd43-153277f9bfde.jpg": 96371,
	"./ID00662_4_4x3_1a3c5a83-6a43-4744-8073-ddf56ed6694b.jpg": 59958,
	"./ID00663_1__21.13.15.jpg": 39233,
	"./ID00663_2__21.13.15.jpg": 11558,
	"./ID00663_3__21.13.15.jpg": 47007,
	"./ID00663_4__21.13.15.jpg": 90532,
	"./ID00663_Hanlin_Master_Education_1_4x3_c6de9acc-75b8-46e5-b98b-3bfe43c13acc.jpg": 93372,
	"./ID00663_Hanlin_Master_Education_2_4x3_d706a792-0b01-49c9-85de-a1e722bf5fec.jpg": 28660,
	"./ID00663_Hanlin_Master_Education_3_4x3_8a75d1a9-c4ce-440a-8141-538c1164c3cb.jpg": 57038,
	"./ID00663_Hanlin_Master_Education_4_4x3_64ae5a26-6b9b-433f-b193-07f39ffa1819.jpg": 27068,
	"./ID00664_11_education_1_1_4x3_888c5b2d-422a-40fc-bd6e-7c097b81622a.jpg": 65077,
	"./ID00664_11_education_2_1_4x3_f091f1b6-2789-47b8-a88b-7d1c0a56a930.jpg": 78888,
	"./ID00664_11_education_2_2_4x3_64a27935-f041-46fd-bf38-51994c2a8316.jpg": 15557,
	"./ID00664_1_11_36de4593-d525-4064-88f3-8b66336d7256.jpg": 60285,
	"./ID00664_2_11_3ea911f0-1d3b-4833-bdf8-1d0da2bd9187.jpg": 57671,
	"./ID00664_3_11_8879fe19-3150-49dc-83c0-4654cdc90762.jpg": 29136,
	"./ID00664_4_11_9f216a81-362e-4264-aed9-0d83f8be548a.jpg": 57813,
	"./ID00665_1_a2e0d7c5-7d88-4cbd-baf4-9bf46dd187d0.jpg": 62218,
	"./ID00665_2_efbe16db-5c61-467a-affd-26eaf5c8d3fd.jpg": 27798,
	"./ID00666_1_4bc72de2-0a18-49a4-8dfb-9bd4fe2bf193.jpg": 5406,
	"./ID00666_1_4x3_933df1ca-c291-4860-bb6f-2cdd571e7a3b.jpg": 19109,
	"./ID00666_2_4x3_36dee4d2-3afd-44d2-8a96-9039d8fb6ab7.jpg": 38297,
	"./ID00666_2_7e396c50-61f6-4336-aa72-747b58fb1512.jpg": 99171,
	"./ID00666_3_f809a4d8-8d89-4dd9-a9a8-7b30a7dcaf13.jpg": 14515,
	"./ID00666_4_32b3b224-73fe-4e1b-9f03-23d41c637f21.jpg": 46306,
	"./ID00667_1_4b63a3e5-6775-4db2-8e25-eede5cdf95e5.jpg": 40498,
	"./ID00667_1_4x3_10faf301-f181-40e4-b401-84ecd9f95bf1.jpg": 21041,
	"./ID00667_2_03763ff3-5e3a-43ab-82b7-50bf6b3d321b.jpg": 5305,
	"./ID00667_2_4x3_58c55f1a-3914-4ee2-86dd-11cbd9db9397.jpg": 32541,
	"./ID00667_3_4x3_c5441fa2-6640-45b7-8385-e3b8e0d12f95.jpg": 97067,
	"./ID00667_3_785ca14d-460b-41e3-9af3-c53865bd07ab.jpg": 96864,
	"./ID00667_4_4x3_4767513f-0dd0-40b6-a1cb-f9d6148b1122.jpg": 21528,
	"./ID00667_4_71be3573-8931-4f84-896a-f06f0532bf8a.jpg": 81475,
	"./ID00668_1_4221527d-d9de-4107-a528-b27cab11e95a.jpg": 87372,
	"./ID00668_2_f8fb0aa4-3d37-4f53-9952-713fa6b468b9.jpg": 34316,
	"./ID00668_3_012471e7-fe49-4b22-9f94-68c122ac7462.jpg": 32418,
	"./ID00668_4_7282dd6d-d288-49a8-952b-1bff7c1d15a9.jpg": 41448,
	"./ID00668_Riverside_Learning_Centre_1_4x3_8cb4903a-90f6-4e39-a28c-b5384254f247.jpg": 35069,
	"./ID00668_Riverside_Learning_Centre_2_4x3_d1bab1fc-52ba-4caf-bdfd-8edc05c4162e.jpg": 62944,
	"./ID00668_Riverside_Learning_Centre_3_4x3_6135f3a5-9d9f-42b7-82c1-7622f05c2e10.jpg": 19889,
	"./ID00668_Riverside_Learning_Centre_4_4x3_dacad973-a0a4-4492-8a4a-0797f307fda1.jpg": 12164,
	"./ID00669_1_MAGOKORO.jpg": 72354,
	"./ID00669_3_MAGOKORO.jpg": 82820,
	"./ID00669_4_MAGOKORO.jpg": 80569,
	"./ID00669_5_MAGOKORO.jpg": 19462,
	"./ID00669_Magokoro__1_4x3_6c271080-b1be-410d-a746-2b6c92e003f4.jpg": 89968,
	"./ID00670_1_42bd243a-6dd2-483c-9f52-5367588db751.jpg": 70214,
	"./ID00670_2_e2eecaec-8db6-487d-a912-7758daa9b496.jpg": 51564,
	"./ID00670_3_82f3f9c2-4d19-4fe2-942a-03bdf039fc3b.jpg": 86562,
	"./ID00670_4_994cda09-66bd-4ec5-88a5-235756fcfced.jpg": 68959,
	"./ID00671_1_angelstep.jpg": 78651,
	"./ID00671_2_angelstep.jpg": 27144,
	"./ID00672_1_6cfdd754-f53d-4f13-a895-c8c6e9cf3ddc.jpg": 20348,
	"./ID00672_2_af8e56cc-d63a-48ce-a004-a5b7d407aead.jpg": 93581,
	"./ID00672_3_192dd2eb-4c15-4584-a36c-c88174ce20a2.jpg": 66743,
	"./ID00673_1_DANCEARTPLUSSTUDIO.jpg": 85836,
	"./ID00673_2_DANCEARTPLUSSTUDIO.jpg": 40781,
	"./ID00673_3_DANCEARTPLUSSTUDIO.jpg": 85806,
	"./ID00673_4_DANCEARTPLUSSTUDIO.jpg": 11415,
	"./ID00674_1_2e7b7d92-9b0d-4fbf-b1d5-ea2c7790a949.jpg": 59153,
	"./ID00674_2_2d46ddea-9cff-4b82-8e97-91ee578995c4.jpg": 82157,
	"./ID00674_3_2f363cd2-89f1-4fa4-ade6-cc0f55f9ff0d.jpg": 87670,
	"./ID00674_4_db93ce18-78f4-4405-835c-7cbcf0577fab.jpg": 69907,
	"./ID00675_1_e9df4620-20c7-4600-861a-89e666f7fd7d.jpg": 21468,
	"./ID00675_2_77f9d354-e676-4327-898f-e9dc909bfb94.jpg": 48621,
	"./ID00676_1_be8028a1-0b9e-4fd4-8160-249e14bcf7e0.jpg": 7209,
	"./ID00676_2_ccda64c9-9620-47fc-bc2b-44ea4ec23ec7.jpg": 58863,
	"./ID00677_1__MoriAtelier.jpg": 42278,
	"./ID00677_2__MoriAtelier.jpg": 19367,
	"./ID00677_3__MoriAtelier.jpg": 93608,
	"./ID00677_4__MoriAtelier.jpg": 54097,
	"./ID00678_1_d1a62dc3-6f76-44f2-89db-8868ddd15d86.jpg": 40697,
	"./ID00678_4_238d4fd4-d7c8-4322-a14a-a39f9dc9a23a.jpg": 80196,
	"./ID00678_5_385a71c0-299a-40fd-8d12-1c3ec89da6fc.jpg": 67409,
	"./ID00678_6_9809280c-4ed6-4e97-86ac-f8c3040a6a0d.jpg": 52917,
	"./ID00679_1_bc245330-b320-4b18-9e81-4e355279782f.jpg": 22322,
	"./ID00679_2_0899a43c-ceae-4304-9402-30fbb151fbb7.jpg": 52277,
	"./ID00679_4_e57fd51d-8510-4273-85ef-3a988408831e.jpg": 63272,
	"./ID00679_5_adac9890-ed0e-4e8b-a92f-e94a0eb7367d.jpg": 81825,
	"./ID00680_1_ArtPort_Studio.jpg": 54851,
	"./ID00680_2_ArtPort_Studio.jpg": 22218,
	"./ID00680_3_ArtPort_Studio.jpg": 31481,
	"./ID00680_4_ArtPort_Studio.jpg": 80112,
	"./ID00681_1_4fac5837-4929-444a-8556-d23899046935.jpg": 47265,
	"./ID00681_2_4b4e801d-6e4e-4cd1-a25a-3b25c181b17b.jpg": 18878,
	"./ID00681_3_dacdab53-dc9d-4878-a12f-9762a359bebb.jpg": 80314,
	"./ID00681_5_76467a0d-5810-4697-bd5d-402c6851d0c6.jpg": 76973,
	"./ID00682_1__DCBallet.jpg": 48740,
	"./ID00682_2__DCBallet.jpg": 4923,
	"./ID00682_DC_Ballet_DC_Ballet_1_4x3_c3dafd64-add6-47ca-a2ed-4e3ba667b85b.jpg": 43464,
	"./ID00682_DC_Ballet_DC_Ballet_2_4x3_607ff914-ead1-46a4-8d8b-3cd600171947.jpg": 65859,
	"./ID00683_1_JEIBrainKeyEducationCentre.jpg": 85513,
	"./ID00683_2_JEIBrainKeyEducationCentre.jpg": 65384,
	"./ID00683_3_JEIBrainKeyEducationCentre.jpg": 75639,
	"./ID00683_4_JEIBrainKeyEducationCentre.jpg": 81558,
	"./ID00684_1_MoodEducation.jpg": 46399,
	"./ID00684_2_MoodEducation.jpg": 97056,
	"./ID00684_3_MoodEducation.jpg": 52853,
	"./ID00684_4_MoodEducation.jpg": 91646,
	"./ID00685_1__HonorExpertEducationCentre.jpg": 93971,
	"./ID00685_2__HonorExpertEducationCentre.jpg": 71996,
	"./ID00685_3__HonorExpertEducationCentre.jpg": 53229,
	"./ID00685_4__HonorExpertEducationCentre.jpg": 78622,
	"./ID00686_1_4x3_41136ca0-a2c7-47ad-b388-645ae15e88c3.jpg": 57551,
	"./ID00686_2_4x3_eac9806d-01e4-4f98-a348-2ed37c9e8a2c.jpg": 83970,
	"./ID00687_1_72eb7afe-3483-4b9d-920f-8b85a44f9c7d.jpg": 1021,
	"./ID00687_2_1bcad921-ddf1-469f-84a0-1cf4deea1ee8.jpg": 58552,
	"./ID00687_3_bb8143f8-8634-456c-a160-426a5deae528.jpg": 19206,
	"./ID00687_4_0a0d98a3-b5e5-438b-8d7e-382723665e0a.jpg": 47460,
	"./ID00687_Little_Scientists_Edu_1_4x3_05dfac0f-feb3-436f-9813-04a9e7cea70a.jpg": 94531,
	"./ID00687_Little_Scientists_Edu_2_4x3_7cde3ffc-9ec5-468a-bbf7-c292b37420aa.jpg": 65873,
	"./ID00688_1_0956efe6-7409-485b-9094-d21d14b42b46.jpg": 4963,
	"./ID00688_1_4x3_e0ae2b55-6341-455e-b876-ecbee77979a5.jpg": 72864,
	"./ID00688_2_4x3_0c86c947-b7f6-4c9b-a4bf-1a6c54674388.jpg": 99731,
	"./ID00688_2_79472343-9c48-4026-8e5f-19374bd304fb.jpg": 71329,
	"./ID00688_3_4x3_7b9403f2-993e-48f0-b67b-5648a96fa834.jpg": 72303,
	"./ID00688_3_fbbfcae5-91a7-49d6-873e-ed56f46e67db.jpg": 8428,
	"./ID00688_4_4x3_f9e2a3ed-5445-4b3e-8cc8-fd7b61e903de.jpg": 76296,
	"./ID00688_4_8da88429-20ad-4d9b-a30b-86c2da63e00c.jpg": 7386,
	"./ID00689_1_a18947de-6811-463c-b39d-5db8658e3c85.jpg": 2928,
	"./ID00689_2_72363ebe-bf91-41c8-99b2-a9ad84a68efd.jpg": 22990,
	"./ID00689_3_8b72d963-5eef-436b-997c-120186b5d110.jpg": 72433,
	"./ID00690_1_e9aed984-a640-4ba1-90a2-f09a47983522.jpg": 64353,
	"./ID00691_2_e85c5b7f-a3a1-441f-857d-6559465d0b4e.jpg": 38278,
	"./ID00691_5_e4c285a1-766a-40a3-934f-814ba1b3e422.jpg": 5224,
	"./ID00691_6_b91a72bf-0169-4f73-bb69-1e1737c5af2f.jpg": 98371,
	"./ID00691_7_43a61f3e-37b8-44d5-a1ec-5712804c956b.jpg": 9952,
	"./ID00692_1_931cc176-897e-4fb4-a5a5-92e063e88025.jpg": 66576,
	"./ID00692_1_c1e91f7b-d3f3-49e0-947f-b5b27e0ca5b6.jpg": 57621,
	"./ID00692_2_0ddee35e-1ef9-405a-9b0a-77b9226345a0.jpg": 18630,
	"./ID00692_2_2934161e-2a5f-422e-b1d1-585d208669c3.jpg": 9771,
	"./ID00692_3_53d22769-b9be-450f-86e8-e8d54f2f7560.jpg": 51363,
	"./ID00692_3_ac8ab57b-25ad-4d1d-b618-c3c6c8bd8597.jpg": 17553,
	"./ID00692_4_0e3b02d3-91a0-4434-9b49-41757f9aeb0f.jpg": 90694,
	"./ID00692_4_8155f54b-9f2a-490a-81d1-d348ed9a9277.jpg": 95921,
	"./ID00693_289_14_D_1.jpg": 5356,
	"./ID00693_2_347ade57-b377-4121-b96d-71b65f03c484.jpg": 99186,
	"./ID00693_WhatsApp_Image_2025-01-14_at_4.50.00_PM.jpg": 8932,
	"./ID00694_1_EnglishStation.jpg": 50677,
	"./ID00695_Big_Lemon_ART.jpg": 82380,
	"./ID00696_1_enngo.jpg": 16908,
	"./ID00696_2_enngo.jpg": 96767,
	"./ID00696_3_enngo.jpg": 9878,
	"./ID00696_4_enngo.jpg": 28705,
	"./ID00697_Wayful_Success_Education_Centre_1_4x3_4e0e709e-866c-4d30-9afe-9c5ca950b635.jpg": 28771,
	"./ID00697_Wayful_Success_Education_Centre_2_4x3_91322ebd-3bb0-4abf-a34c-88cf1b500b30.jpg": 22558,
	"./ID00697_Wayful_Success_Education_Centre_3_4x3_38d94b40-dc43-4dbe-9f6b-b6d71f4bd448.jpg": 22942,
	"./ID00697_Wayful_Success_Education_Centre_4_4x3_a8695fa7-e05e-4813-8687-4125da64732b.jpg": 11355,
	"./ID00698_1_3446d883-aec3-407f-ab93-cd0907532ad2.jpg": 34331,
	"./ID00698_2_f83fd189-8461-4ba3-9565-2b39b36292ad.jpg": 54614,
	"./ID00698_3_b3b11eb1-f27b-40a8-b469-b5f6ab450119.jpg": 62473,
	"./ID00698_4_49113359-98fc-4e41-8efa-60559a3c09c3.jpg": 97478,
	"./ID00699_1_ChimaMusicStudio.jpg": 56721,
	"./ID00700_1_727d4d62-f70a-4709-b7f1-1a9d966496fb.jpg": 79402,
	"./ID00700_2_541663ba-a4e8-4980-9020-78d54c989188.jpg": 87126,
	"./ID00700_3_609d60d7-a1f4-4a43-82a3-78815943c664.jpg": 88045,
	"./ID00700_4_02729d40-b514-4330-a9a6-5d3c4242fb64.jpg": 75666,
	"./ID00701_1_4x3_f8ebc81f-09ce-4c94-9408-617e784fa87c.jpg": 53122,
	"./ID00701_2_4x3_e3bab25d-f42b-42ea-8211-5ab22be499ac.jpg": 3730,
	"./ID00701_3_4x3_58cbe544-6121-4df3-a210-126591eb08e0.jpg": 43667,
	"./ID00701_4_4x3_bf605904-105f-4217-a9a4-04789b8e6172.jpg": 37759,
	"./ID00702_1_57bd8b09-75ae-495f-bf70-93731736579a.jpg": 47470,
	"./ID00702_2_b67dca6e-a866-4d03-8853-6e694603f1d6.jpg": 5336,
	"./ID00703_KIDS_LAB_1_4x3_0e896c8e-6cce-485b-afe0-ae8550d0a1f8.jpg": 65604,
	"./ID00703_KIDS_LAB_2_4x3_da96b6b8-f6c1-4412-be90-a0ff628d1ed3.jpg": 83896,
	"./ID00703_KIDS_LAB_3_4x3_63ee76ab-a1d1-4f12-928c-2d2459b22ca5.jpg": 21366,
	"./ID00703_KIDS_LAB_4_4x3_706c6c31-9016-4d6b-974a-d77c030d68d6.jpg": 75149,
	"./ID00704_DreamDanceandartstudio_1_4x3_fabddc9e-6347-418a-82cd-5d76a213189f.jpg": 25428,
	"./ID00704_DreamDanceandartstudio_2_4x3_118adc0b-6456-4290-8f51-773cb3d4e933.jpg": 5790,
	"./ID00704_DreamDanceandartstudio_3_4x3_0121d0b1-d567-4cd1-85c5-6bc8d64901b2.jpg": 54237,
	"./ID00704_DreamDanceandartstudio_4_4x3_38d9ffd5-d6f4-4db3-b8b5-a0d32b9e1053.jpg": 49473,
	"./ID00705_1_f9516405-d868-4e38-a3a2-66cc1a7f42a4.jpg": 84181,
	"./ID00705_2_e117280d-ef3b-4852-a1b3-3ecbb9acb5ac.jpg": 36344,
	"./ID00705_3_d4e2e8b2-a516-4b71-a064-8a92d7c6ef55.jpg": 29647,
	"./ID00705_4_c4b460b6-fb03-4788-abcc-bc3214c79aac.jpg": 57596,
	"./ID00706_1_JungleParadise-EducationCentre.jpg": 74789,
	"./ID00706_2_JungleParadise-EducationCentre.jpg": 11848,
	"./ID00706_3_JungleParadise-EducationCentre.jpg": 35787,
	"./ID00706_4_JungleParadise-EducationCentre.jpg": 31950,
	"./ID00707_1_7864e5a7-aa7e-4fd9-bd07-caea21dd4002.jpg": 14054,
	"./ID00707_2_7d8c6b32-2c53-495c-975a-1259f000bc20.jpg": 61344,
	"./ID00707_3_522e2a9b-1e00-42c9-86e8-77f382093f6a.jpg": 50319,
	"./ID00707_4_168f81a1-3ed0-4e6d-a3fd-fef5b9235080.jpg": 76369,
	"./ID00708_1_HelloKidsLearningCenter.jpg": 30633,
	"./ID00708_2_HelloKidsLearningCenter.jpg": 30134,
	"./ID00709_1_13c33371-45bc-4603-aaa4-a974f1acf4df.jpg": 53526,
	"./ID00709_2_89beb362-e323-4ff0-871d-02bb946d42af.jpg": 64845,
	"./ID00709_3_f34e9ed3-dd96-41b2-8532-2dda1453b8e2.jpg": 12956,
	"./ID00709_4_479634e5-7e05-4234-bb02-9f9d1009bca1.jpg": 61304,
	"./ID00709_CreativeZoo_Playgroup_and_Art_Center_1_4x3_81a406e8-15a3-4242-ae4f-314b1551d550.jpg": 13069,
	"./ID00709_CreativeZoo_Playgroup_and_Art_Center_2_4x3_704b82f5-50e3-46cf-8569-8cc71ca85091.jpg": 67094,
	"./ID00709_CreativeZoo_Playgroup_and_Art_Center_3_4x3_456d009b-a2ee-49cf-b5d2-db0bc68f4507.jpg": 65592,
	"./ID00710_1_07b616dc-1eaf-4e0f-8568-83b0d2d40cd6.jpg": 78270,
	"./ID00710_2_ed99a44d-6324-4481-ad7e-7e8f74647dd9.jpg": 50037,
	"./ID00710_3_7b61abe5-007b-4470-ac83-1b9731cdce46.jpg": 44308,
	"./ID00710_4_d49f0261-cdea-4693-969f-92ae90b372cf.jpg": 67419,
	"./ID00711_1_f70c817c-8606-4da6-933c-6b3069f36ea6.jpg": 44845,
	"./ID00711_2_10aa351c-4230-4641-9d20-596e8d5bd28a.jpg": 59767,
	"./ID00711_3_9cfc5d92-524b-45f0-89b1-89282f0654d6.jpg": 24656,
	"./ID00711_4_aa2108b5-027a-4b3a-909e-35cd3c9b55d7.jpg": 93088,
	"./ID00712_1_4x3_baf934fa-c34c-4e88-9bd2-ff2cd6d0e889.jpg": 37034,
	"./ID00712_2_4x3_a1c138c7-e379-4cd4-8a9d-5cf967dcfdb3.jpg": 16661,
	"./ID00712_3_4x3_edad35a5-eaa7-452f-a514-3c1adb785858.jpg": 16597,
	"./ID00712_4_4x3_398ef1a4-3ed3-4e32-856f-1edb36a38085.jpg": 48066,
	"./ID00713_1_3d7e594b-4a52-42b6-a089-b79f76be83df.jpg": 86303,
	"./ID00713_1_4x3_4d051f9a-37e4-4f1d-9ba5-31f7b5dace47.jpg": 78508,
	"./ID00713_2_d7c94395-0515-4b5c-bfce-6bacf3db471b.jpg": 79778,
	"./ID00713_3_b741353d-885f-4dd3-b8df-e11c470dc54b.jpg": 37327,
	"./ID00713_4_74bb1b93-f24e-4c61-bd70-162a01d3f6e5.jpg": 44128,
	"./ID00714_1_FUNtasticEducationCentre.jpg": 58400,
	"./ID00714_2_FUNtasticEducationCentre.jpg": 45237,
	"./ID00714_3_FUNtasticEducationCentre.jpg": 10858,
	"./ID00714_4_FUNtasticEducationCentre.jpg": 31783,
	"./ID00715_1_fe4f33f8-aa40-40ed-a995-b8fc8fe531fd.jpg": 75160,
	"./ID00715_2_7d5b7570-39ef-463e-b122-4803bcfc2eff.jpg": 85973,
	"./ID00716_1_d5a0b8e7-a29b-4662-a2bc-5f1ce73f9bf7.jpg": 92884,
	"./ID00716_2_3a37c8bd-c40d-47f3-bf2c-5e85f7fb0105.jpg": 19144,
	"./ID00716_3_c6e7596d-b549-48ff-b635-ec27b372e569.jpg": 13897,
	"./ID00716_4_12c9228a-81b8-4ed9-bc19-d94cf1d61cbe.jpg": 2399,
	"./ID00717_1_4x3_db5427dc-685a-47a0-a33d-92d18d706dab.jpg": 91291,
	"./ID00717_2_4x3_16b18676-2ea9-4b6c-9a04-f854520b5395.jpg": 24265,
	"./ID00718_1__TheStudyPlace.jpg": 60954,
	"./ID00718_2__TheStudyPlace.jpg": 11995,
	"./ID00718_3__TheStudyPlace.jpg": 44640,
	"./ID00718_4__TheStudyPlace.jpg": 77513,
	"./ID00719_1_3255ac8e-9ed1-48d7-8ac1-73761df2ad2f.jpg": 91277,
	"./ID00719_2_bd58bec2-f4b2-43b8-a40b-ecbfdd60f98e.jpg": 13477,
	"./ID00719_3_e00223de-9df8-4367-9339-ca0e5c2fdec9.jpg": 12527,
	"./ID00719_4_55cbc678-39da-4e73-84f7-62db30ce2b42.jpg": 9527,
	"./ID00720_1_Artzwork.jpg": 61829,
	"./ID00720_3_Artzwork.jpg": 70567,
	"./ID00720_4_Artzwork.jpg": 76114,
	"./ID00721_1_e6213fd8-3abf-4ac3-8e70-d8849fb36caf.jpg": 35416,
	"./ID00721_2_96b10a87-c357-4cfb-909d-e14cc16a1a82.jpg": 92312,
	"./ID00721_3_432c9f4a-5ca9-4062-8780-ea346e2c65f0.jpg": 81897,
	"./ID00721_4_a64322cf-b44b-47de-9718-d7b24e954245.jpg": 42148,
	"./ID00722_1_ada337bb-d180-4171-a1cd-d2d594c51d91.jpg": 36812,
	"./ID00722_2_a13da90c-6b1a-48d7-aa94-ef52b919290d.jpg": 15532,
	"./ID00723_3_f2b38c80-35c9-47c3-9dd1-71f22924c9f1.jpg": 1957,
	"./ID00723_4_f25a34c6-4635-4d4d-b1c3-4c9147757c1f.jpg": 58003,
	"./ID00724_1_52701a55-8ee6-485a-9cfb-2cecaa82fde3.jpg": 17848,
	"./ID00724_2_e15d017d-48ff-46c1-8339-04a54c2be172.jpg": 61026,
	"./ID00725_1_17dc8693-c378-4b54-ac8c-ae5a3a6377b2.jpg": 1649,
	"./ID00725_2_0e780ce4-a928-418b-81d6-ad60615531ba.jpg": 41062,
	"./ID00725_3_7a2d2a41-034e-40f1-946d-37853e3f7a9e.jpg": 61848,
	"./ID00725_Mr_Paintbrush__Mr_Paintbrush__1_4x3_33635452-8d6e-4372-8d47-f6d8384b51e2.jpg": 20741,
	"./ID00726_1_3cb6889d-06d3-46a1-8209-e28a93b1936c.jpg": 37398,
	"./ID00726_2_0f2067fe-458b-4028-98b6-9ef81f580f76.jpg": 44073,
	"./ID00726_3_ae7df764-8cdf-40b6-8938-0bf4063f1e85.jpg": 39491,
	"./ID00726_4_9ce670dc-fa40-4ab8-a424-c1e27c284281.jpg": 60264,
	"./ID00727_1_7e782543-a1ab-408a-ae8f-7cc5c393721b.jpg": 54275,
	"./ID00727_2_8ea19dbc-5a42-4868-b834-5400302c7fb3.jpg": 2302,
	"./ID00727_3_67ea20ec-bebe-4ce6-8a55-2320eb6374dc.jpg": 55893,
	"./ID00727_4_e760a296-69c6-42a0-a3fc-98a2a85f8136.jpg": 5893,
	"./ID00728_2_broadsight.jpg": 54296,
	"./ID00728_3_broadsight.jpg": 93836,
	"./ID00728_4_broadsight.jpg": 19249,
	"./ID00728_5_broadsight.jpg": 30338,
	"./ID00729_1_98c319f0-ad8f-4b59-86b2-8736b56d103f.jpg": 74843,
	"./ID00729_2_7a5a8919-9f11-46a5-b312-4bcedc5ebcea.jpg": 3847,
	"./ID00729_The_Grapes_Education_The_Grapes_Education_1.jpg": 55801,
	"./ID00730_1_d5282ab3-4f7a-44f8-a67a-400adf9c063a.jpg": 4195,
	"./ID00730_2_e435626b-5a3d-4a4b-858f-ddcf279a105b.jpg": 2455,
	"./ID00731_1_8c710d07-5235-40ff-89b5-a817a2399294.jpg": 25782,
	"./ID00731_2_a7851b6e-c921-48ba-90e4-9a2a347d34b1.jpg": 25620,
	"./ID00731_3_d5a8dd84-de42-44e9-9010-fd5bd7e5b526.jpg": 92945,
	"./ID00731_4_b5e3cc82-4b76-4324-a029-b85fb1033093.jpg": 40263,
	"./ID00732_1_325f3c1e-d055-4bab-872a-f447a112f0c2.jpg": 30202,
	"./ID00732_2_98b903cd-f8c9-4561-a524-deebd18d80eb.jpg": 60333,
	"./ID00732_3_2a1c393a-e362-4332-a161-8550c38df1ce.jpg": 47579,
	"./ID00732_Little_Beijing_Chinese_Education_Centre.jpg": 71054,
	"./ID00733_2_218ee644-7d47-40ce-b539-ab0a2601fbf1.jpg": 2506,
	"./ID00733_Tak_Shin_Education.jpg": 53097,
	"./ID00734_2_1c891c17-5aac-4971-b805-f43c37986566.jpg": 9580,
	"./ID00734_3_f0c3946f-12ff-4361-a8a3-6e5b1720b3d8.jpg": 89550,
	"./ID00734_4_35bb99ea-f042-4382-8a55-c22c7df54f8f.jpg": 16187,
	"./ID00734_Login_Educational_Centre.jpg": 18059,
	"./ID00735_2_65a8611d-a10c-4174-b8fa-70c9dceb797b.jpg": 65646,
	"./ID00735_Creat_Learning.jpg": 2511,
	"./ID00736_2_2e36c2c9-310e-4772-ba39-e7c1a5fb2157.jpg": 60067,
	"./ID00736_I_Can_Read_learning_reading_english.jpg": 94990,
	"./ID00737_1_4x3_022c55dc-0ec9-47e7-9d56-fc4bf84119af.jpg": 26008,
	"./ID00737_2_4x3_d533e46f-e5db-4b12-87c7-07e2f777bf47.jpg": 40308,
	"./ID00737_2_50a1a828-4304-4cbe-9c30-96801bf3f38f.jpg": 22152,
	"./ID00737_3_023af63c-07d8-43b8-910c-147651478c88.jpg": 41518,
	"./ID00737_3_4x3_8af55f2d-cca6-4190-a562-55a20a2a5c05.jpg": 51865,
	"./ID00737_4_4x3_ceb47fa5-5b11-4ca0-9b03-e98f9fab40e7.jpg": 39040,
	"./ID00737_4_fbc832c6-42af-476f-ace7-7dec4d4545b7.jpg": 48513,
	"./ID00737_Starbridge_Education_Centre.jpg": 7547,
	"./ID00738_Seedling_Table_Tennis_School.jpg": 36511,
	"./ID00739_1_352227c4-5b57-4665-aba8-3f23b6ab01de.jpg": 53980,
	"./ID00739_3_15bbd0f5-0164-4a0a-bdae-94fd1ee74bc3.jpg": 83025,
	"./ID00739_4_c890b344-f422-4f7e-bd53-7c1417a98e56.jpg": 6354,
	"./ID00739_6_86e1bd97-ca78-4d9e-9ae9-c4384d85ee47.jpg": 59173,
	"./ID00740_2_bda58b7f-399e-4f74-8429-06e89c2fa9d7.jpg": 74475,
	"./ID00740_3_a5e56315-c40c-4794-a0a5-6ae0221cb977.jpg": 62186,
	"./ID00740_4_272e0745-a38b-4476-a4bb-9ac3bf6412d1.jpg": 80722,
	"./ID00740_FUNG_WING_EDUCATION.jpg": 60552,
	"./ID00741_3_a402ae5e-ff2c-4871-bcd7-9cb0f0861532.jpg": 39973,
	"./ID00741_4_9dbf55eb-d7b6-4620-a68d-c1b16807cd4b.jpg": 5168,
	"./ID00741_5_d399bfa9-33d7-48c8-bf88-2259cdfbc44b.jpg": 3277,
	"./ID00741_English_Wise_Learning_Center.jpg": 2776,
	"./ID00742_Excellent_Mandarin_Language_Center.jpg": 56491,
	"./ID00743_2_b5b7afa3-3373-4534-9167-e0b5ddcc4da0.jpg": 29244,
	"./ID00743_3_2b8ba627-882f-4721-91c2-6029e286b95a.jpg": 67942,
	"./ID00743_4_7bf83c2f-e151-42c7-ada6-49c508fb47c9.jpg": 39646,
	"./ID00743_MATHS_GENERATION_ACADEMY_1.jpg": 5139,
	"./ID00744_f62eb440-6502-4e52-9fd1-306cc84b5bbb.jpg": 17951,
	"./ID00745_ICanCode_coding.jpg": 13389,
	"./ID00746_2025summercourse.pdf_4_4x3_de934159-5ae9-485c-93ec-a0c8543f52a1.jpg": 83211,
	"./ID00746_GP_poster_summer_2025_3.pdf_2_4x3_17ce823d-1a19-41ca-a59b-7f875068e8ea.jpg": 14607,
	"./ID00746_WhatsApp_Image_2025-06-18_at_9.53.14_AM_1_4x3_de6a4bbe-1032-42f2-8528-fe67c262473f.jpg": 846,
	"./ID00746_pdf_3_4x3_b817918d-b8d0-4cd9-b441-2a7dcd74930b.jpg": 52477,
	"./ID00747_Amazing_Education_Centre.jpg": 11534,
	"./ID00748_1_4x3_274a6f1a-ec81-4705-9545-d370ec4f5962.jpg": 78817,
	"./ID00749_2_2ee7432e-bb04-46ef-876a-a8d5b3340afa.jpg": 58689,
	"./ID00749_3_737f519d-b1e4-4016-a7c9-42330a681e62.jpg": 95278,
	"./ID00749_4_87ad5cf5-673e-4ab3-a6db-7091053e0bd3.jpg": 3669,
	"./ID00749_So_in_maths.jpg": 63166,
	"./ID00750_2_7b440613-3864-496c-9e4b-cf0948e9f194.jpg": 44439,
	"./ID00750_3_77f10800-36ae-47d4-b032-2cb2148811b4.jpg": 52308,
	"./ID00750_4_1d4f8720-9bc3-4c1d-9cd8-7ae2bc2cd4ec.jpg": 37305,
	"./ID00750_Learning_center_Tsuen_Wan.jpg": 12005,
	"./ID00751_2_187f0335-cfcf-4e82-a5db-2337f856798c.jpg": 73867,
	"./ID00751_3_6e62c38e-041c-4285-b14e-780313e119f7.jpg": 77869,
	"./ID00751_4_a7b2ac49-690c-4051-b5ab-2839156632ee.jpg": 59902,
	"./ID00751_Bubbly_English.jpg": 73246,
	"./ID00752_1_91dcc01a-5623-4081-9af4-5e1db0daff18.jpg": 66530,
	"./ID00752_2_e58bb075-f4cd-4e42-9ed4-b0ae290426c1.jpg": 34432,
	"./ID00753_2_49a96603-5ab9-49fd-af4f-a17b87c77bf9.jpg": 13855,
	"./ID00753_3_670d577d-a28d-45ad-b0d6-438ad98e5d82.jpg": 52819,
	"./ID00753_4_22335777-433f-49d4-8487-31bcd8220c77.jpg": 92720,
	"./ID00753_MathConcept_Education_maths.jpg": 70938,
	"./ID00754_Eye_level_Maths_English_Chinese.jpg": 26697,
	"./ID00754_Eye_level_chinese.jpg": 19188,
	"./ID00754_eye_level_English.jpg": 91265,
	"./ID00754_eye_level_math.jpg": 87111,
	"./ID00755_1_1a7cf810-763e-4c46-932e-602e1588d335.jpg": 63929,
	"./ID00755_2_6f70c37f-81b1-4901-af23-0ced702b0c6e.jpg": 48703,
	"./ID00755_3_c85d4f2b-fecd-46b8-9c7d-154b71683b2c.jpg": 51450,
	"./ID00755_4_bbd3df4a-daa6-47e5-871a-c4da49d2a5d1.jpg": 10336,
	"./ID00756_2_bc8d3061-a4a3-4542-bb31-885ed1a68749.jpg": 76616,
	"./ID00756_3_8eb4eb5d-741b-4bc5-ad98-44cd7d6f0e18.jpg": 21903,
	"./ID00756_4_61deba85-bfc9-4a41-a2d6-780c783665b6.jpg": 31293,
	"./ID00756_CCDA.jpg": 22859,
	"./ID00757_2_732ee6fe-86be-41aa-821d-d550e63628ec.jpg": 93576,
	"./ID00757_3_13290700-caa3-483d-8c9f-988988d94c34.jpg": 29475,
	"./ID00757_4_c79ba1e4-ddbb-4385-95d8-ca3b5c461b06.jpg": 62516,
	"./ID00757_Yan_s_Superb.jpg": 14115,
	"./ID00758_2_946a8013-e0fb-4c69-b33d-46c4fef46d43.jpg": 74613,
	"./ID00758_Petite_Princess_Academy_of_Dance_BALLET_JAZZ.jpg": 36953,
	"./ID00759_2_fca5550a-7820-48d4-ba4f-3b9a07a3f4ec.jpg": 40110,
	"./ID00759_3_4b937be3-9821-473a-98e6-d4e502978c10.jpg": 32083,
	"./ID00759_4_eb8f198d-0d80-4c0c-836c-784edadbe4bd.jpg": 29827,
	"./ID00759_English_Excel_Triniry_cambridge_exam.jpg": 93880,
	"./ID00759_excel_english_1_4x3_edd94d63-fa58-46c5-858c-e793e39bfebd.jpg": 55347,
	"./ID00760_Tw9_1_4x3_efb7b497-3fba-4fab-9f02-b5329e0e222a.jpg": 80880,
	"./ID00760_Tw9_2_4x3_5082d39e-9bf9-46d7-ab01-2a2b3d2bc4c5.jpg": 78909,
	"./ID00760_Tw9_3_4x3_520d0b32-373f-4185-8f84-fa46cf810648.jpg": 63518,
	"./ID00761_1_fdea697a-89ee-4cbc-83e0-6625c9ce0e7a.jpg": 45664,
	"./ID00761_2_86da9f58-c7c2-46ce-bf98-bed141e411f0.jpg": 98570,
	"./ID00762_2_09a9d79e-fb14-4c0c-a517-eeedf5b0da30.jpg": 83,
	"./ID00762_3_a1645d5b-38bf-4e44-85fa-a7be83f65b5e.jpg": 21304,
	"./ID00762_4_17032299-559f-4642-836d-c4570c0c6c27.jpg": 11194,
	"./ID00762_Cheerful_Studio_lai_chi_kok.jpg": 16946,
	"./ID00763_1_9ecb57df-6e20-40f4-a8ad-67d1ef2fd05e.jpg": 63045,
	"./ID00763_2_4eafbeac-7dc0-416a-96f1-bee472ba8797.jpg": 65013,
	"./ID00763_3_104c4755-b912-4184-ba0b-461afe06d04b.jpg": 54524,
	"./ID00763_robocode_academy.png": 82496,
	"./ID00763_robocode_academy_1.png": 36664,
	"./ID00764_2_c5235cc8-83e6-4558-b40e-1cb13e5cf698.jpg": 48281,
	"./ID00764_4_34c2007b-1ca7-406e-aa6d-a20ca630d633.jpg": 61058,
	"./ID00764_Bonra_Education_Centre.jpg": 91952,
	"./ID00765_2_51adbbe6-2972-418c-a541-a6b72dbc4214.jpg": 43506,
	"./ID00765_3_e6cf1a6d-dfde-4b7c-a5e0-cd9cb0fd30c1.jpg": 90964,
	"./ID00765_4_396bbc36-b640-4a61-9323-8a234ea310f7.jpg": 83953,
	"./ID00765_Math_Blocks_Education_Centre.jpg": 72952,
	"./ID00766_2_b8e71d67-4f2c-4997-a97f-afe5187a2b1f.jpg": 40384,
	"./ID00766_3_b7d8eec5-ef43-43a4-87b3-10883de367f1.jpg": 70518,
	"./ID00766_4_198ded9c-8deb-47e1-bf99-0622b6f47388.jpg": 74715,
	"./ID00766_SDM_Jazz_Ballet_Academie_ballet_jazz.jpg": 9357,
	"./ID00767_2_9c009382-269d-4866-9a88-2bfacc209451.jpg": 70598,
	"./ID00767_3_f569117f-9011-4c26-bafe-bdee0dd7b61c.jpg": 95120,
	"./ID00767_4_73e251d8-95a6-44ea-a390-1a3107ce69a7.jpg": 93426,
	"./ID00767_Bilingual_by_Miss_Choy_BbC_Language_Centre.jpg": 57705,
	"./ID00768_Enchanted_English_Enchanted_English_1_4x3_d2ff08c0-a67c-4411-a342-4fa9bc55ecf2.jpg": 11550,
	"./ID00768_Enchanted_English_Enchanted_English_2_4x3_5b0f5cf5-2d5b-494a-8b97-2ac82748d937.jpg": 26861,
	"./ID00768_Enchanted_English_Enchanted_English_3_4x3_66dab26b-5ec4-4219-96b4-4dc07af2a0c4.jpg": 88711,
	"./ID00768_Enchanted_English_Enchanted_English_4_4x3_3d2b2dba-2704-4224-b086-2835ea23a732.jpg": 79449,
	"./ID00769_2_9b271f44-d51b-4035-9455-35474f9ab368.jpg": 75117,
	"./ID00769_3_791c853c-bbc0-4148-93ab-a0067b1dbf2d.jpg": 77633,
	"./ID00769_King_s_Glory_Education_interview_class.jpg": 71213,
	"./ID00770_2_2da4ac5b-6747-4176-9746-1943303bebc1.jpg": 13925,
	"./ID00770_3_7dee94da-fb36-4b20-b9ff-1ebde4766034.jpg": 92807,
	"./ID00770_4_5041144b-abc1-488f-981c-10ff5a977ed8.jpg": 16961,
	"./ID00770_KUMON_TAI_WO_HAU_EDUCATION_CENTRE.jpg": 90294,
	"./ID00771_2_698610d8-c2b6-4869-9176-a4491739f8ac.jpg": 57685,
	"./ID00771_3_a5931f07-6504-48cf-8dbc-ddd1caff4b83.jpg": 37180,
	"./ID00771_4_2cef29a7-e3ab-446d-8ee8-c8456047fabf.jpg": 33838,
	"./ID00771_Talent_Development_KK_Education_Centre.jpg": 51863,
	"./ID00772_2_6076475d-508f-4a6e-a8cc-e09fe7ae64b8.jpg": 32544,
	"./ID00772_3_a90f30a6-66ce-41c3-bf9e-85195e323281.jpg": 37845,
	"./ID00772_4_d3e20e06-9152-4c8b-9a9d-cc03c5fce5a2.jpg": 38308,
	"./ID00772_THINK_SMART_EDUCATION_CENTRE.jpg": 99803,
	"./ID00773_El_Camino_Music__El_Camino_Music__1_4x3_7b92e4ea-0533-4f75-802c-210e4d5389e6.jpg": 4672,
	"./ID00773_El_Camino_Music__El_Camino_Music__3_4x3_3d2bbde1-0b1e-43c4-afbd-bef69b911057.jpg": 9646,
	"./ID00773_El_Camino_Music__El_Camino_Music__4_4x3_4fd91ef4-382e-4c4e-9275-476cb11afdf3.jpg": 20058,
	"./ID00773_El_Camino_Music__El_Camino_Music__5_4x3_e038aab4-adb8-422e-803d-2f773bb6fd9b.jpg": 61600,
	"./ID00773_El_Camino_Music__El_Camino_Music__6_4x3_67e9fe4f-80dc-45db-8610-855b0eff5472.jpg": 67010,
	"./ID00774_2_f20ffb64-d3bc-4c8f-9d64-8324c76ea8d8.jpg": 5306,
	"./ID00774_3_f9deb734-6e21-4e90-bb52-fbe4e6e79a88.jpg": 69249,
	"./ID00774_7277085692e0dadf060e70e393862c47.jpg": 22767,
	"./ID00774_Knowledge_Base_goingclass.jpg": 60947,
	"./ID00775_2_6333b172-f7af-4c40-a9d1-68859bf835c2.jpg": 16148,
	"./ID00775_Backstage_Ballet_Studio_ballet_mei_foo.jpg": 40772,
	"./ID00776_1_ba70e083-e719-4607-9bd3-b1e93b2ebaeb.jpg": 88966,
	"./ID00776_1_db31a549-0aaa-48e6-858e-1fdc83051037.jpg": 12102,
	"./ID00776_2_833711dd-360f-4dac-977f-b9eb618e15c5.jpg": 95212,
	"./ID00776_taiwan_maths.jpg": 41194,
	"./ID00777_3_2dc54bc9-18bf-4484-acef-57bd3b655c56.jpg": 86306,
	"./ID00777_3_e62c78f7-221a-4a8c-8b55-ae642ce89b72.jpg": 93163,
	"./ID00777_4_21ffe251-46c5-4b8e-9f3e-c289ce4cea90.jpg": 16676,
	"./ID00777_4_a524841b-275d-40d8-a723-a3d5f83890eb.jpg": 99230,
	"./ID00777_5_2c125eda-a3e8-4c28-8e96-af5246ee4148.jpg": 11735,
	"./ID00777_5_649fd644-cf91-4c51-aa50-a9cf48a089c8.jpg": 28503,
	"./ID00777_6_135fe576-39ce-42ba-a367-956d1c4f5dfd.jpg": 16745,
	"./ID00777_MomoKing_Education_Centre.jpg": 80485,
	"./ID00778_2_6632293f-072d-402c-9c35-8501ebcab75f.jpg": 76937,
	"./ID00778_cad828c2-99c8-40c6-8e37-4b055eb96e6b.jpg": 34695,
	"./ID00779_2_865d20f8-3d6b-41c6-97ef-aa32a086d303.jpg": 98333,
	"./ID00779_3_ab15d2fc-68b1-44e9-a7bb-53880307c4c1.jpg": 18001,
	"./ID00779_Wisepine_Forest.jpg": 99145,
	"./ID00780_2_8c87d32a-3854-4bcc-8ed9-28bf287e11af.jpg": 51371,
	"./ID00780_3_e8397098-3527-4bee-b588-6d39e714879e.jpg": 15034,
	"./ID00780_4_3cf850c0-450d-4f93-937e-39fa69e51533.jpg": 1509,
	"./ID00780_Applause_Educational_Centre_tsuen_wan.jpg": 77881,
	"./ID00780_WhatsApp_Image_2025-07-02_at_10.56.54_AM_4x3_66f2faf4-0e52-44fd-8370-2dc342648fb6.jpg": 10653,
	"./ID00780_WhatsApp_Image_2025-07-02_at_10.56.55_AM_1__4x3_7476ff15-f6bd-42ac-a7f1-1407b529bbfe.jpg": 38782,
	"./ID00780_WhatsApp_Image_2025-07-02_at_10.56.55_AM_2__4x3_7aae18be-9458-4fc2-9b83-db8510c79b63.jpg": 21444,
	"./ID00780_WhatsApp_Image_2025-07-02_at_10.56.55_AM_4x3_5b09d986-5712-4a37-89b6-8f5027e247d7.jpg": 55502,
	"./ID00781_1_ARTCO_Gallery.jpg": 18664,
	"./ID00781_2_ARTCO_Gallery.jpg": 99883,
	"./ID00781_3_ARTCO_Gallery.jpg": 97114,
	"./ID00781_5_ARTCO_Gallery.jpg": 19596,
	"./ID00781_6_ARTCO_Gallery.jpg": 85759,
	"./ID00782_Golegendhk.jpg": 78475,
	"./ID00783_Mathwood_Education__north_point.jpg": 40578,
	"./ID00783_WhatsAppImage2024-12-17at3.00.46PM.jpg": 33551,
	"./ID00783_WhatsApp_Image_2025-02-11_at_7.37.49_PM.jpg": 32717,
	"./ID00783_WhatsApp_Image_2025-02-11_at_7.40.01_PM.jpg": 59483,
	"./ID00784_Joyful_Mind_goingclass.jpg": 73860,
	"./ID00784_Joyful_Mind_goingclass_1.jpg": 27868,
	"./ID00785_1_843a2e02-aa5f-4d99-84de-fcf37cacd3b1.jpg": 88075,
	"./ID00785_2_38a1fd76-0efc-4272-abf7-58cc98315f89.jpg": 62004,
	"./ID00785_2_b4bd780f-009e-4db4-9d7c-d478755fba61.jpg": 19989,
	"./ID00785_3_30fff5df-1722-4ebb-bddd-e689ac3d1375.jpg": 66412,
	"./ID00785_3_f54251dc-2539-4d22-8a4b-75f08a19423a.jpg": 13049,
	"./ID00785_4_484287bb-9837-4902-88e8-fd677616f433.jpg": 4254,
	"./ID00785_4_fb2f014f-d1bb-4a7e-ae95-69af44a839a8.jpg": 23648,
	"./ID00785_Gsmart_Education_goingclass.jpg": 41892,
	"./ID00786_2_65101544-7168-420a-b964-726d06e55a4c.jpg": 58956,
	"./ID00786_3_c96e5d64-8c7e-4e35-9c75-29fd560e6348.jpg": 42173,
	"./ID00786_4_cfa428d3-ceeb-4e9e-bd77-f612c87f61b4.jpg": 71529,
	"./ID00786_JEI_Learning_Centre_tsuen_wan.jpg": 6319,
	"./ID00787_2_9d66c953-5e91-4df8-b298-0af632716972.jpg": 11493,
	"./ID00787_3_a834631c-eeb5-403e-9bff-89b78eb22a8d.jpg": 95129,
	"./ID00787_4_97caac75-7572-4a02-b648-d53ccf68d6c5.jpg": 80343,
	"./ID00787_My_Dream_Education_Centre_goingclass.jpg": 87548,
	"./ID00788_1_1107da58-87d4-45c5-a31f-b42739ac262f.jpg": 4272,
	"./ID00788_2_3e73f373-5d7a-4763-aed2-ca4ac81871ca.jpg": 26363,
	"./ID00788_3_c1db549b-87f1-43dc-9442-6ddecc729559.jpg": 75252,
	"./ID00789_Modern_Bachelor_Education_goingclass.jpg": 30486,
	"./ID00789_Modern_Bachelor_Education_goingclass_1_-f141-44e6-a64e-580cbfda7eb6.jpg": 92077,
	"./ID00789_Modern_Bachelor_Education_goingclass_2.jpg": 94893,
	"./ID00790_Babington_Education_English_Learning_Centre_Babington_goingclass.jpg": 83889,
	"./ID00790_Babington_Education_English_Learning_Centre_Babington_goingclass_2.jpg": 29446,
	"./ID00790_Babington_Education_English_Learning_Centre_Babington_goingclass_3.jpg": 51619,
	"./ID00791_everygreen_way_1_4x3_fefc7b9d-46ed-4cc6-816b-29af2c46ad61.jpg": 52701,
	"./ID00791_everygreen_way_2_4x3_bb2fb932-ecb3-4738-bc7d-a32c53c2084d.jpg": 25020,
	"./ID00791_everygreen_way_3_4x3_aa69edaf-60a7-43ea-939f-d1cf3dfa453c.jpg": 99488,
	"./ID00791_everygreen_way_4_4x3_9aa89155-af24-4e80-ba94-f8d791bc123c.jpg": 13277,
	"./ID00791_everygreen_way_5_4x3_c03c461b-e78c-4e9a-8c9b-686ba5ebe459.jpg": 27462,
	"./ID00792_Skying_Tree_Education_Centre_goingclass_1.jpg": 46510,
	"./ID00792_Skying_Tree_Education_Centre_goingclass_2.jpg": 2649,
	"./ID00793_2_ada8efe4-a27e-4b15-b4ba-9a69fadbbf97.jpg": 97968,
	"./ID00793_3_47f339b1-ea44-4374-9062-66b3778b2715.jpg": 36771,
	"./ID00793_4_688ed5df-b884-4659-8ca0-734cd5c8611b.jpg": 36733,
	"./ID00793_G-Kids_Dance_Academy_goingclass.jpg": 25934,
	"./ID00794_1_72371c27-72bf-4286-bb4a-26dac30d4a6d.jpg": 75276,
	"./ID00794_2_f6275fd8-31ec-4a06-be37-0929eb8f5d04.jpg": 25993,
	"./ID00794_Greatness_Learning_Centre_Kwai_Hing_goingclass.jpg": 82208,
	"./ID00794_Greatness_Learning_Centre_Kwai_Hing_goingclass_1.jpg": 81728,
	"./ID00795_MC_Music_goingclass.jpg": 21928,
	"./ID00795_MC_Music_goingclass_1.jpg": 23512,
	"./ID00795_MC_Music_goingclass_2.jpg": 56359,
	"./ID00795_MC_Music_goingclass_3.jpg": 44202,
	"./ID00796_1_b1364e45-a293-4b9f-8c9c-950e19322b6e.jpg": 99596,
	"./ID00796_2_59d52010-40ca-46f7-bd52-d6a1e6433d52.jpg": 27059,
	"./ID00796_2_96f8821c-c2b1-469a-8017-ccadf4ee573d.jpg": 62816,
	"./ID00796_3_6a6c16e3-e822-40f9-b7f9-80283b3a2b28.jpg": 49678,
	"./ID00796_3_a18d2012-92ec-430c-a113-504d18eef3f0.jpg": 2583,
	"./ID00796_PhD_Scientists_goingclass.jpg": 18441,
	"./ID00797_Popular_Learning_GoingClassHK.jpg": 80801,
	"./ID00797_Popular_Learning_GoingClass_hong_kong.jpg": 3677,
	"./ID00797_Popular_Learning_goingclass_hk.jpg": 80248,
	"./ID00798_1_d8f23a7c-c794-4f73-8936-df91f21a3c68.jpg": 44427,
	"./ID00798_2_4ca97195-6e13-45d9-b46b-3f811187277b.jpg": 72798,
	"./ID00798_2_7cbb8a79-e59a-4a14-95b0-ad85a2e1c24b.jpg": 83658,
	"./ID00798_3_4909a430-a87f-44c7-aa0e-df992a086405.jpg": 41409,
	"./ID00798_3_798b81da-a688-40a5-ad19-697a169f70ca.jpg": 22470,
	"./ID00798_4_9ab2a1b8-6cde-44cf-b481-efb59ea77f4c.jpg": 24873,
	"./ID00798_4_c6fe62d1-cf07-40ee-aef2-ff35b40a1f03.jpg": 57073,
	"./ID00798_5_3bce19ef-746b-4ba6-bd97-5a6c7efd65c1.jpg": 84850,
	"./ID00798_6_15ece1e9-dbfd-41a7-9d4d-fe164a32abc6.jpg": 23823,
	"./ID00798_INNOVATIVE_CENTRE_Tsuen_Wan_goingclass.jpg": 18909,
	"./ID00799_MapleTree-Creative_Writing_Course_MapleTree.jpg": 74325,
	"./ID00799_MapleTree-ESOL_Examination_MapleTree.jpg": 75608,
	"./ID00799_MapleTree1-2.jpg": 48064,
	"./ID00799_MapleTree_Education_Centre.jpg": 75883,
	"./ID00800_2_6bb5ff25-176f-4500-a87d-18c44058e2c8.jpg": 31185,
	"./ID00800_3_45f0d98b-147b-4af5-a57e-ed5bfbb15a43.jpg": 60484,
	"./ID00800_4_d9d63882-74bd-4522-89be-6fc9d49608a5.jpg": 62984,
	"./ID00800_Sky_for_excellence_tsuen_wan.jpg": 1837,
	"./ID00801_1_a9e7ae9c-f5dd-4a23-97b5-6a07b05f5d12.jpg": 35052,
	"./ID00801_2_8d85f0a2-3662-4361-9ef4-8431a7d76b7f.jpg": 39567,
	"./ID00801_2_dc276a13-5420-406d-a87f-6091072edbc0.jpg": 47103,
	"./ID00801_3_2fbdbc3a-932b-4c3f-81eb-ce4b3cf80d4a.jpg": 32027,
	"./ID00801_3_59176e4d-e142-409f-8137-f26e40c8c6b3.jpg": 91506,
	"./ID00801_4_26772903-fe53-402c-9b5f-f7987c540a83.jpg": 68805,
	"./ID00801_Perfect_Art_Studio_tsuen_wan.jpg": 86980,
	"./ID00802_2_46fdaa35-0609-4493-afcf-b70755d1def5.jpg": 79015,
	"./ID00802_3_36d1eaad-b5ee-4ef2-91dc-7e6e9ac844c6.jpg": 98631,
	"./ID00802_4_10c37421-69e5-4482-b9ff-65b8c2e1629a.jpg": 81514,
	"./ID00802_Honey_Bee_tsuen_wan.jpg": 55661,
	"./ID00803_2_d299b0a6-d5a6-4cea-a3b6-0bd9aae78d44.jpg": 19857,
	"./ID00803_3_3c42e044-401e-4ef6-b798-1cbf0b018cf7.jpg": 47842,
	"./ID00803_4_9a0c4fe2-1c4c-4598-aac3-031744d8db96.jpg": 28945,
	"./ID00803_Mickey_Art_Studio_Tsuen_Wan.jpg": 80461,
	"./ID00804_2_65532358-9bc3-45d6-914c-addeaf00fbed.jpg": 32495,
	"./ID00804_3_9c2c2005-0cac-4365-ab82-606b9a11bda4.jpg": 15865,
	"./ID00804_4_b3bbacfc-55c2-4c7e-80ea-00452b164c69.jpg": 36183,
	"./ID00804_M-learning_tsuen_wan.jpg": 96177,
	"./ID00805_2_a0c6dd6f-42ab-402d-9c9f-7e755ce61724.jpg": 78431,
	"./ID00805_tsuen_wan_tai_wo_hau.jpg": 93072,
	"./ID00806_2_8308d9f1-eb2b-47bf-8509-cf3064bcab25.jpg": 30951,
	"./ID00806_3_1e032bb4-6e07-4a56-ae8d-0db51e5333ca.jpg": 29084,
	"./ID00806_4_b0163573-dcca-4a51-a808-60ec7ccc5352.jpg": 51874,
	"./ID00806_STAR_Education_tsuen_wan.jpg": 78052,
	"./ID00807_2_ce819d1d-b7cd-408b-8b60-856d72654ce6.jpg": 8632,
	"./ID00807_3_28418ed2-2f53-4c78-b797-107313f5bdc7.jpg": 84698,
	"./ID00807_4_d4c8e0c5-291d-4940-9566-755179f7e678.jpg": 82462,
	"./ID00807_INest_Art_Center_tsuen_wan.jpg": 32123,
	"./ID00808_VIOBRATO_tsuen_wan.jpg": 49809,
	"./ID00809_2_f4c29156-f776-4e32-a574-1388d9990ad3.jpg": 33070,
	"./ID00809_3_d54909a3-13e9-460a-8978-709ba1c30c6b.jpg": 43239,
	"./ID00809_4_7b0c4910-9050-46d7-b280-f2868662ecd0.jpg": 68001,
	"./ID00809_Quest_Education_tsuen_wan.jpg": 49099,
	"./ID00810_2_5d17efbc-675a-4d1e-98f2-479fb136ca84.jpg": 94625,
	"./ID00810_318_Education_tsuen_wan.jpg": 76503,
	"./ID00810_3_87a1f70c-9459-444e-a51c-adcdb1ad1600.jpg": 92569,
	"./ID00810_4_d1d383b1-08f9-402a-9d6c-d2882d7f40a8.jpg": 42282,
	"./ID00811_2_fcb6380e-6166-406a-af24-75fb05d761b9.jpg": 79901,
	"./ID00811_Luminous_Music_tsuen_wan.jpg": 28829,
	"./ID00812_2_d45d5a07-3d47-488a-9e61-417d18301774.jpg": 56281,
	"./ID00812_I_Maths_Tutorial_Centre_tsuen_wan.jpg": 60462,
	"./ID00813_kids_yoga.jpg": 80430,
	"./ID00814_2_3f5a4fab-ce2a-44fa-a418-a8290079b440.jpg": 72404,
	"./ID00814_3_498a89fc-0f88-4ea0-8e73-32f6c3284269.jpg": 68166,
	"./ID00814_LING_FUNG_MUSIC_ROOM_Sham_Tseng.jpg": 31044,
	"./ID00815_2_a7705c75-2b38-4f9a-89fb-f2897bfae423.jpg": 5151,
	"./ID00815_3_946c3a08-286e-46ad-9df0-78da29fafad0.jpg": 15270,
	"./ID00815_Ssang_Yong_Kwan_Korean_Taekwondo_Tsuen_Wan.jpg": 50425,
	"./ID00816_1_f60ff466-f43c-426b-94a7-878572638fa5.jpg": 31130,
	"./ID00816_2_1a35c17f-d3fa-4085-8eca-f746213ff8bf.jpg": 38490,
	"./ID00816_3_5c236bb1-b37c-4e4d-8073-5fc4d53b0439.jpg": 39569,
	"./ID00816_4_7fda68d2-e7a7-4096-96c4-40c07acb29b7.jpg": 16557,
	"./ID00816_Tsuen_Wan.jpg": 77707,
	"./ID00817_2_0d062259-c3d7-433a-a573-a4e40fca6567.jpg": 36267,
	"./ID00817_3_d255a2a1-072e-4502-9454-34aa454e20f1.jpg": 63046,
	"./ID00817_4_48a13594-bb7c-4c49-87bc-af236c91ace9.jpg": 9939,
	"./ID00817_LaserPlay_Sha_Tin.jpg": 54600,
	"./ID00818_2_58de1143-6290-435d-8a82-ba1045eb6549.jpg": 28263,
	"./ID00818_3_0121d204-de97-4c2d-8f9e-3c41ec1b9e36.jpg": 43252,
	"./ID00818_4_7871d402-401a-4e7f-a8ed-8a249f5a4e22.jpg": 67630,
	"./ID00818_Enlightening_Education_Tsuen_Wan.jpg": 78877,
	"./ID00819_Lead_English_WhatsApp_Image_2025-06-11_at_6.55.15_PM.jpg": 20261,
	"./ID00819_Lead_English_WhatsApp_Image_2025-06-11_at_6.55.16_PM.jpg": 38664,
	"./ID00819_Lead_English_WhatsApp_Image_2025-06-11_at_6.55.16_PM_1.jpg": 57016,
	"./ID00819_Lead_English_WhatsApp_Image_2025-06-11_at_6.55.16_PM_2.jpg": 94471,
	"./ID00819_Lead_English_WhatsApp_Image_2025-06-17_at_5.43.16_PM_4x3_b517d92f-c9c8-42ba-930f-8e387604eb21.jpg": 18850,
	"./ID00819_Lead_English_WhatsApp_Image_2025-06-17_at_5.43.17_PM_1__4x3_1201f53c-6857-4aa5-a5b2-8e54286c01bb.jpg": 78091,
	"./ID00819_Lead_English_WhatsApp_Image_2025-06-17_at_5.43.17_PM_4x3_810ad9fc-4889-4af2-a808-e04b3d8c0004.jpg": 92,
	"./ID00819_Lead_English_WhatsApp_Image_2025-06-17_at_5.43.18_PM_4x3_89008463-ecd8-4746-9a0c-b2d9fca12090.jpg": 42334,
	"./ID00820_2_531e7bd8-bf60-403d-8fff-eae5f987769f.jpg": 87171,
	"./ID00820_3_5b2cce1d-6183-40b8-9553-a48b6fd41dbe.jpg": 86076,
	"./ID00820_4_2aef637e-790d-448e-bfb8-9e1ee3e03116.jpg": 87689,
	"./ID00820_Read_Write_by_Indigo_Kids_Tsuen_Wan_Tseung_Kwan_O.jpg": 90417,
	"./ID00821_2_0afe60af-d4c4-4f7a-8c03-38f88be24bfd.jpg": 2806,
	"./ID00821_3_2b2b2bd7-82bf-4daf-b713-0e9369fea510.jpg": 12098,
	"./ID00821_4_98e71fc9-4524-4f38-b244-5013920d0a5a.jpg": 65694,
	"./ID00821_Creative_Minds_Mei_Foo.jpg": 5073,
	"./ID00822_2_0b1fe445-0427-49bd-a2a7-d0d7e69af7be.jpg": 16243,
	"./ID00822_3_1827dc71-4e6e-4ee9-99bc-11c5abbee272.jpg": 61131,
	"./ID00822_4_b2eded1d-110d-417c-a07a-0d35004ef675.jpg": 29883,
	"./ID00822_JS_Blessing_Workshop_Music_Mei_Foo.jpg": 61884,
	"./ID00823_1.jpg": 53956,
	"./ID00823_L._W._T_Dancing_College_tsuen_wan.jpg": 46462,
	"./ID00824_Maestro_Education.jpg": 46666,
	"./ID00824_Maestro_Education_tsuen_wan.jpg": 68029,
	"./ID00825_1_ca795f9b-ad9b-4901-a0d4-33e332c609ce.jpg": 83463,
	"./ID00825_2_5441b1a0-524d-4b74-a1ae-9c11816d4058.jpg": 32058,
	"./ID00825_2_9132f07b-8b8e-4f8a-8517-f692c2f196ad.jpg": 1968,
	"./ID00825_Virtue_Kids_Education_Mei_Foo.jpg": 35022,
	"./ID00826_2_66734379-07c2-4d72-ae47-d7707012b2a2.jpg": 89749,
	"./ID00826_3_cfbef3d3-f2ff-47e3-9154-a19f719acb74.jpg": 74246,
	"./ID00826_4_cb49d4bf-b247-4630-bc20-85e9fa1742d3.jpg": 61665,
	"./ID00826_English_Course_Tsuen_Wan.jpg": 40833,
	"./ID00827_2_9920f5b1-e8ea-419b-8cbc-225965f2b89b.jpg": 16955,
	"./ID00827_3_24f0a47d-7341-4458-b4bd-e0732865cdcc.jpg": 75211,
	"./ID00827_5_d6653487-0e6d-4dba-b085-1c7592cfe037.jpg": 21106,
	"./ID00827_A1_Tsuen_Wan_Shau_Kei_Wan.jpg": 61221,
	"./ID00828_2_4a893997-b837-4620-80cf-b647b6486242.jpg": 97897,
	"./ID00828_Champion_Goal_Music_Centre_lai_chi_kok.jpg": 3941,
	"./ID00829_2_e0876af2-f2af-41bb-9d33-910343ab44f6.jpg": 15159,
	"./ID00829_DILIGENT_LEARNERS_EDUCATION_CENTRE_tsuen_wan.jpg": 14518,
	"./ID00830_2_0702a066-a37f-4c42-bb50-34c197c42133.jpg": 21642,
	"./ID00830_3_137bc6dc-1cc3-4cce-9435-c72bf09e3753.jpg": 22184,
	"./ID00830_4_0e358c35-dcc6-499a-ac84-1d5f808ed554.jpg": 59129,
	"./ID00830_Yandarin_tsuen_wan_prince_edward_tseung_kwan_O.jpg": 87823,
	"./ID00831_6.jpg": 44074,
	"./ID00831_7.jpg": 99911,
	"./ID00831_8.jpg": 852,
	"./ID00831_Little_Masterpiece_Education_Center_Lai_Chi_Kok.jpg": 1722,
	"./ID00832_2_f5f92c45-0062-40ae-8646-3074c2bfffd6.jpg": 24025,
	"./ID00832_3_b0168885-d6b5-4b6f-91c5-38c0ffbcfcc0.jpg": 40981,
	"./ID00832_4_7ab3d315-c700-49a1-80c0-6fbadfdeb2cd.jpg": 98687,
	"./ID00832_ETUDE_MUSIC_EDUCATION_CENTRE_Tsuen_Wan.jpg": 93732,
	"./ID00833_2_da6c8d9c-3e9c-4d2e-8b49-c2ac07f7c590.jpg": 5441,
	"./ID00833_3_0facc0fa-fc54-491b-a8c3-0e77806b68f4.jpg": 33436,
	"./ID00833_4_cf34a392-c174-4113-892d-d7d52dd6d795.jpg": 55292,
	"./ID00833_Star_Club_Scientist_Education_Tsuen_WAn.jpg": 82710,
	"./ID00834_2_b84105d0-ec38-4530-b47d-b58410e9ba31.jpg": 76997,
	"./ID00834_3_b2d06286-17e6-442a-b887-99f9dd77ad4c.jpg": 10505,
	"./ID00834_4_d7086039-e86f-4a61-9bc8-bd6a33195758.jpg": 36022,
	"./ID00834_MarcSway_Music_Academy.jpg": 83789,
	"./ID00835_2_67ce6222-2bbd-4833-9cf7-812c0f0c4f8c.jpg": 47781,
	"./ID00835_3_edbc1c41-3017-4e5d-afd9-a33afdff0e3b.jpg": 99474,
	"./ID00835_Cleverest_Education_Centre.jpg": 6200,
	"./ID00836_1_c477cba9-7d59-4f5c-afd9-0c28270b2b7a.jpg": 27664,
	"./ID00836_2_e5ecc8e6-2fa3-4b56-901c-15aa49a3d681.jpg": 8384,
	"./ID00837_1_d346c9b4-2252-4178-a809-a7653ee99d05.jpg": 40457,
	"./ID00837_2_03a11313-d9d1-4b93-88c7-19097b2bdb24.jpg": 58524,
	"./ID00837_3_03f340a4-498b-4828-a6b0-314fa407218d.jpg": 18500,
	"./ID00837_Baby_Garden_Centre.jpg": 18522,
	"./ID00838_1_9238d206-d3cf-4694-97a6-5f0ca6e6ddf1.jpg": 99830,
	"./ID00838_2_1479d487-636a-4442-af58-2d4351a7b919.jpg": 34424,
	"./ID00838_3_26fa4976-7f56-4e18-b9cb-6d34b00ddf03.jpg": 57946,
	"./ID00838_4_1758a48f-18ae-4b83-b9eb-e17727f01a86.jpg": 7123,
	"./ID00839_2_80ba5e1d-1a43-4c31-9b36-c08f646d4a9a.jpg": 10919,
	"./ID00839_3_a37e82f7-3304-407b-828c-61ffe1e9f042.jpg": 7742,
	"./ID00839_4_8705648d-97a4-4ac3-a936-bb2262f4835d.jpg": 17402,
	"./ID00839_School_of_Creativity.jpg": 29843,
	"./ID00840_2_378bdefb-bf34-458d-9952-2ebc51d1fa01.jpg": 77306,
	"./ID00840_3_95467c41-3e9f-40e4-824f-bb70f30616fe.jpg": 871,
	"./ID00840_4_310b8344-36e2-4d56-90ca-3e6dbe6072ea.jpg": 17696,
	"./ID00840_Prince_Princesses_Studio.jpg": 43390,
	"./ID00841_1_4c745b3a-5c54-4a4a-8dd5-4978d64faecd.jpg": 58019,
	"./ID00841_2_819ec589-fc9d-410e-9b55-73a470acf119.jpg": 48624,
	"./ID00841_3_9c92ca4f-75fd-4d81-8452-6cf719bbe2aa.jpg": 36773,
	"./ID00842_1_64162a1e-65a8-407a-b8c6-e366820fc6f1.jpg": 21033,
	"./ID00842_2_acb513cc-406e-4cfe-b2b0-e2f7604cc8bd.jpg": 56874,
	"./ID00842_3_5341d10c-46b5-4621-a93f-2cabc4fbaa69.jpg": 76408,
	"./ID00842_4_c74526e8-06ac-4b32-a59c-60f030a41656.jpg": 18196,
	"./ID00843_2_304e6e35-26a7-45d6-baae-3f2be3af2439.jpg": 58333,
	"./ID00843_3_e364d1e6-f257-4840-96df-57e20105e055.jpg": 89606,
	"./ID00843_4_9e5514a3-abe7-4ad3-83b2-a219edf816b2.jpg": 900,
	"./ID00843_PHD_Classrooms.jpg": 76204,
	"./ID00844_1_2034794e-d2db-4ff3-866b-25f23631dd54.jpg": 24170,
	"./ID00844_2_829f5ccf-bc84-4505-a571-6cfc7be0a22b.jpg": 76059,
	"./ID00844_3_241705ba-734f-47f0-9b38-63108da3b9c3.jpg": 91990,
	"./ID00845_2_01e6b1a6-4b03-4fce-9914-349669ca7d3e.jpg": 31930,
	"./ID00845_3_01320948-9df3-489a-9439-ad78335d069a.jpg": 86206,
	"./ID00845_4_f018e681-f5e2-4cde-a211-4a6c0cba7d9a.jpg": 41353,
	"./ID00845_Leo_Music.jpg": 8973,
	"./ID00846_2_7c27080a-6fcc-4a9e-b657-a3714f24c3b7.jpg": 48881,
	"./ID00846_3_82bac024-3d6a-49e4-bdea-565fc6db4e64.jpg": 94198,
	"./ID00846_4_5e40fd01-61cf-4d86-a0d6-d7beabf24b5c.jpg": 7988,
	"./ID00846_Step_Ahead_Educational_Centre.jpg": 13564,
	"./ID00846_Step_Ahead_Educational_Centre_1_4x3_7932e168-62ea-404a-9455-cd46cc94b826.jpg": 5944,
	"./ID00846_Step_Ahead_Educational_Centre_2_4x3_6643abda-f9f8-459e-8fb6-046fe749e92d.jpg": 92814,
	"./ID00847_2_714b495c-3359-436b-ac91-d7547cc98290.jpg": 86747,
	"./ID00847_3_4bead64f-3db8-4809-a095-7b681211f16c.jpg": 38246,
	"./ID00847_5.jpg": 16498,
	"./ID00847_Calibre_Education_Centre.jpg": 1293,
	"./ID00848_2_2dd61763-0afa-480b-88fb-45455d4efe95.jpg": 48937,
	"./ID00848_3_0c83c609-4af0-4983-ae25-04b2307e840c.jpg": 9136,
	"./ID00848_Aloha_Education_Centre.jpg": 18976,
	"./ID00848_aloha.jpg": 58875,
	"./ID00849_2_4ddcef6e-231b-41c6-83e6-93f473f0b47e.jpg": 91741,
	"./ID00849_3_0eacdc07-7e92-4392-9be9-3894bb72b252.jpg": 74166,
	"./ID00849_4_bdafa570-6252-4959-aff1-a5be49d10e08.jpg": 70048,
	"./ID00849_Start_With_ART_Studio.jpg": 87036,
	"./ID00850_DoDo_Art_Room_3_4x3_adec7d78-0b8e-486f-86a7-a5f241563fd0.jpg": 33017,
	"./ID00850_DoDo_Art_Room_DoDo_Art_Room_1_4x3_0180d769-557c-4e8c-86b8-431809a74dc6.jpg": 55584,
	"./ID00850_DoDo_Art_Room_DoDo_Art_Room_2_4x3_67b5bf02-577c-4df4-a47e-d45c96fab172.jpg": 65703,
	"./ID00850_DoDo_Art_Room_DoDo_Art_Room_4_4x3_aef8b299-efed-4fe4-95b9-a62553dab9d7.jpg": 52011,
	"./ID00851_2_ca2a1cf2-3d6d-491f-bb48-c1d209c21b08.jpg": 10570,
	"./ID00851_Art_Point_Creative.jpg": 36044,
	"./ID00851_page-0.jpg": 63074,
	"./ID00851_page-1.jpg": 83071,
	"./ID00852_new_doc_2024-11-06_13.40.41_1_4x3_0d580963-6539-47ec-97d4-b483613ddd43.jpg": 95293,
	"./ID00852_new_doc_2024-11-06_13.40.41_2_4x3_1cfe337c-063d-412c-9f8a-71fb358b8f78.jpg": 31086,
	"./ID00852_new_doc_2024-11-06_13.40.41_3_4x3_4a7111a8-94e5-4231-82bc-0b61f0df3057.jpg": 31290,
	"./ID00853_2_5dadd039-664d-4b97-a860-be91a0f00b14.jpg": 30895,
	"./ID00853_Art_Story.jpg": 94193,
	"./ID00853_Art_Story_1_4x3_a75dc440-b8e4-442f-9d69-2967b8225d30.jpg": 72235,
	"./ID00853_Art_Story_2_4x3_369f79e6-2d00-419a-9ad4-55277f0df912.jpg": 22567,
	"./ID00853_Art_Story_3_4x3_0e1bfa76-a844-40eb-bed5-5ec69e06173d.jpg": 80868,
	"./ID00853_Art_Story_4_4x3_05c6aa1c-6560-4822-b4fa-c08362bdfe4f.jpg": 88558,
	"./ID00853_Art_Story_5_4x3_aa49e2b2-8a3f-4404-b6e3-c6a3bae29bbb.jpg": 92260,
	"./ID00853_Art_Story_6_4x3_e6960c29-163b-4825-9f79-827d753922f9.jpg": 1323,
	"./ID00854_2_03a382d8-a2c6-4037-8a78-b1cec4871f31.jpg": 20019,
	"./ID00854_3_1631d7c0-0735-4270-a7cc-e7724078dcdc.jpg": 31576,
	"./ID00854_4_a5c0b4ca-1a33-42d5-aa22-a3e7419e6322.jpg": 84222,
	"./ID00854_SMART_ONE_Tutorial_School_1.jpg": 69173,
	"./ID00855_1_1d6e2d2c-d499-4ac2-b048-5c2807cc5a7d.jpg": 48397,
	"./ID00855_2_124e89dd-5a3c-4a60-9e3b-0d3e3bd86b4c.jpg": 59880,
	"./ID00855_3_3ad66d26-15bb-4c95-ae8a-096d04ebb691.jpg": 72060,
	"./ID00855_4_2b27abc6-8928-46a9-bd32-0887cbfba412.jpg": 57864,
	"./ID00856_1_860e60e1-aa65-4faf-bdcd-365cd3f0f65b.jpg": 71720,
	"./ID00856_2_50d52a80-1c63-4ad4-a74e-bc7b501cb7d7.jpg": 87739,
	"./ID00857_2.jpg": 90030,
	"./ID00857_3_b2053f71-37d9-40c5-b45e-3f8d45f55052.jpg": 34872,
	"./ID00857_Grace_Child_Development_and_Therapy_Centre.jpg": 49547,
	"./ID00858_Chancery_English_Chancery_English_1_4x3_f9eb4cb3-d21b-4bbd-a5b1-fab2833681a5.jpg": 13169,
	"./ID00858_P1_English_Bridging_Class_ChanceryEnglish1-4.jpg": 84285,
	"./ID00858_Phonics_Stories_ChanceryEnglish1-3.jpg": 9010,
	"./ID00858_Present_British_English_Chancery_English.jpg": 72422,
	"./ID00858_Reading-Comprehension-ChanceryEnglish.jpg": 12034,
	"./ID00859_RoadToCambridge1-2.jpg": 19039,
	"./ID00859_RoadToCambridge1-3.jpg": 10978,
	"./ID00859_RoadToCambridge1-4.jpg": 65585,
	"./ID00859_RoadToCambridge_RTC.jpg": 59727,
	"./ID00860_2_11a480ab-7f7e-4ec9-9b24-17183b056538.jpg": 52635,
	"./ID00860_Chill_Easy_Education.jpg": 89044,
	"./ID00860_Chill_Easy_Education_2_4x3_da837e1a-37e3-43b0-97a2-5a65c1544476.jpg": 45975,
	"./ID00860_Chill_Easy_Education_3_4x3_81f900bc-1f9e-4b73-a10a-f55b1c0ea881.jpg": 3687,
	"./ID00860_Chill_Easy_Education_Chill_Easy_Education_1_4x3_eb24afa6-6af2-4da8-bc64-af5fecb212fb.jpg": 85641,
	"./ID00861_NOTONLYAPATTERN_1_2803b969-e870-4622-aca4-d071df718dad.png": 90353,
	"./ID00861_hqdefault.jpg": 1748,
	"./ID00862_P1_Interview_Dunn_s_Education.jpg": 44536,
	"./ID00862_Speech_Training_Dunn_s_Education.jpg": 16624,
	"./ID00862_hqdefault_304a7727-11b6-49c0-a0d5-2c3480608dd6.jpg": 58518,
	"./ID00862_hqdefault_6443b82a-aff5-4f11-9545-d8467e6dd07c.jpg": 84588,
	"./ID00863_1_summer_AS_chloe.jpg": 6233,
	"./ID00863_AS_Chloe_School_of_Gymnastics_and_Dance.jpg": 90731,
	"./ID00863_Aschloe-Public-Performance.jpg": 68867,
	"./ID00863_Aschloe1-1.jpg": 78159,
	"./ID00863_Aschloe_School_of_Gymnastics_and_Dance.jpg": 23312,
	"./ID00864_EQ_SQ_ImPossible.jpg": 81895,
	"./ID00864_ImPossible1-1.jpg": 63820,
	"./ID00864_ImPossible1-2.jpg": 6619,
	"./ID00864_ImPossible1-3.jpg": 51838,
	"./ID00865_Cordate1-2_e8fae2e3-24be-4258-b5c4-8661fb4b4fa3.jpg": 52140,
	"./ID00865_Cordate_Education_Centre.jpg": 92176,
	"./ID00865_Cordate_Education_Centre_Playgroup.jpg": 31766,
	"./ID00865_Quality_Early_Childhood_Education_Programmes.jpg": 30638,
	"./ID00866_Art-Jaming.jpg": 52798,
	"./ID00866_rainbow-gallery.jpg": 78163,
	"./ID00867_BABY_CLAP-Little_Prince_Art.jpg": 67593,
	"./ID00867_Every_Child_is_an_Artist_-_Little_Prince_Art.jpg": 22743,
	"./ID00867_Little_Prince_Art_Promotion.jpg": 62273,
	"./ID00867_Visual_Art_CLAP_Little_Prince_Art.jpg": 54933,
	"./ID00868_1_18b8f0b6-1b81-44ed-b52d-070dee0de565.jpg": 35111,
	"./ID00868_1_aa580da4-d1b9-4860-ab46-a0fce0ecfa55.jpg": 5339,
	"./ID00868_2_6d04e38c-ac2f-4fd0-be2a-3b3fa77d10fc.jpg": 71513,
	"./ID00868_2_de3db0b2-1047-43dc-8f19-ca2926d1f6a5.jpg": 44071,
	"./ID00868_3_3fbf7735-6dd5-4d2d-9558-b48546c3b22c.jpg": 37493,
	"./ID00868_3_c76bff1b-fc87-4018-b078-bab7ca21447f.jpg": 11991,
	"./ID00868_4_3eb66251-11ab-4a33-ac8e-d7dc24d8fe76.jpg": 5286,
	"./ID00868_hklachinese.jpg": 40925,
	"./ID00869_3_b8d45e2b-522f-4e8a-80d5-852745e0f3ed.jpg": 96385,
	"./ID00869_IELTS.jpg": 61353,
	"./ID00869_Leung-s-Institute.jpg": 64390,
	"./ID00869_Leung_s_Institute.jpg": 21146,
	"./ID00869_Leung_s_Institute__Leung_s_Institute_1_4x3_4x3_88f969e3-37ab-4004-95dc-267063051c56.jpg": 28814,
	"./ID00869_Leung_s_Institute__Leung_s_Institute_2_4x3_b184dfd0-d113-4729-9d8a-956be5ae3c14.jpg": 50976,
	"./ID00869_Leung_s_Institute__Leung_s_Institute_3_4x3_9db6f2fc-6632-4686-8f23-f25893cfa3b4.jpg": 99956,
	"./ID00869_Leung_s_Institute__Leung_s_Institute_4_4x3_48fcd414-fc58-4939-b017-1ae233bae421.jpg": 83292,
	"./ID00870_K-Korea_Taekwondo_1.jpg": 18018,
	"./ID00870_K-Korea_Taekwondo_2.jpg": 30925,
	"./ID00871_1_e5eaa980-9421-4dec-b764-4d9ae0aa9117.jpg": 39219,
	"./ID00872_1_64b44ffe-de2a-4797-af7e-1c11e1286b3e.jpg": 86546,
	"./ID00872_2_dce6745f-4a50-4c8a-93c6-f4b5f6a6bb5a.jpg": 98391,
	"./ID00872_3_98fb1af9-37e2-4043-8c4d-65a50746e227.jpg": 36884,
	"./ID00872_4_62a6cc33-0ef5-423e-985f-615251ba6a13.jpg": 18479,
	"./ID00873_1_simply_english.jpg": 49783,
	"./ID00873_2_simply_english.jpg": 1978,
	"./ID00873_3_simply_english.jpg": 69129,
	"./ID00873_4_simply_english.jpg": 30156,
	"./ID00874_1_rex_music.jpg": 64872,
	"./ID00874_2_524deda9-fb5d-4759-9a50-08ffce03d5ab.jpg": 12156,
	"./ID00874_Rex-Music.jpg": 26230,
	"./ID00874_Rex_Music.jpg": 95008,
	"./ID00874_Rex_music__Rex_music__1_4x3_cd85a90d-27ab-431d-a9c7-e3ca6e1d3389.jpg": 20972,
	"./ID00874_Rex_music__Rex_music__2_4x3_805dd165-5182-4870-bd8f-e0ad6cda2d7e.jpg": 68538,
	"./ID00875_Mathvolution_WhatsApp_Image_2025-06-03_at_2.59.22_PM.jpg": 69155,
	"./ID00875_Mathvolution_WhatsApp_Image_2025-06-03_at_2.59.23_PM.jpg": 34496,
	"./ID00875_Mathvolution_WhatsApp_Image_2025-06-03_at_2.59.23_PM_1.jpg": 77184,
	"./ID00875_Mathvolution_WhatsApp_Image_2025-06-03_at_2.59.23_PM_2.jpg": 74447,
	"./ID00876_Bright_English_Education_Centre_Tsuen_Wan_West.jpg": 27224,
	"./ID00876_Bright_English_Education_Centre_Tsuen_Wan_West_1.jpg": 19067,
	"./ID00876_shopfront1.jpg": 33669,
	"./ID00876_shopfront2.jpg": 11066,
	"./ID00876_shopfront_with_crowd.jpg": 6745,
	"./ID00876_testimonial.jpg": 55118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75784;